/* eslint-disable max-lines */
// 不支持时区配置列表
export const notSupportTimeZone = [
    // UTC-08:00 (美国/新太平洋)、UTC-08:00 (US/Pacific-New)
    'US/Pacific-New',
];
export const timeZones = {
    zh: [
        {
            value: 'Etc/GMT+12',
            label: 'UTC-12:00 (Etc/GMT+12)',
        },
        {
            value: 'Etc/GMT+11',
            label: 'UTC-11:00 (Etc/GMT+11)',
        },
        {
            value: 'Pacific/Midway',
            label: 'UTC-11:00 (太平洋/中途岛)',
        },
        {
            value: 'Pacific/Niue',
            label: 'UTC-11:00 (太平洋/纽埃)',
        },
        {
            value: 'Pacific/Pago_Pago',
            label: 'UTC-11:00 (太平洋/帕果帕果)',
        },
        {
            value: 'Pacific/Samoa',
            label: 'UTC-11:00 (太平洋/萨摩亚)',
        },
        {
            value: 'US/Samoa',
            label: 'UTC-11:00 (美国/萨摩亚)',
        },
        {
            value: 'America/Adak',
            label: 'UTC-10:00 (美洲/埃达克)',
        },
        {
            value: 'America/Atka',
            label: 'UTC-10:00 (美洲/阿特卡)',
        },
        {
            value: 'Etc/GMT+10',
            label: 'UTC-10:00 (Etc/GMT+10)',
        },
        {
            value: 'HST',
            label: 'UTC-10:00 (夏威夷-阿留申标准时区)',
        },
        {
            value: 'Pacific/Honolulu',
            label: 'UTC-10:00 (太平洋/檀香山)',
        },
        {
            value: 'Pacific/Johnston',
            label: 'UTC-10:00 (太平洋/约翰斯顿)',
        },
        {
            value: 'Pacific/Rarotonga',
            label: 'UTC-10:00 (太平洋/拉罗汤加)',
        },
        {
            value: 'Pacific/Tahiti',
            label: 'UTC-10:00 (太平洋/大溪地)',
        },
        {
            value: 'US/Aleutian',
            label: 'UTC-10:00 (美国/阿留申群岛)',
        },
        {
            value: 'US/Hawaii',
            label: 'UTC-10:00 (美国/夏威夷)',
        },
        {
            value: 'Pacific/Marquesas',
            label: 'UTC-09:30 (太平洋/马克萨斯)',
        },
        {
            value: 'America/Anchorage',
            label: 'UTC-09:00 (美洲/安克雷奇)',
        },
        {
            value: 'America/Juneau',
            label: 'UTC-09:00 (美洲/朱诺)',
        },
        {
            value: 'America/Nome',
            label: 'UTC-09:00 (美洲/诺姆)',
        },
        {
            value: 'America/Sitka',
            label: 'UTC-09:00 (美洲/锡特卡)',
        },
        {
            value: 'America/Yakutat',
            label: 'UTC-09:00 (美洲/亚库塔特)',
        },
        {
            value: 'Etc/GMT+9',
            label: 'UTC-09:00 (Etc/GMT+9)',
        },
        {
            value: 'Pacific/Gambier',
            label: 'UTC-09:00 (太平洋/甘比尔)',
        },
        {
            value: 'US/Alaska',
            label: 'UTC-09:00 (美国/阿拉斯加)',
        },
        {
            value: 'America/Dawson',
            label: 'UTC-07:00 (美洲/道森)',
        },
        {
            value: 'America/Ensenada',
            label: 'UTC-08:00 (美洲/恩森那达)',
        },
        {
            value: 'America/Los_Angeles',
            label: 'UTC-08:00 (美洲/洛杉矶)',
        },
        {
            value: 'America/Metlakatla',
            label: 'UTC-09:00 (美洲/梅特拉卡特拉)',
        },
        {
            value: 'America/Santa_Isabel',
            label: 'UTC-08:00 (美洲/圣伊莎贝尔)',
        },
        {
            value: 'America/Tijuana',
            label: 'UTC-08:00 (美洲/蒂华纳)',
        },
        {
            value: 'America/Vancouver',
            label: 'UTC-08:00 (美洲/温哥华)',
        },
        {
            value: 'America/Whitehorse',
            label: 'UTC-07:00 (美洲/怀特霍尔斯)',
        },
        {
            value: 'Canada/Pacific',
            label: 'UTC-08:00 (加拿大/太平洋)',
        },
        {
            value: 'Canada/Yukon',
            label: 'UTC-07:00 (加拿大/育空)',
        },
        {
            value: 'Etc/GMT+8',
            label: 'UTC-08:00 (Etc/GMT+8)',
        },
        {
            value: 'Mexico/BajaNorte',
            label: 'UTC-08:00 (墨西哥/巴扎半岛)',
        },
        {
            value: 'PST8PDT',
            label: 'UTC-08:00 (太平洋时间 (美加))',
        },
        {
            value: 'Pacific/Pitcairn',
            label: 'UTC-08:00 (太平洋/皮特凯恩)',
        },
        {
            value: 'US/Pacific-New',
            label: 'UTC-08:00 (美国/新太平洋)',
        },
        {
            value: 'US/Pacific',
            label: 'UTC-08:00 (美国/太平洋)',
        },
        {
            value: 'America/Boise',
            label: 'UTC-07:00 (美洲/博伊西)',
        },
        {
            value: 'America/Cambridge_Bay',
            label: 'UTC-07:00 (美洲/剑桥湾)',
        },
        {
            value: 'America/Chihuahua',
            label: 'UTC-06:00 (美洲/奇瓦瓦)',
        },
        {
            value: 'America/Creston',
            label: 'UTC-07:00 (美洲/克雷斯顿)',
        },
        {
            value: 'America/Dawson_Creek',
            label: 'UTC-07:00 (美洲/道森克里克)',
        },
        {
            value: 'America/Denver',
            label: 'UTC-07:00 (美洲/丹佛)',
        },
        {
            value: 'America/Edmonton',
            label: 'UTC-07:00 (美洲/埃德蒙顿)',
        },
        {
            value: 'America/Fort_Nelson',
            label: 'UTC-07:00 (美洲/福特纳尔逊)',
        },
        {
            value: 'America/Hermosillo',
            label: 'UTC-07:00 (美洲/埃莫西约)',
        },
        {
            value: 'America/Inuvik',
            label: 'UTC-07:00 (美洲/伊努维克)',
        },
        {
            value: 'America/Mazatlan',
            label: 'UTC-07:00 (美洲/马萨特兰)',
        },
        {
            value: 'America/Ojinaga',
            label: 'UTC-06:00 (美洲/奥希纳加)',
        },
        {
            value: 'America/Phoenix',
            label: 'UTC-07:00 (美洲/凤凰城)',
        },
        {
            value: 'America/Shiprock',
            label: 'UTC-07:00 (美洲/希普罗克)',
        },
        {
            value: 'America/Yellowknife',
            label: 'UTC-07:00 (美洲/耶洛奈夫)',
        },
        {
            value: 'Canada/Mountain',
            label: 'UTC-07:00 (加拿大/山地)',
        },
        {
            value: 'Etc/GMT+7',
            label: 'UTC-07:00 (Etc/GMT+7)',
        },
        {
            value: 'MST7MDT',
            label: 'UTC-07:00 (山地标准时区 (美加))',
        },
        {
            value: 'MST',
            label: 'UTC-07:00 (山区标准时区)',
        },
        {
            value: 'Mexico/BajaSur',
            label: 'UTC-07:00 (墨西哥/南下加利福尼亚州)',
        },
        {
            value: 'Navajo',
            label: 'UTC-07:00 (纳瓦霍)',
        },
        {
            value: 'US/Arizona',
            label: 'UTC-07:00 (美国/亚利桑那)',
        },
        {
            value: 'US/Mountain',
            label: 'UTC-07:00 (美国/山地)',
        },
        {
            value: 'America/Bahia_Banderas',
            label: 'UTC-06:00 (美洲/巴伊亚班德拉斯)',
        },
        {
            value: 'America/Belize',
            label: 'UTC-06:00 (美洲/伯利兹)',
        },
        {
            value: 'America/Chicago',
            label: 'UTC-06:00 (美洲/芝加哥)',
        },
        {
            value: 'America/Costa_Rica',
            label: 'UTC-06:00 (美洲/哥斯达黎加)',
        },
        {
            value: 'America/El_Salvador',
            label: 'UTC-06:00 (美洲/萨尔瓦多)',
        },
        {
            value: 'America/Guatemala',
            label: 'UTC-06:00 (美洲/危地马拉)',
        },
        {
            value: 'America/Indiana/Knox',
            label: 'UTC-06:00 (美洲/印第安纳州/诺克斯)',
        },
        {
            value: 'America/Indiana/Tell_City',
            label: 'UTC-06:00 (美洲/印第安纳州/特尔城)',
        },
        {
            value: 'America/Knox_IN',
            label: 'UTC-06:00 (美洲/诺克斯)',
        },
        {
            value: 'America/Managua',
            label: 'UTC-06:00 (美洲/马那瓜)',
        },
        {
            value: 'America/Matamoros',
            label: 'UTC-06:00 (美洲/马塔莫罗斯)',
        },
        {
            value: 'America/Menominee',
            label: 'UTC-06:00 (美洲/梅诺米尼)',
        },
        {
            value: 'America/Merida',
            label: 'UTC-06:00 (美洲/梅里达)',
        },
        {
            value: 'America/Mexico_City',
            label: 'UTC-06:00 (美洲/墨西哥城)',
        },
        {
            value: 'America/Monterrey',
            label: 'UTC-06:00 (美洲/蒙特雷)',
        },
        {
            value: 'America/North_Dakota/Beulah',
            label: 'UTC-06:00 (美洲/北达科他州/比尤拉)',
        },
        {
            value: 'America/North_Dakota/Center',
            label: 'UTC-06:00 (美洲/北达科他州/中心)',
        },
        {
            value: 'America/North_Dakota/New_Salem',
            label: 'UTC-06:00 (美洲/北达科他州/新塞勒姆)',
        },
        {
            value: 'America/Rainy_River',
            label: 'UTC-06:00 (美洲/雷尼里弗)',
        },
        {
            value: 'America/Rankin_Inlet',
            label: 'UTC-06:00 (美洲/兰金因莱特)',
        },
        {
            value: 'America/Regina',
            label: 'UTC-06:00 (美洲/里贾纳)',
        },
        {
            value: 'America/Resolute',
            label: 'UTC-06:00 (美洲/雷索卢特)',
        },
        {
            value: 'America/Swift_Current',
            label: 'UTC-06:00 (美洲/斯威夫特卡伦特)',
        },
        {
            value: 'America/Tegucigalpa',
            label: 'UTC-06:00 (美洲/特古西加尔巴)',
        },
        {
            value: 'America/Winnipeg',
            label: 'UTC-06:00 (美洲/温尼伯)',
        },
        {
            value: 'CST6CDT',
            label: 'UTC-06:00 (中部标准时区 (美加))',
        },
        {
            value: 'Canada/Central',
            label: 'UTC-06:00 (加拿大/中部)',
        },
        {
            value: 'Canada/Saskatchewan',
            label: 'UTC-06:00 (加拿大/萨斯喀彻温)',
        },
        {
            value: 'Etc/GMT+6',
            label: 'UTC-06:00 (Etc/GMT+6)',
        },
        {
            value: 'Mexico/General',
            label: 'UTC-06:00 (墨西哥/通用)',
        },
        {
            value: 'Pacific/Galapagos',
            label: 'UTC-06:00 (太平洋/加拉帕戈斯)',
        },
        {
            value: 'US/Central',
            label: 'UTC-06:00 (美国/中部)',
        },
        {
            value: 'US/Indiana-Starke',
            label: 'UTC-06:00 (美国/印第安纳州-斯塔克)',
        },
        {
            value: 'America/Atikokan',
            label: 'UTC-05:00 (美洲/阿蒂科肯)',
        },
        {
            value: 'America/Bogota',
            label: 'UTC-05:00 (美洲/波哥大)',
        },
        {
            value: 'America/Cancun',
            label: 'UTC-05:00 (美洲/坎昆)',
        },
        {
            value: 'America/Cayman',
            label: 'UTC-05:00 (美洲/开曼)',
        },
        {
            value: 'America/Coral_Harbour',
            label: 'UTC-05:00 (美洲/珊瑚港)',
        },
        {
            value: 'America/Detroit',
            label: 'UTC-05:00 (美洲/底特律)',
        },
        {
            value: 'America/Eirunepe',
            label: 'UTC-05:00 (美洲/艾鲁内佩)',
        },
        {
            value: 'America/Fort_Wayne',
            label: 'UTC-05:00 (美洲/韦恩堡)',
        },
        {
            value: 'America/Guayaquil',
            label: 'UTC-05:00 (美洲/瓜亚基尔)',
        },
        {
            value: 'America/Havana',
            label: 'UTC-05:00 (美洲/哈瓦那)',
        },
        {
            value: 'America/Indiana/Indianapolis',
            label: 'UTC-05:00 (美洲/印第安纳州/印第安纳波利斯)',
        },
        {
            value: 'America/Indiana/Marengo',
            label: 'UTC-05:00 (美洲/印第安纳州/马伦戈)',
        },
        {
            value: 'America/Indiana/Petersburg',
            label: 'UTC-05:00 (美洲/印第安纳州/彼得斯堡)',
        },
        {
            value: 'America/Indiana/Vevay',
            label: 'UTC-05:00 (美洲/印第安纳州/韦韦)',
        },
        {
            value: 'America/Indiana/Vincennes',
            label: 'UTC-05:00 (美洲/印第安纳州/文森斯)',
        },
        {
            value: 'America/Indiana/Winamac',
            label: 'UTC-05:00 (美洲/印第安纳州/威纳马克)',
        },
        {
            value: 'America/Indianapolis',
            label: 'UTC-05:00 (美洲/印第安纳波利斯)',
        },
        {
            value: 'America/Iqaluit',
            label: 'UTC-05:00 (美洲/伊卡瑞特)',
        },
        {
            value: 'America/Jamaica',
            label: 'UTC-05:00 (美洲/牙买加)',
        },
        {
            value: 'America/Kentucky/Louisville',
            label: 'UTC-05:00 (美洲/肯塔基州/路易斯维尔)',
        },
        {
            value: 'America/Kentucky/Monticello',
            label: 'UTC-05:00 (美洲/肯塔基州/蒙蒂塞洛)',
        },
        {
            value: 'America/Lima',
            label: 'UTC-05:00 (美洲/利马)',
        },
        {
            value: 'America/Louisville',
            label: 'UTC-05:00 (美洲/路易斯维尔)',
        },
        {
            value: 'America/Montreal',
            label: 'UTC-05:00 (美洲/蒙特利尔)',
        },
        {
            value: 'America/Nassau',
            label: 'UTC-05:00 (美洲/拿骚)',
        },
        {
            value: 'America/New_York',
            label: 'UTC-05:00 (美洲/纽约)',
        },
        {
            value: 'America/Nipigon',
            label: 'UTC-05:00 (美洲/尼皮贡)',
        },
        {
            value: 'America/Panama',
            label: 'UTC-05:00 (美洲/巴拿马)',
        },
        {
            value: 'America/Pangnirtung',
            label: 'UTC-05:00 (美洲/庞纳唐)',
        },
        {
            value: 'America/Port-au-Prince',
            label: 'UTC-05:00 (美洲/太子港)',
        },
        {
            value: 'America/Porto_Acre',
            label: 'UTC-05:00 (美洲/阿克里港)',
        },
        {
            value: 'America/Rio_Branco',
            label: 'UTC-05:00 (美洲/里奥布朗库)',
        },
        {
            value: 'America/Thunder_Bay',
            label: 'UTC-05:00 (美洲/桑德湾)',
        },
        {
            value: 'America/Toronto',
            label: 'UTC-05:00 (美洲/多伦多)',
        },
        {
            value: 'Brazil/Acre',
            label: 'UTC-05:00 (巴西/阿克雷)',
        },
        {
            value: 'Canada/Eastern',
            label: 'UTC-05:00 (加拿大/东部)',
        },
        {
            value: 'Chile/EasterIsland',
            label: 'UTC-06:00 (智利/复活岛)',
        },
        {
            value: 'Cuba',
            label: 'UTC-05:00 (古巴)',
        },
        {
            value: 'EST5EDT',
            label: 'UTC-05:00 (东部标准时区 (美加))',
        },
        {
            value: 'EST',
            label: 'UTC-05:00 (东部标准时区)',
        },
        {
            value: 'Etc/GMT+5',
            label: 'UTC-05:00 (Etc/GMT+5)',
        },
        {
            value: 'Jamaica',
            label: 'UTC-05:00 (牙买加)',
        },
        {
            value: 'Pacific/Easter',
            label: 'UTC-06:00 (太平洋/复活节岛)',
        },
        {
            value: 'US/East-Indiana',
            label: 'UTC-05:00 (美国/东印第安那)',
        },
        {
            value: 'US/Eastern',
            label: 'UTC-05:00 (美国/东部)',
        },
        {
            value: 'US/Michigan',
            label: 'UTC-05:00 (美国/密歇根)',
        },
        {
            value: 'America/Caracas',
            label: 'UTC-04:00 (美洲/加拉加斯)',
        },
        {
            value: 'America/Anguilla',
            label: 'UTC-04:00 (美洲/安圭拉岛)',
        },
        {
            value: 'America/Antigua',
            label: 'UTC-04:00 (美洲/安地卡及巴布达)',
        },
        {
            value: 'America/Aruba',
            label: 'UTC-04:00 (美洲/阿鲁巴)',
        },
        {
            value: 'America/Barbados',
            label: 'UTC-04:00 (美洲/巴巴多斯)',
        },
        {
            value: 'America/Blanc-Sablon',
            label: 'UTC-04:00 (美洲/布朗萨布隆)',
        },
        {
            value: 'America/Boa_Vista',
            label: 'UTC-04:00 (美洲/博阿维斯塔)',
        },
        {
            value: 'America/Curacao',
            label: 'UTC-04:00 (美洲/库拉索岛)',
        },
        {
            value: 'America/Dominica',
            label: 'UTC-04:00 (美洲/多米尼克)',
        },
        {
            value: 'America/Glace_Bay',
            label: 'UTC-04:00 (美洲/格莱斯贝)',
        },
        {
            value: 'America/Goose_Bay',
            label: 'UTC-04:00 (美洲/鹅湾)',
        },
        {
            value: 'America/Grand_Turk',
            label: 'UTC-05:00 (美洲/大特克)',
        },
        {
            value: 'America/Grenada',
            label: 'UTC-04:00 (美洲/格林纳达)',
        },
        {
            value: 'America/Guadeloupe',
            label: 'UTC-04:00 (美洲/瓜德罗普岛)',
        },
        {
            value: 'America/Guyana',
            label: 'UTC-04:00 (美洲/圭亚那)',
        },
        {
            value: 'America/Halifax',
            label: 'UTC-04:00 (美洲/哈利法克斯)',
        },
        {
            value: 'America/Kralendijk',
            label: 'UTC-04:00 (美洲/克拉伦代克)',
        },
        {
            value: 'America/La_Paz',
            label: 'UTC-04:00 (美洲/拉巴斯)',
        },
        {
            value: 'America/Lower_Princes',
            label: 'UTC-04:00 (美洲/下太子区)',
        },
        {
            value: 'America/Manaus',
            label: 'UTC-04:00 (美洲/马瑙斯)',
        },
        {
            value: 'America/Marigot',
            label: 'UTC-04:00 (美洲/马里戈特)',
        },
        {
            value: 'America/Martinique',
            label: 'UTC-04:00 (美洲/马提尼克岛)',
        },
        {
            value: 'America/Moncton',
            label: 'UTC-04:00 (美洲/蒙克顿)',
        },
        {
            value: 'America/Montserrat',
            label: 'UTC-04:00 (美洲/蒙特塞拉特岛)',
        },
        {
            value: 'America/Port_of_Spain',
            label: 'UTC-04:00 (美洲/西班牙港)',
        },
        {
            value: 'America/Porto_Velho',
            label: 'UTC-04:00 (美洲/波多韦柳)',
        },
        {
            value: 'America/Puerto_Rico',
            label: 'UTC-04:00 (美洲/波多黎各)',
        },
        {
            value: 'America/Santo_Domingo',
            label: 'UTC-04:00 (美洲/圣多明各)',
        },
        {
            value: 'America/St_Barthelemy',
            label: 'UTC-04:00 (美洲/圣巴托洛缪)',
        },
        {
            value: 'America/St_Kitts',
            label: 'UTC-04:00 (美洲/圣基茨)',
        },
        {
            value: 'America/St_Lucia',
            label: 'UTC-04:00 (美洲/圣露西亚)',
        },
        {
            value: 'America/St_Thomas',
            label: 'UTC-04:00 (美洲/圣托马斯)',
        },
        {
            value: 'America/St_Vincent',
            label: 'UTC-04:00 (美洲/圣文森特)',
        },
        {
            value: 'America/Thule',
            label: 'UTC-04:00 (美洲/图勒)',
        },
        {
            value: 'America/Cuiaba',
            label: 'UTC-04:00 (美洲/库亚巴)',
        },
        {
            value: 'America/Tortola',
            label: 'UTC-04:00 (美洲/托尔托拉岛)',
        },
        {
            value: 'America/Campo_Grande',
            label: 'UTC-04:00 (美洲/大坎普)',
        },
        {
            value: 'America/Virgin',
            label: 'UTC-04:00 (美洲/维尔京)',
        },
        {
            value: 'America/Asuncion',
            label: 'UTC-04:00 (美洲/亚松森)',
        },
        {
            value: 'Atlantic/Bermuda',
            label: 'UTC-04:00 (大西洋/百慕达)',
        },
        {
            value: 'Brazil/West',
            label: 'UTC-04:00 (巴西/西部)',
        },
        {
            value: 'Canada/Atlantic',
            label: 'UTC-04:00 (加拿大/大西洋)',
        },
        {
            value: 'Etc/GMT+4',
            label: 'UTC-04:00 (Etc/GMT+4)',
        },
        {
            value: 'America/St_Johns',
            label: 'UTC-03:30 (美洲/圣约翰斯)',
        },
        {
            value: 'Canada/Newfoundland',
            label: 'UTC-03:30 (加拿大/纽芬兰)',
        },
        {
            value: 'America/Araguaina',
            label: 'UTC-03:00 (美洲/阿拉瓜伊纳)',
        },
        {
            value: 'America/Argentina/Buenos_Aires',
            label: 'UTC-03:00 (美洲/阿根廷/布宜诺斯艾利斯)',
        },
        {
            value: 'America/Argentina/Catamarca',
            label: 'UTC-03:00 (美洲/阿根廷/卡塔马卡)',
        },
        {
            value: 'America/Argentina/ComodRivadavia',
            label: 'UTC-03:00 (美洲/阿根廷/里瓦达维亚)',
        },
        {
            value: 'America/Argentina/Cordoba',
            label: 'UTC-03:00 (美洲/阿根廷/科尔多瓦)',
        },
        {
            value: 'America/Argentina/Jujuy',
            label: 'UTC-03:00 (美洲/阿根廷/胡胡伊)',
        },
        {
            value: 'America/Argentina/La_Rioja',
            label: 'UTC-03:00 (美洲/阿根廷/拉里奥哈)',
        },
        {
            value: 'America/Argentina/Mendoza',
            label: 'UTC-03:00 (美洲/阿根廷/门多萨)',
        },
        {
            value: 'America/Argentina/Rio_Gallegos',
            label: 'UTC-03:00 (美洲/阿根廷/里奥加耶戈斯)',
        },
        {
            value: 'America/Argentina/Salta',
            label: 'UTC-03:00 (美洲/阿根廷/萨尔塔)',
        },
        {
            value: 'America/Argentina/San_Juan',
            label: 'UTC-03:00 (美洲/阿根廷/圣胡安)',
        },
        {
            value: 'America/Argentina/San_Luis',
            label: 'UTC-03:00 (美洲/阿根廷/圣路易斯)',
        },
        {
            value: 'America/Argentina/Tucuman',
            label: 'UTC-03:00 (美洲/阿根廷/图库曼)',
        },
        {
            value: 'America/Argentina/Ushuaia',
            label: 'UTC-03:00 (美洲/阿根廷/乌斯怀亚)',
        },
        {
            value: 'America/Bahia',
            label: 'UTC-03:00 (美洲/巴伊亚)',
        },
        {
            value: 'America/Belem',
            label: 'UTC-03:00 (美洲/贝伦)',
        },
        {
            value: 'America/Buenos_Aires',
            label: 'UTC-03:00 (美洲/布宜诺斯艾利斯)',
        },
        {
            value: 'America/Catamarca',
            label: 'UTC-03:00 (美洲/卡塔马卡)',
        },
        {
            value: 'America/Cayenne',
            label: 'UTC-03:00 (美洲/卡宴)',
        },
        {
            value: 'America/Cordoba',
            label: 'UTC-03:00 (美洲/科尔多瓦)',
        },
        {
            value: 'America/Fortaleza',
            label: 'UTC-03:00 (美洲/福塔莱萨)',
        },
        {
            value: 'America/Godthab',
            label: 'UTC-02:00 (美洲/哥特哈布)',
        },
        {
            value: 'America/Jujuy',
            label: 'UTC-03:00 (美洲/胡胡伊)',
        },
        {
            value: 'America/Maceio',
            label: 'UTC-03:00 (美洲/马塞约)',
        },
        {
            value: 'America/Mendoza',
            label: 'UTC-03:00 (美洲/门多萨)',
        },
        {
            value: 'America/Miquelon',
            label: 'UTC-03:00 (美洲/密克隆岛)',
        },
        {
            value: 'America/Paramaribo',
            label: 'UTC-03:00 (美洲/帕拉马里博)',
        },
        {
            value: 'America/Punta_Arenas',
            label: 'UTC-03:00 (美洲/蓬塔阿雷纳斯)',
        },
        {
            value: 'America/Recife',
            label: 'UTC-03:00 (美洲/累西腓)',
        },
        {
            value: 'America/Rosario',
            label: 'UTC-03:00 (美洲/罗萨里奥)',
        },
        {
            value: 'America/Santarem',
            label: 'UTC-03:00 (美洲/圣塔伦)',
        },
        {
            value: 'America/Santiago',
            label: 'UTC-04:00 (美洲/圣地亚哥)',
        },
        {
            value: 'America/Montevideo',
            label: 'UTC-03:00 (美洲/蒙得维的亚)',
        },
        {
            value: 'America/Sao_Paulo',
            label: 'UTC-03:00 (美洲/圣保罗)',
        },
        {
            value: 'Antarctica/Palmer',
            label: 'UTC-03:00 (南极洲/帕默)',
        },
        {
            value: 'Antarctica/Rothera',
            label: 'UTC-03:00 (南极洲/罗瑟拉)',
        },
        {
            value: 'Brazil/East',
            label: 'UTC-03:00 (巴西/东部)',
        },
        {
            value: 'Atlantic/Stanley',
            label: 'UTC-03:00 (大西洋/斯坦利)',
        },
        {
            value: 'Chile/Continental',
            label: 'UTC-04:00 (智利/智利大陆)',
        },
        {
            value: 'Etc/GMT+3',
            label: 'UTC-03:00 (Etc/GMT+3)',
        },
        {
            value: 'America/Noronha',
            label: 'UTC-02:00 (美洲/诺罗尼亚)',
        },
        {
            value: 'Atlantic/South_Georgia',
            label: 'UTC-02:00 (大西洋/南乔治亚)',
        },
        {
            value: 'Brazil/DeNoronha',
            label: 'UTC-02:00 (巴西/迪诺罗尼亚)',
        },
        {
            value: 'Etc/GMT+2',
            label: 'UTC-02:00 (Etc/GMT+2)',
        },
        {
            value: 'America/Scoresbysund',
            label: 'UTC-02:00 (美洲/斯科斯比松)',
        },
        {
            value: 'Atlantic/Azores',
            label: 'UTC-01:00 (大西洋/亚速尔群岛)',
        },
        {
            value: 'Atlantic/Cape_Verde',
            label: 'UTC-01:00 (大西洋/佛得角)',
        },
        {
            value: 'Etc/GMT+1',
            label: 'UTC-01:00 (Etc/GMT+1)',
        },
        {
            value: 'Africa/Abidjan',
            label: 'UTC+00:00 (非洲/阿比让)',
        },
        {
            value: 'Africa/Accra',
            label: 'UTC+00:00 (非洲/阿克拉)',
        },
        {
            value: 'Africa/Bamako',
            label: 'UTC+00:00 (非洲/巴马科)',
        },
        {
            value: 'Africa/Banjul',
            label: 'UTC+00:00 (非洲/班珠尔)',
        },
        {
            value: 'Africa/Bissau',
            label: 'UTC+00:00 (非洲/比绍)',
        },
        {
            value: 'Africa/Casablanca',
            label: 'UTC+00:00 (非洲/卡萨布兰卡)',
        },
        {
            value: 'Africa/Conakry',
            label: 'UTC+00:00 (非洲/科纳克里)',
        },
        {
            value: 'Africa/Dakar',
            label: 'UTC+00:00 (非洲/达喀尔)',
        },
        {
            value: 'Africa/Freetown',
            label: 'UTC+00:00 (非洲/弗里敦)',
        },
        {
            value: 'Africa/Lome',
            label: 'UTC+00:00 (非洲/洛美)',
        },
        {
            value: 'Africa/Monrovia',
            label: 'UTC+00:00 (非洲/蒙罗维亚)',
        },
        {
            value: 'Africa/Nouakchott',
            label: 'UTC+00:00 (非洲/努瓦克肖特)',
        },
        {
            value: 'Africa/Ouagadougou',
            label: 'UTC+00:00 (非洲/瓦加杜古)',
        },
        {
            value: 'Africa/Sao_Tome',
            label: 'UTC+00:00 (非洲/圣多美)',
        },
        {
            value: 'Africa/Timbuktu',
            label: 'UTC+00:00 (非洲/通布图)',
        },
        {
            value: 'America/Danmarkshavn',
            label: 'UTC+00:00 (美洲/丹马沙)',
        },
        {
            value: 'Antarctica/Troll',
            label: 'UTC+00:00 (南极洲/特罗尔站)',
        },
        {
            value: 'Atlantic/Canary',
            label: 'UTC+00:00 (大西洋/加那利)',
        },
        {
            value: 'Atlantic/Faeroe',
            label: 'UTC+00:00 (大西洋/法罗群岛 (Faeroe))',
        },
        {
            value: 'Atlantic/Faroe',
            label: 'UTC+00:00 (大西洋/法罗群岛 (Faroe))',
        },
        {
            value: 'Atlantic/Madeira',
            label: 'UTC+00:00 (大西洋/马德拉岛)',
        },
        {
            value: 'Atlantic/Reykjavik',
            label: 'UTC+00:00 (大西洋/雷克雅未克)',
        },
        {
            value: 'Atlantic/St_Helena',
            label: 'UTC+00:00 (大西洋/圣赫勒拿岛)',
        },
        {
            value: 'Eire',
            label: 'UTC+00:00 (爱尔兰)',
        },
        {
            value: 'Etc/GMT',
            label: 'UTC+00:00 (Etc/GMT)',
        },
        {
            value: 'Etc/GMT+0',
            label: 'UTC+00:00 (Etc/GMT+0)',
        },
        {
            value: 'Etc/GMT-0',
            label: 'UTC+00:00 (Etc/GMT-0)',
        },
        {
            value: 'Etc/GMT0',
            label: 'UTC+00:00 (Etc/GMT0)',
        },
        {
            value: 'Etc/Greenwich',
            label: 'UTC+00:00 (格林威治 (Etc))',
        },
        {
            value: 'Etc/UCT',
            label: 'UTC+00:00 (Etc/UCT)',
        },
        {
            value: 'Etc/UTC',
            label: 'UTC+00:00 (Etc/UTC)',
        },
        {
            value: 'Etc/Universal',
            label: 'UTC+00:00 (Etc/通用)',
        },
        {
            value: 'Etc/Zulu',
            label: 'UTC+00:00 (Etc/祖鲁)',
        },
        {
            value: 'Europe/Belfast',
            label: 'UTC+00:00 (欧洲/贝尔法斯特)',
        },
        {
            value: 'Europe/Dublin',
            label: 'UTC+00:00 (欧洲/都柏林)',
        },
        {
            value: 'Europe/Guernsey',
            label: 'UTC+00:00 (欧洲/根西岛)',
        },
        {
            value: 'Europe/Isle_of_Man',
            label: 'UTC+00:00 (欧洲/马恩岛)',
        },
        {
            value: 'Europe/Jersey',
            label: 'UTC+00:00 (欧洲/泽西)',
        },
        {
            value: 'Europe/Lisbon',
            label: 'UTC+00:00 (欧洲/里斯本)',
        },
        {
            value: 'Europe/London',
            label: 'UTC+00:00 (欧洲/伦敦)',
        },
        {
            value: 'GB-Eire',
            label: 'UTC+00:00 (英国-爱尔兰)',
        },
        {
            value: 'GB',
            label: 'UTC+00:00 (英国)',
        },
        {
            value: 'GMT+0',
            label: 'UTC+00:00 (GMT+0)',
        },
        {
            value: 'GMT-0',
            label: 'UTC+00:00 (GMT-0)',
        },
        {
            value: 'GMT0',
            label: 'UTC+00:00 (GMT0)',
        },
        {
            value: 'GMT',
            label: 'UTC+00:00 (GMT)',
        },
        {
            value: 'Greenwich',
            label: 'UTC+00:00 (格林威治)',
        },
        {
            value: 'Iceland',
            label: 'UTC+00:00 (冰岛)',
        },
        {
            value: 'Portugal',
            label: 'UTC+00:00 (葡萄牙)',
        },
        {
            value: 'UCT',
            label: 'UTC+00:00 (UCT)',
        },
        {
            value: 'UTC',
            label: 'UTC+00:00 (UTC)',
        },
        {
            value: 'Universal',
            label: 'UTC+00:00 (通用)',
        },
        {
            value: 'WET',
            label: 'UTC+00:00 (欧洲西部时区)',
        },
        {
            value: 'Zulu',
            label: 'UTC+00:00 (祖鲁)',
        },
        {
            value: 'Africa/Algiers',
            label: 'UTC+01:00 (非洲/阿尔及尔)',
        },
        {
            value: 'Africa/Bangui',
            label: 'UTC+01:00 (非洲/班吉)',
        },
        {
            value: 'Africa/Brazzaville',
            label: 'UTC+01:00 (非洲/布拉柴维尔)',
        },
        {
            value: 'Africa/Ceuta',
            label: 'UTC+01:00 (非洲/休达)',
        },
        {
            value: 'Africa/Douala',
            label: 'UTC+01:00 (非洲/杜阿拉)',
        },
        {
            value: 'Africa/Kinshasa',
            label: 'UTC+01:00 (非洲/金沙萨)',
        },
        {
            value: 'Africa/Lagos',
            label: 'UTC+01:00 (非洲/拉各斯)',
        },
        {
            value: 'Africa/Libreville',
            label: 'UTC+01:00 (非洲/利伯维尔)',
        },
        {
            value: 'Africa/Luanda',
            label: 'UTC+01:00 (非洲/罗安达)',
        },
        {
            value: 'Africa/Malabo',
            label: 'UTC+01:00 (非洲/马拉博)',
        },
        {
            value: 'Africa/Ndjamena',
            label: 'UTC+01:00 (非洲/恩贾梅纳)',
        },
        {
            value: 'Africa/Niamey',
            label: 'UTC+01:00 (非洲/尼亚美)',
        },
        {
            value: 'Africa/Porto-Novo',
            label: 'UTC+01:00 (非洲/波多诺伏)',
        },
        {
            value: 'Africa/Tunis',
            label: 'UTC+01:00 (非洲/突尼斯)',
        },
        {
            value: 'Africa/Windhoek',
            label: 'UTC+02:00 (非洲/温得和克)',
        },
        {
            value: 'Arctic/Longyearbyen',
            label: 'UTC+01:00 (北极/朗伊尔城)',
        },
        {
            value: 'Atlantic/Jan_Mayen',
            label: 'UTC+01:00 (大西洋/扬马延岛)',
        },
        {
            value: 'CET',
            label: 'UTC+01:00 (中欧时区)',
        },
        {
            value: 'Etc/GMT-1',
            label: 'UTC+01:00 (Etc/GMT-1)',
        },
        {
            value: 'Europe/Amsterdam',
            label: 'UTC+01:00 (欧洲/阿姆斯特丹)',
        },
        {
            value: 'Europe/Andorra',
            label: 'UTC+01:00 (欧洲/安道尔)',
        },
        {
            value: 'Europe/Belgrade',
            label: 'UTC+01:00 (欧洲/贝尔格莱德)',
        },
        {
            value: 'Europe/Berlin',
            label: 'UTC+01:00 (欧洲/柏林)',
        },
        {
            value: 'Europe/Bratislava',
            label: 'UTC+01:00 (欧洲/布拉迪斯拉发)',
        },
        {
            value: 'Europe/Brussels',
            label: 'UTC+01:00 (欧洲/布鲁塞尔)',
        },
        {
            value: 'Europe/Budapest',
            label: 'UTC+01:00 (欧洲/布达佩斯)',
        },
        {
            value: 'Europe/Busingen',
            label: 'UTC+01:00 (欧洲/布辛根)',
        },
        {
            value: 'Europe/Copenhagen',
            label: 'UTC+01:00 (欧洲/哥本哈根)',
        },
        {
            value: 'Europe/Gibraltar',
            label: 'UTC+01:00 (欧洲/直布罗陀)',
        },
        {
            value: 'Europe/Ljubljana',
            label: 'UTC+01:00 (欧洲/卢布尔雅那)',
        },
        {
            value: 'Europe/Luxembourg',
            label: 'UTC+01:00 (欧洲/卢森堡)',
        },
        {
            value: 'Europe/Madrid',
            label: 'UTC+01:00 (欧洲/马德里)',
        },
        {
            value: 'Europe/Malta',
            label: 'UTC+01:00 (欧洲/马耳他)',
        },
        {
            value: 'Europe/Monaco',
            label: 'UTC+01:00 (欧洲/摩纳哥)',
        },
        {
            value: 'Europe/Oslo',
            label: 'UTC+01:00 (欧洲/奥斯陆)',
        },
        {
            value: 'Europe/Paris',
            label: 'UTC+01:00 (欧洲/巴黎)',
        },
        {
            value: 'Europe/Podgorica',
            label: 'UTC+01:00 (欧洲/波德戈里察)',
        },
        {
            value: 'Europe/Prague',
            label: 'UTC+01:00 (欧洲/布拉格)',
        },
        {
            value: 'Europe/Rome',
            label: 'UTC+01:00 (欧洲/罗马)',
        },
        {
            value: 'Europe/San_Marino',
            label: 'UTC+01:00 (欧洲/圣马力诺)',
        },
        {
            value: 'Europe/Sarajevo',
            label: 'UTC+01:00 (欧洲/萨拉热窝)',
        },
        {
            value: 'Europe/Skopje',
            label: 'UTC+01:00 (欧洲/斯科普里)',
        },
        {
            value: 'Europe/Stockholm',
            label: 'UTC+01:00 (欧洲/斯德哥尔摩)',
        },
        {
            value: 'Europe/Tirane',
            label: 'UTC+01:00 (欧洲/地拉那)',
        },
        {
            value: 'Europe/Vaduz',
            label: 'UTC+01:00 (欧洲/瓦杜兹)',
        },
        {
            value: 'Europe/Vatican',
            label: 'UTC+01:00 (欧洲/梵蒂冈)',
        },
        {
            value: 'Europe/Vienna',
            label: 'UTC+01:00 (欧洲/维也纳)',
        },
        {
            value: 'Europe/Warsaw',
            label: 'UTC+01:00 (欧洲/华沙)',
        },
        {
            value: 'Europe/Zagreb',
            label: 'UTC+01:00 (欧洲/萨格勒布)',
        },
        {
            value: 'Europe/Zurich',
            label: 'UTC+01:00 (欧洲/苏黎世)',
        },
        {
            value: 'MET',
            label: 'UTC+01:00 (中欧时区)',
        },
        {
            value: 'Poland',
            label: 'UTC+01:00 (波兰)',
        },
        {
            value: 'Africa/Blantyre',
            label: 'UTC+02:00 (非洲/布兰太尔)',
        },
        {
            value: 'Africa/Bujumbura',
            label: 'UTC+02:00 (非洲/布琼布拉)',
        },
        {
            value: 'Africa/Cairo',
            label: 'UTC+02:00 (非洲/开罗)',
        },
        {
            value: 'Africa/Gaborone',
            label: 'UTC+02:00 (非洲/哈博罗内)',
        },
        {
            value: 'Africa/Harare',
            label: 'UTC+02:00 (非洲/哈拉雷)',
        },
        {
            value: 'Africa/Johannesburg',
            label: 'UTC+02:00 (非洲/约翰内斯堡)',
        },
        {
            value: 'Africa/Kigali',
            label: 'UTC+02:00 (非洲/基加利)',
        },
        {
            value: 'Africa/Lubumbashi',
            label: 'UTC+02:00 (非洲/卢本巴希)',
        },
        {
            value: 'Africa/Lusaka',
            label: 'UTC+02:00 (非洲/卢萨卡)',
        },
        {
            value: 'Africa/Maputo',
            label: 'UTC+02:00 (非洲/马普托)',
        },
        {
            value: 'Africa/Maseru',
            label: 'UTC+02:00 (非洲/马塞卢)',
        },
        {
            value: 'Africa/Mbabane',
            label: 'UTC+02:00 (非洲/姆巴巴内)',
        },
        {
            value: 'Africa/Tripoli',
            label: 'UTC+02:00 (非洲/的黎波里)',
        },
        {
            value: 'Asia/Amman',
            label: 'UTC+03:00 (亚洲/安曼)',
        },
        {
            value: 'Asia/Beirut',
            label: 'UTC+02:00 (亚洲/贝鲁特)',
        },
        {
            value: 'Asia/Damascus',
            label: 'UTC+03:00 (亚洲/大马士革)',
        },
        {
            value: 'Asia/Gaza',
            label: 'UTC+02:00 (亚洲/加沙)',
        },
        {
            value: 'Asia/Hebron',
            label: 'UTC+02:00 (亚洲/希伯伦)',
        },
        {
            value: 'Asia/Istanbul',
            label: 'UTC+03:00 (亚洲/伊斯坦布尔)',
        },
        {
            value: 'Asia/Jerusalem',
            label: 'UTC+02:00 (亚洲/耶路撒冷)',
        },
        {
            value: 'Asia/Nicosia',
            label: 'UTC+02:00 (亚洲/尼科西亚)',
        },
        {
            value: 'Asia/Tel_Aviv',
            label: 'UTC+02:00 (亚洲/特拉维夫)',
        },
        {
            value: 'EET',
            label: 'UTC+02:00 (东欧时区)',
        },
        {
            value: 'Egypt',
            label: 'UTC+02:00 (埃及)',
        },
        {
            value: 'Etc/GMT-2',
            label: 'UTC+02:00 (Etc/GMT-2)',
        },
        {
            value: 'Europe/Athens',
            label: 'UTC+02:00 (欧洲/雅典)',
        },
        {
            value: 'Asia/Famagusta',
            label: 'UTC+02:00 (亚洲/法马古塔斯)',
        },
        {
            value: 'Europe/Bucharest',
            label: 'UTC+02:00 (欧洲/布加勒斯特)',
        },
        {
            value: 'Europe/Chisinau',
            label: 'UTC+02:00 (欧洲/基希讷乌)',
        },
        {
            value: 'Europe/Helsinki',
            label: 'UTC+02:00 (欧洲/赫尔辛基)',
        },
        {
            value: 'Europe/Istanbul',
            label: 'UTC+03:00 (欧洲/伊斯坦布尔)',
        },
        {
            value: 'Europe/Kaliningrad',
            label: 'UTC+02:00 (欧洲/加里宁格勒)',
        },
        {
            value: 'Europe/Kiev',
            label: 'UTC+02:00 (欧洲/基辅)',
        },
        {
            value: 'Europe/Mariehamn',
            label: 'UTC+02:00 (欧洲/玛丽港)',
        },
        {
            value: 'Europe/Nicosia',
            label: 'UTC+02:00 (欧洲/尼科西亚)',
        },
        {
            value: 'Europe/Riga',
            label: 'UTC+02:00 (欧洲/里加)',
        },
        {
            value: 'Europe/Sofia',
            label: 'UTC+02:00 (欧洲/索非亚)',
        },
        {
            value: 'Europe/Tallinn',
            label: 'UTC+02:00 (欧洲/塔林)',
        },
        {
            value: 'Europe/Tiraspol',
            label: 'UTC+02:00 (欧洲/蒂拉斯波尔)',
        },
        {
            value: 'Europe/Uzhgorod',
            label: 'UTC+02:00 (欧洲/乌日格罗德)',
        },
        {
            value: 'Europe/Vilnius',
            label: 'UTC+02:00 (欧洲/维尔纽斯)',
        },
        {
            value: 'Europe/Zaporozhye',
            label: 'UTC+02:00 (欧洲/扎波罗什)',
        },
        {
            value: 'Libya',
            label: 'UTC+02:00 (利比亚)',
        },
        {
            value: 'Turkey',
            label: 'UTC+03:00 (土耳其)',
        },
        {
            value: 'Africa/Addis_Ababa',
            label: 'UTC+03:00 (非洲/亚的斯亚贝巴)',
        },
        {
            value: 'Africa/Asmara',
            label: 'UTC+03:00 (非洲/阿斯马拉 (Asmara))',
        },
        {
            value: 'Africa/Asmera',
            label: 'UTC+03:00 (非洲/阿斯马拉 (Asmera))',
        },
        {
            value: 'Africa/Dar_es_Salaam',
            label: 'UTC+03:00 (非洲/达累斯萨拉姆)',
        },
        {
            value: 'Africa/Djibouti',
            label: 'UTC+03:00 (非洲/吉布提)',
        },
        {
            value: 'Africa/Juba',
            label: 'UTC+02:00 (非洲/朱巴)',
        },
        {
            value: 'Africa/Kampala',
            label: 'UTC+03:00 (非洲/坎帕拉)',
        },
        {
            value: 'Africa/Khartoum',
            label: 'UTC+02:00 (非洲/喀士穆)',
        },
        {
            value: 'Africa/Mogadishu',
            label: 'UTC+03:00 (非洲/摩加迪沙)',
        },
        {
            value: 'Africa/Nairobi',
            label: 'UTC+03:00 (非洲/内罗毕)',
        },
        {
            value: 'Antarctica/Syowa',
            label: 'UTC+03:00 (南极洲/昭和站)',
        },
        {
            value: 'Asia/Aden',
            label: 'UTC+03:00 (亚洲/亚丁)',
        },
        {
            value: 'Asia/Baghdad',
            label: 'UTC+03:00 (亚洲/巴格达)',
        },
        {
            value: 'Asia/Bahrain',
            label: 'UTC+03:00 (亚洲/巴林)',
        },
        {
            value: 'Asia/Kuwait',
            label: 'UTC+03:00 (亚洲/科威特)',
        },
        {
            value: 'Asia/Qatar',
            label: 'UTC+03:00 (亚洲/卡塔尔)',
        },
        {
            value: 'Asia/Riyadh',
            label: 'UTC+03:00 (亚洲/利雅得)',
        },
        {
            value: 'Etc/GMT-3',
            label: 'UTC+03:00 (Etc/GMT-3)',
        },
        {
            value: 'Europe/Kirov',
            label: 'UTC+03:00 (欧洲/基洛夫)',
        },
        {
            value: 'Europe/Minsk',
            label: 'UTC+03:00 (欧洲/明斯克)',
        },
        {
            value: 'Europe/Moscow',
            label: 'UTC+03:00 (欧洲/莫斯科)',
        },
        {
            value: 'Europe/Simferopol',
            label: 'UTC+03:00 (欧洲/辛菲罗波尔)',
        },
        {
            value: 'Europe/Volgograd',
            label: 'UTC+03:00 (欧洲/伏尔加格勒)',
        },
        {
            value: 'Indian/Antananarivo',
            label: 'UTC+03:00 (印度洋/安塔那那利佛)',
        },
        {
            value: 'Indian/Comoro',
            label: 'UTC+03:00 (印度洋/科摩罗)',
        },
        {
            value: 'Indian/Mayotte',
            label: 'UTC+03:00 (印度洋/马约特)',
        },
        {
            value: 'W-SU',
            label: 'UTC+03:00 (W-SU)',
        },
        {
            value: 'Asia/Tehran',
            label: 'UTC+03:30 (亚洲/德黑兰)',
        },
        {
            value: 'Iran',
            label: 'UTC+03:30 (伊朗)',
        },
        {
            value: 'Asia/Baku',
            label: 'UTC+04:00 (亚洲/巴库)',
        },
        {
            value: 'Asia/Dubai',
            label: 'UTC+04:00 (亚洲/迪拜)',
        },
        {
            value: 'Asia/Muscat',
            label: 'UTC+04:00 (亚洲/马斯喀特)',
        },
        {
            value: 'Asia/Tbilisi',
            label: 'UTC+04:00 (亚洲/第比利斯)',
        },
        {
            value: 'Asia/Yerevan',
            label: 'UTC+04:00 (亚洲/埃里温)',
        },
        {
            value: 'Europe/Astrakhan',
            label: 'UTC+04:00 (欧洲/阿斯特拉罕)',
        },
        {
            value: 'Etc/GMT-4',
            label: 'UTC+04:00 (Etc/GMT-4)',
        },
        {
            value: 'Europe/Samara',
            label: 'UTC+04:00 (欧洲/萨马拉)',
        },
        {
            value: 'Europe/Saratov',
            label: 'UTC+04:00 (欧洲/萨拉托夫)',
        },
        {
            value: 'Europe/Ulyanovsk',
            label: 'UTC+04:00 (欧洲/乌里扬诺夫斯克)',
        },
        {
            value: 'Indian/Mahe',
            label: 'UTC+04:00 (印度洋/马埃岛)',
        },
        {
            value: 'Indian/Mauritius',
            label: 'UTC+04:00 (印度洋/毛里求斯)',
        },
        {
            value: 'Indian/Reunion',
            label: 'UTC+04:00 (印度洋/留尼汪)',
        },
        {
            value: 'Asia/Kabul',
            label: 'UTC+04:30 (亚洲/喀布尔)',
        },
        {
            value: 'Antarctica/Mawson',
            label: 'UTC+05:00 (南极洲/莫森站)',
        },
        {
            value: 'Asia/Aqtau',
            label: 'UTC+05:00 (亚洲/阿克套)',
        },
        {
            value: 'Asia/Aqtobe',
            label: 'UTC+05:00 (亚洲/阿克托别)',
        },
        {
            value: 'Asia/Ashgabat',
            label: 'UTC+05:00 (亚洲/阿什哈巴德 (Ashgabat))',
        },
        {
            value: 'Asia/Ashkhabad',
            label: 'UTC+05:00 (亚洲/阿什哈巴德 (Ashkhabad))',
        },
        {
            value: 'Asia/Dushanbe',
            label: 'UTC+05:00 (亚洲/杜尚别)',
        },
        {
            value: 'Asia/Karachi',
            label: 'UTC+05:00 (亚洲/卡拉奇)',
        },
        {
            value: 'Asia/Oral',
            label: 'UTC+05:00 (亚洲/乌拉尔)',
        },
        {
            value: 'Asia/Samarkand',
            label: 'UTC+05:00 (亚洲/撒马尔罕)',
        },
        {
            value: 'Asia/Tashkent',
            label: 'UTC+05:00 (亚洲/塔什干)',
        },
        {
            value: 'Asia/Yekaterinburg',
            label: 'UTC+05:00 (亚洲/叶卡捷琳堡)',
        },
        {
            value: 'Asia/Atyrau',
            label: 'UTC+05:00 (亚洲/阿特劳)',
        },
        {
            value: 'Etc/GMT-5',
            label: 'UTC+05:00 (Etc/GMT-5)',
        },
        {
            value: 'Indian/Kerguelen',
            label: 'UTC+05:00 (印度洋/凯尔盖朗)',
        },
        {
            value: 'Indian/Maldives',
            label: 'UTC+05:00 (印度洋/马尔代夫)',
        },
        {
            value: 'Antarctica/Vostok',
            label: 'UTC+05:00 (南极洲/东方站)',
        },
        {
            value: 'Asia/Almaty',
            label: 'UTC+05:00 (亚洲/阿拉木图)',
        },
        {
            value: 'Asia/Calcutta',
            label: 'UTC+05:30 (亚洲/加尔各答 (Calcutta))',
        },
        {
            value: 'Asia/Colombo',
            label: 'UTC+05:30 (亚洲/科伦坡)',
        },
        {
            value: 'Asia/Kolkata',
            label: 'UTC+05:30 (亚洲/加尔各答 (Kolkata))',
        },
        {
            value: 'Asia/Kathmandu',
            label: 'UTC+05:45 (亚洲/加德满都 (Kathmandu))',
        },
        {
            value: 'Asia/Katmandu',
            label: 'UTC+05:45 (亚洲/加德满都 (Katmandu))',
        },
        {
            value: 'Asia/Bishkek',
            label: 'UTC+06:00 (亚洲/比什凯克)',
        },
        {
            value: 'Asia/Dacca',
            label: 'UTC+06:00 (亚洲/达卡 (Dacca))',
        },
        {
            value: 'Asia/Dhaka',
            label: 'UTC+06:00 (亚洲/达卡 (Dhaka))',
        },
        {
            value: 'Asia/Kashgar',
            label: 'UTC+06:00 (亚洲/喀什)',
        },
        {
            value: 'Asia/Novosibirsk',
            label: 'UTC+07:00 (亚洲/新西伯利亚)',
        },
        {
            value: 'Asia/Omsk',
            label: 'UTC+06:00 (亚洲/鄂木斯克)',
        },
        {
            value: 'Asia/Qyzylorda',
            label: 'UTC+05:00 (亚洲/克孜勒奥尔达)',
        },
        {
            value: 'Asia/Thimbu',
            label: 'UTC+06:00 (亚洲/廷布 (Thimbu))',
        },
        {
            value: 'Asia/Thimphu',
            label: 'UTC+06:00 (亚洲/廷布 (Thimphu))',
        },
        {
            value: 'Asia/Urumqi',
            label: 'UTC+06:00 (亚洲/乌鲁木齐)',
        },
        {
            value: 'Etc/GMT-6',
            label: 'UTC+06:00 (Etc/GMT-6)',
        },
        {
            value: 'Indian/Chagos',
            label: 'UTC+06:00 (印度洋/查戈斯群岛)',
        },
        {
            value: 'Asia/Rangoon',
            label: 'UTC+06:30 (亚洲/仰光 (Rangoon))',
        },
        {
            value: 'Asia/Yangon',
            label: 'UTC+06:30 (亚洲/仰光 (Yangon))',
        },
        {
            value: 'Indian/Cocos',
            label: 'UTC+06:30 (印度洋/科科斯群岛)',
        },
        {
            value: 'Antarctica/Davis',
            label: 'UTC+07:00 (南极洲/戴维斯站)',
        },
        {
            value: 'Asia/Bangkok',
            label: 'UTC+07:00 (亚洲/曼谷)',
        },
        {
            value: 'Asia/Barnaul',
            label: 'UTC+07:00 (亚洲/巴尔瑙尔)',
        },
        {
            value: 'Asia/Ho_Chi_Minh',
            label: 'UTC+07:00 (亚洲/胡志明)',
        },
        {
            value: 'Asia/Hovd',
            label: 'UTC+07:00 (亚洲/科布多)',
        },
        {
            value: 'Asia/Jakarta',
            label: 'UTC+07:00 (亚洲/雅加达)',
        },
        {
            value: 'Asia/Krasnoyarsk',
            label: 'UTC+07:00 (亚洲/克拉斯诺亚尔斯克)',
        },
        {
            value: 'Asia/Novokuznetsk',
            label: 'UTC+07:00 (亚洲/新库兹涅茨克)',
        },
        {
            value: 'Asia/Phnom_Penh',
            label: 'UTC+07:00 (亚洲/金边)',
        },
        {
            value: 'Asia/Pontianak',
            label: 'UTC+07:00 (亚洲/坤甸)',
        },
        {
            value: 'Asia/Saigon',
            label: 'UTC+07:00 (亚洲/西贡)',
        },
        {
            value: 'Asia/Tomsk',
            label: 'UTC+07:00 (亚洲/托木斯克)',
        },
        {
            value: 'Asia/Vientiane',
            label: 'UTC+07:00 (亚洲/万象)',
        },
        {
            value: 'Etc/GMT-7',
            label: 'UTC+07:00 (Etc/GMT-7)',
        },
        {
            value: 'Indian/Christmas',
            label: 'UTC+07:00 (印度洋/圣诞岛)',
        },
        {
            value: 'PRC',
            label: 'UTC+08:00 (中国)',
        },
        {
            value: 'Antarctica/Casey',
            label: 'UTC+08:00 (南极洲/凯西站)',
        },
        {
            value: 'Asia/Beijing',
            label: 'UTC+08:00 (亚洲/北京)',
        },
        {
            value: 'Asia/Brunei',
            label: 'UTC+08:00 (亚洲/文莱)',
        },
        {
            value: 'Asia/Chita',
            label: 'UTC+09:00 (亚洲/赤塔)',
        },
        {
            value: 'Asia/Choibalsan',
            label: 'UTC+08:00 (亚洲/乔巴山)',
        },
        {
            value: 'Asia/Chongqing',
            label: 'UTC+08:00 (亚洲/重庆 (Chongqing))',
        },
        {
            value: 'Asia/Chungking',
            label: 'UTC+08:00 (亚洲/重庆 (Chungking))',
        },
        {
            value: 'Asia/Harbin',
            label: 'UTC+08:00 (亚洲/哈尔滨)',
        },
        {
            value: 'Asia/Irkutsk',
            label: 'UTC+08:00 (亚洲/伊尔库次克)',
        },
        {
            value: 'Asia/Kuala_Lumpur',
            label: 'UTC+08:00 (亚洲/吉隆坡)',
        },
        {
            value: 'Asia/Kuching',
            label: 'UTC+08:00 (亚洲/古晋)',
        },
        {
            value: 'Asia/Makassar',
            label: 'UTC+08:00 (亚洲/望加锡)',
        },
        {
            value: 'Asia/Manila',
            label: 'UTC+08:00 (亚洲/马尼拉)',
        },
        {
            value: 'Asia/Hong_Kong',
            label: 'UTC+08:00 (亚洲/香港)',
        },
        {
            value: 'Asia/Macao',
            label: 'UTC+08:00 (亚洲/澳门 (Macao))',
        },
        {
            value: 'Asia/Taipei',
            label: 'UTC+08:00 (亚洲/台北)',
        },
        {
            value: 'Asia/Shanghai',
            label: 'UTC+08:00 (亚洲/上海)',
        },
        {
            value: 'Asia/Singapore',
            label: 'UTC+08:00 (亚洲/新加坡)',
        },
        {
            value: 'Asia/Ujung_Pandang',
            label: 'UTC+08:00 (亚洲/乌戎潘当)',
        },
        {
            value: 'Asia/Ulaanbaatar',
            label: 'UTC+08:00 (亚洲/乌兰巴托 (Ulaanbaatar))',
        },
        {
            value: 'Asia/Ulan_Bator',
            label: 'UTC+08:00 (亚洲/乌兰巴托 (Ulan_Bator))',
        },
        {
            value: 'Australia/Perth',
            label: 'UTC+08:00 (澳大利亚/珀斯)',
        },
        {
            value: 'Australia/West',
            label: 'UTC+08:00 (澳大利亚/西澳)',
        },
        {
            value: 'Etc/GMT-8',
            label: 'UTC+08:00 (Etc/GMT-8)',
        },
        {
            value: 'Singapore',
            label: 'UTC+08:00 (新加坡)',
        },
        {
            value: 'Australia/Eucla',
            label: 'UTC+08:45 (澳大利亚/尤克拉)',
        },
        {
            value: 'Asia/Dili',
            label: 'UTC+09:00 (亚洲/帝力)',
        },
        {
            value: 'Asia/Jayapura',
            label: 'UTC+09:00 (亚洲/查亚普拉)',
        },
        {
            value: 'Asia/Khandyga',
            label: 'UTC+09:00 (亚洲/萨哈)',
        },
        {
            value: 'Asia/Pyongyang',
            label: 'UTC+09:00 (亚洲/平壤)',
        },
        {
            value: 'Asia/Seoul',
            label: 'UTC+09:00 (亚洲/首尔)',
        },
        {
            value: 'Asia/Tokyo',
            label: 'UTC+09:00 (亚洲/东京)',
        },
        {
            value: 'Asia/Yakutsk',
            label: 'UTC+09:00 (亚洲/雅库茨克)',
        },
        {
            value: 'Etc/GMT-9',
            label: 'UTC+09:00 (Etc/GMT-9)',
        },
        {
            value: 'Japan',
            label: 'UTC+09:00 (日本)',
        },
        {
            value: 'Pacific/Palau',
            label: 'UTC+09:00 (太平洋/帕劳)',
        },
        {
            value: 'ROK',
            label: 'UTC+09:00 (韩国)',
        },
        {
            value: 'Australia/Darwin',
            label: 'UTC+09:30 (澳大利亚/达尔文)',
        },
        {
            value: 'Australia/North',
            label: 'UTC+09:30 (澳大利亚/北澳)',
        },
        {
            value: 'Australia/Adelaide',
            label: 'UTC+09:30 (澳大利亚/阿德莱德)',
        },
        {
            value: 'Australia/Broken_Hill',
            label: 'UTC+09:30 (澳大利亚/布罗肯希尔)',
        },
        {
            value: 'Australia/South',
            label: 'UTC+09:30 (澳大利亚/南澳)',
        },
        {
            value: 'Australia/Yancowinna',
            label: 'UTC+09:30 (澳大利亚/新南威尔士)',
        },
        {
            value: 'Antarctica/DumontDUrville',
            label: 'UTC+10:00 (南极洲/迪蒙·迪维尔站)',
        },
        {
            value: 'Asia/Magadan',
            label: 'UTC+11:00 (亚洲/马加丹)',
        },
        {
            value: 'Asia/Sakhalin',
            label: 'UTC+11:00 (亚洲/萨哈林岛)',
        },
        {
            value: 'Asia/Ust-Nera',
            label: 'UTC+10:00 (亚洲/乌斯季涅拉)',
        },
        {
            value: 'Asia/Vladivostok',
            label: 'UTC+10:00 (亚洲/符拉迪沃斯托克)',
        },
        {
            value: 'Australia/Brisbane',
            label: 'UTC+10:00 (澳大利亚/布里斯班)',
        },
        {
            value: 'Australia/Lindeman',
            label: 'UTC+10:00 (澳大利亚/林德曼岛)',
        },
        {
            value: 'Australia/Queensland',
            label: 'UTC+10:00 (澳大利亚/昆士兰)',
        },
        {
            value: 'Australia/ACT',
            label: 'UTC+10:00 (澳大利亚/澳大利亚首都特区)',
        },
        {
            value: 'Australia/Canberra',
            label: 'UTC+10:00 (澳大利亚/堪培拉)',
        },
        {
            value: 'Australia/Currie',
            label: 'UTC+10:00 (澳大利亚/柯里)',
        },
        {
            value: 'Australia/Melbourne',
            label: 'UTC+10:00 (澳大利亚/墨尔本)',
        },
        {
            value: 'Australia/NSW',
            label: 'UTC+10:00 (澳大利亚/新南威尔士)',
        },
        {
            value: 'Australia/Sydney',
            label: 'UTC+10:00 (澳大利亚/悉尼)',
        },
        {
            value: 'Australia/Tasmania',
            label: 'UTC+10:00 (澳大利亚/塔斯马尼亚)',
        },
        {
            value: 'Australia/Victoria',
            label: 'UTC+10:00 (澳大利亚/维多利亚)',
        },
        {
            value: 'Australia/Hobart',
            label: 'UTC+10:00 (澳大利亚/霍巴特)',
        },
        {
            value: 'Etc/GMT-10',
            label: 'UTC+10:00 (Etc/GMT-10)',
        },
        {
            value: 'Pacific/Chuuk',
            label: 'UTC+10:00 (太平洋/楚克)',
        },
        {
            value: 'Pacific/Guam',
            label: 'UTC+10:00 (太平洋/关岛)',
        },
        {
            value: 'Pacific/Port_Moresby',
            label: 'UTC+10:00 (太平洋/莫尔兹比港)',
        },
        {
            value: 'Pacific/Saipan',
            label: 'UTC+10:00 (太平洋/塞班岛)',
        },
        {
            value: 'Pacific/Truk',
            label: 'UTC+10:00 (太平洋/特鲁克群岛)',
        },
        {
            value: 'Pacific/Yap',
            label: 'UTC+10:00 (太平洋/雅浦岛)',
        },
        {
            value: 'Australia/LHI',
            label: 'UTC+10:30 (澳大利亚/豪勋爵岛 (LHI))',
        },
        {
            value: 'Australia/Lord_Howe',
            label: 'UTC+10:30 (澳大利亚/豪勋爵岛 (Lord_Howe))',
        },
        {
            value: 'Antarctica/Macquarie',
            label: 'UTC+10:00 (南极洲/麦夸里岛)',
        },
        {
            value: 'Asia/Srednekolymsk',
            label: 'UTC+11:00 (亚洲/中科雷姆斯克)',
        },
        {
            value: 'Etc/GMT-11',
            label: 'UTC+11:00 (Etc/GMT-11)',
        },
        {
            value: 'Pacific/Bougainville',
            label: 'UTC+11:00 (太平洋/布干维尔岛)',
        },
        {
            value: 'Pacific/Efate',
            label: 'UTC+11:00 (太平洋/埃法特)',
        },
        {
            value: 'Pacific/Guadalcanal',
            label: 'UTC+11:00 (太平洋/瓜达尔卡纳尔岛)',
        },
        {
            value: 'Pacific/Kosrae',
            label: 'UTC+11:00 (太平洋/科斯雷)',
        },
        {
            value: 'Pacific/Noumea',
            label: 'UTC+11:00 (太平洋/努美阿)',
        },
        {
            value: 'Pacific/Pohnpei',
            label: 'UTC+11:00 (太平洋/波纳佩 (Pohnpei))',
        },
        {
            value: 'Pacific/Ponape',
            label: 'UTC+11:00 (太平洋/波纳佩 (Ponape))',
        },
        {
            value: 'Pacific/Norfolk',
            label: 'UTC+11:00 (太平洋/诺福克)',
        },
        {
            value: 'Asia/Anadyr',
            label: 'UTC+12:00 (亚洲/阿纳德尔)',
        },
        {
            value: 'Asia/Kamchatka',
            label: 'UTC+12:00 (亚洲/堪察加半岛)',
        },
        {
            value: 'Etc/GMT-12',
            label: 'UTC+12:00 (Etc/GMT-12)',
        },
        {
            value: 'Kwajalein',
            label: 'UTC+12:00 (夸贾林)',
        },
        {
            value: 'Pacific/Fiji',
            label: 'UTC+12:00 (太平洋/斐济)',
        },
        {
            value: 'Pacific/Funafuti',
            label: 'UTC+12:00 (太平洋/富纳富提)',
        },
        {
            value: 'Pacific/Kwajalein',
            label: 'UTC+12:00 (太平洋/夸贾林)',
        },
        {
            value: 'Pacific/Majuro',
            label: 'UTC+12:00 (太平洋/马朱罗)',
        },
        {
            value: 'Pacific/Nauru',
            label: 'UTC+12:00 (太平洋/瑙鲁)',
        },
        {
            value: 'Pacific/Tarawa',
            label: 'UTC+12:00 (太平洋/塔拉瓦)',
        },
        {
            value: 'Pacific/Wake',
            label: 'UTC+12:00 (太平洋/威克岛)',
        },
        {
            value: 'Pacific/Wallis',
            label: 'UTC+12:00 (太平洋/瓦利斯)',
        },
        {
            value: 'Pacific/Auckland',
            label: 'UTC+12:00 (太平洋/奥克兰)',
        },
        {
            value: 'Antarctica/McMurdo',
            label: 'UTC+12:00 (南极洲/麦克默多站)',
        },
        {
            value: 'Antarctica/South_Pole',
            label: 'UTC+12:00 (南极洲/南极)',
        },
        {
            value: 'NZ',
            label: 'UTC+12:00 (新西兰时区)',
        },
        {
            value: 'Pacific/Chatham',
            label: 'UTC+12:45 (太平洋/查塔姆)',
        },
        {
            value: 'NZ-CHAT',
            label: 'UTC+12:45 (NZ-CHAT)',
        },
        {
            value: 'Etc/GMT-13',
            label: 'UTC+13:00 (Etc/GMT-13)',
        },
        {
            value: 'Pacific/Enderbury',
            label: 'UTC+13:00 (太平洋/恩德伯里)',
        },
        {
            value: 'Pacific/Fakaofo',
            label: 'UTC+13:00 (太平洋/法考福)',
        },
        {
            value: 'Pacific/Tongatapu',
            label: 'UTC+13:00 (太平洋/汤加塔布)',
        },
        {
            value: 'Pacific/Apia',
            label: 'UTC+13:00 (太平洋/阿皮亚)',
        },
        {
            value: 'Etc/GMT-14',
            label: 'UTC+14:00 (Etc/GMT-14)',
        },
        {
            value: 'Pacific/Kiritimati',
            label: 'UTC+14:00 (太平洋/吉尔伯特群岛)',
        },
    ],
    en: [
        {
            value: 'Etc/GMT+12',
            label: 'UTC-12:00 (Etc/GMT+12)',
        },
        {
            value: 'Etc/GMT+11',
            label: 'UTC-11:00 (Etc/GMT+11)',
        },
        {
            value: 'Pacific/Midway',
            label: 'UTC-11:00 (Pacific/Midway)',
        },
        {
            value: 'Pacific/Niue',
            label: 'UTC-11:00 (Pacific/Niue)',
        },
        {
            value: 'Pacific/Pago_Pago',
            label: 'UTC-11:00 (Pacific/Pago_Pago)',
        },
        {
            value: 'Pacific/Samoa',
            label: 'UTC-11:00 (Pacific/Samoa)',
        },
        {
            value: 'US/Samoa',
            label: 'UTC-11:00 (US/Samoa)',
        },
        {
            value: 'America/Adak',
            label: 'UTC-10:00 (America/Adak)',
        },
        {
            value: 'America/Atka',
            label: 'UTC-10:00 (America/Atka)',
        },
        {
            value: 'Etc/GMT+10',
            label: 'UTC-10:00 (Etc/GMT+10)',
        },
        {
            value: 'HST',
            label: 'UTC-10:00 (HST)',
        },
        {
            value: 'Pacific/Honolulu',
            label: 'UTC-10:00 (Pacific/Honolulu)',
        },
        {
            value: 'Pacific/Johnston',
            label: 'UTC-10:00 (Pacific/Johnston)',
        },
        {
            value: 'Pacific/Rarotonga',
            label: 'UTC-10:00 (Pacific/Rarotonga)',
        },
        {
            value: 'Pacific/Tahiti',
            label: 'UTC-10:00 (Pacific/Tahiti)',
        },
        {
            value: 'US/Aleutian',
            label: 'UTC-10:00 (US/Aleutian)',
        },
        {
            value: 'US/Hawaii',
            label: 'UTC-10:00 (US/Hawaii)',
        },
        {
            value: 'Pacific/Marquesas',
            label: 'UTC-09:30 (Pacific/Marquesas)',
        },
        {
            value: 'America/Anchorage',
            label: 'UTC-09:00 (America/Anchorage)',
        },
        {
            value: 'America/Juneau',
            label: 'UTC-09:00 (America/Juneau)',
        },
        {
            value: 'America/Nome',
            label: 'UTC-09:00 (America/Nome)',
        },
        {
            value: 'America/Sitka',
            label: 'UTC-09:00 (America/Sitka)',
        },
        {
            value: 'America/Yakutat',
            label: 'UTC-09:00 (America/Yakutat)',
        },
        {
            value: 'Etc/GMT+9',
            label: 'UTC-09:00 (Etc/GMT+9)',
        },
        {
            value: 'Pacific/Gambier',
            label: 'UTC-09:00 (Pacific/Gambier)',
        },
        {
            value: 'US/Alaska',
            label: 'UTC-09:00 (US/Alaska)',
        },
        {
            value: 'America/Dawson',
            label: 'UTC-07:00 (America/Dawson)',
        },
        {
            value: 'America/Ensenada',
            label: 'UTC-08:00 (America/Ensenada)',
        },
        {
            value: 'America/Los_Angeles',
            label: 'UTC-08:00 (America/Los_Angeles)',
        },
        {
            value: 'America/Metlakatla',
            label: 'UTC-09:00 (America/Metlakatla)',
        },
        {
            value: 'America/Santa_Isabel',
            label: 'UTC-08:00 (America/Santa_Isabel)',
        },
        {
            value: 'America/Tijuana',
            label: 'UTC-08:00 (America/Tijuana)',
        },
        {
            value: 'America/Vancouver',
            label: 'UTC-08:00 (America/Vancouver)',
        },
        {
            value: 'America/Whitehorse',
            label: 'UTC-07:00 (America/Whitehorse)',
        },
        {
            value: 'Canada/Pacific',
            label: 'UTC-08:00 (Canada/Pacific)',
        },
        {
            value: 'Canada/Yukon',
            label: 'UTC-07:00 (Canada/Yukon)',
        },
        {
            value: 'Etc/GMT+8',
            label: 'UTC-08:00 (Etc/GMT+8)',
        },
        {
            value: 'Mexico/BajaNorte',
            label: 'UTC-08:00 (Mexico/BajaNorte)',
        },
        {
            value: 'PST8PDT',
            label: 'UTC-08:00 (PST8PDT)',
        },
        {
            value: 'Pacific/Pitcairn',
            label: 'UTC-08:00 (Pacific/Pitcairn)',
        },
        {
            value: 'US/Pacific-New',
            label: 'UTC-08:00 (US/Pacific-New)',
        },
        {
            value: 'US/Pacific',
            label: 'UTC-08:00 (US/Pacific)',
        },
        {
            value: 'America/Boise',
            label: 'UTC-07:00 (America/Boise)',
        },
        {
            value: 'America/Cambridge_Bay',
            label: 'UTC-07:00 (America/Cambridge_Bay)',
        },
        {
            value: 'America/Chihuahua',
            label: 'UTC-06:00 (America/Chihuahua)',
        },
        {
            value: 'America/Creston',
            label: 'UTC-07:00 (America/Creston)',
        },
        {
            value: 'America/Dawson_Creek',
            label: 'UTC-07:00 (America/Dawson_Creek)',
        },
        {
            value: 'America/Denver',
            label: 'UTC-07:00 (America/Denver)',
        },
        {
            value: 'America/Edmonton',
            label: 'UTC-07:00 (America/Edmonton)',
        },
        {
            value: 'America/Fort_Nelson',
            label: 'UTC-07:00 (America/Fort_Nelson)',
        },
        {
            value: 'America/Hermosillo',
            label: 'UTC-07:00 (America/Hermosillo)',
        },
        {
            value: 'America/Inuvik',
            label: 'UTC-07:00 (America/Inuvik)',
        },
        {
            value: 'America/Mazatlan',
            label: 'UTC-07:00 (America/Mazatlan)',
        },
        {
            value: 'America/Ojinaga',
            label: 'UTC-06:00 (America/Ojinaga)',
        },
        {
            value: 'America/Phoenix',
            label: 'UTC-07:00 (America/Phoenix)',
        },
        {
            value: 'America/Shiprock',
            label: 'UTC-07:00 (America/Shiprock)',
        },
        {
            value: 'America/Yellowknife',
            label: 'UTC-07:00 (America/Yellowknife)',
        },
        {
            value: 'Canada/Mountain',
            label: 'UTC-07:00 (Canada/Mountain)',
        },
        {
            value: 'Etc/GMT+7',
            label: 'UTC-07:00 (Etc/GMT+7)',
        },
        {
            value: 'MST7MDT',
            label: 'UTC-07:00 (MST7MDT)',
        },
        {
            value: 'MST',
            label: 'UTC-07:00 (MST)',
        },
        {
            value: 'Mexico/BajaSur',
            label: 'UTC-07:00 (Mexico/BajaSur)',
        },
        {
            value: 'Navajo',
            label: 'UTC-07:00 (Navajo)',
        },
        {
            value: 'US/Arizona',
            label: 'UTC-07:00 (US/Arizona)',
        },
        {
            value: 'US/Mountain',
            label: 'UTC-07:00 (US/Mountain)',
        },
        {
            value: 'America/Bahia_Banderas',
            label: 'UTC-06:00 (America/Bahia_Banderas)',
        },
        {
            value: 'America/Belize',
            label: 'UTC-06:00 (America/Belize)',
        },
        {
            value: 'America/Chicago',
            label: 'UTC-06:00 (America/Chicago)',
        },
        {
            value: 'America/Costa_Rica',
            label: 'UTC-06:00 (America/Costa_Rica)',
        },
        {
            value: 'America/El_Salvador',
            label: 'UTC-06:00 (America/El_Salvador)',
        },
        {
            value: 'America/Guatemala',
            label: 'UTC-06:00 (America/Guatemala)',
        },
        {
            value: 'America/Indiana/Knox',
            label: 'UTC-06:00 (America/Indiana/Knox)',
        },
        {
            value: 'America/Indiana/Tell_City',
            label: 'UTC-06:00 (America/Indiana/Tell_City)',
        },
        {
            value: 'America/Knox_IN',
            label: 'UTC-06:00 (America/Knox_IN)',
        },
        {
            value: 'America/Managua',
            label: 'UTC-06:00 (America/Managua)',
        },
        {
            value: 'America/Matamoros',
            label: 'UTC-06:00 (America/Matamoros)',
        },
        {
            value: 'America/Menominee',
            label: 'UTC-06:00 (America/Menominee)',
        },
        {
            value: 'America/Merida',
            label: 'UTC-06:00 (America/Merida)',
        },
        {
            value: 'America/Mexico_City',
            label: 'UTC-06:00 (America/Mexico_City)',
        },
        {
            value: 'America/Monterrey',
            label: 'UTC-06:00 (America/Monterrey)',
        },
        {
            value: 'America/North_Dakota/Beulah',
            label: 'UTC-06:00 (America/North_Dakota/Beulah)',
        },
        {
            value: 'America/North_Dakota/Center',
            label: 'UTC-06:00 (America/North_Dakota/Center)',
        },
        {
            value: 'America/North_Dakota/New_Salem',
            label: 'UTC-06:00 (America/North_Dakota/New_Salem)',
        },
        {
            value: 'America/Rainy_River',
            label: 'UTC-06:00 (America/Rainy_River)',
        },
        {
            value: 'America/Rankin_Inlet',
            label: 'UTC-06:00 (America/Rankin_Inlet)',
        },
        {
            value: 'America/Regina',
            label: 'UTC-06:00 (America/Regina)',
        },
        {
            value: 'America/Resolute',
            label: 'UTC-06:00 (America/Resolute)',
        },
        {
            value: 'America/Swift_Current',
            label: 'UTC-06:00 (America/Swift_Current)',
        },
        {
            value: 'America/Tegucigalpa',
            label: 'UTC-06:00 (America/Tegucigalpa)',
        },
        {
            value: 'America/Winnipeg',
            label: 'UTC-06:00 (America/Winnipeg)',
        },
        {
            value: 'CST6CDT',
            label: 'UTC-06:00 (CST6CDT)',
        },
        {
            value: 'Canada/Central',
            label: 'UTC-06:00 (Canada/Central)',
        },
        {
            value: 'Canada/Saskatchewan',
            label: 'UTC-06:00 (Canada/Saskatchewan)',
        },
        {
            value: 'Etc/GMT+6',
            label: 'UTC-06:00 (Etc/GMT+6)',
        },
        {
            value: 'Mexico/General',
            label: 'UTC-06:00 (Mexico/General)',
        },
        {
            value: 'Pacific/Galapagos',
            label: 'UTC-06:00 (Pacific/Galapagos)',
        },
        {
            value: 'US/Central',
            label: 'UTC-06:00 (US/Central)',
        },
        {
            value: 'US/Indiana-Starke',
            label: 'UTC-06:00 (US/Indiana-Starke)',
        },
        {
            value: 'America/Atikokan',
            label: 'UTC-05:00 (America/Atikokan)',
        },
        {
            value: 'America/Bogota',
            label: 'UTC-05:00 (America/Bogota)',
        },
        {
            value: 'America/Cancun',
            label: 'UTC-05:00 (America/Cancun)',
        },
        {
            value: 'America/Cayman',
            label: 'UTC-05:00 (America/Cayman)',
        },
        {
            value: 'America/Coral_Harbour',
            label: 'UTC-05:00 (America/Coral_Harbour)',
        },
        {
            value: 'America/Detroit',
            label: 'UTC-05:00 (America/Detroit)',
        },
        {
            value: 'America/Eirunepe',
            label: 'UTC-05:00 (America/Eirunepe)',
        },
        {
            value: 'America/Fort_Wayne',
            label: 'UTC-05:00 (America/Fort_Wayne)',
        },
        {
            value: 'America/Guayaquil',
            label: 'UTC-05:00 (America/Guayaquil)',
        },
        {
            value: 'America/Havana',
            label: 'UTC-05:00 (America/Havana)',
        },
        {
            value: 'America/Indiana/Indianapolis',
            label: 'UTC-05:00 (America/Indiana/Indianapolis)',
        },
        {
            value: 'America/Indiana/Marengo',
            label: 'UTC-05:00 (America/Indiana/Marengo)',
        },
        {
            value: 'America/Indiana/Petersburg',
            label: 'UTC-05:00 (America/Indiana/Petersburg)',
        },
        {
            value: 'America/Indiana/Vevay',
            label: 'UTC-05:00 (America/Indiana/Vevay)',
        },
        {
            value: 'America/Indiana/Vincennes',
            label: 'UTC-05:00 (America/Indiana/Vincennes)',
        },
        {
            value: 'America/Indiana/Winamac',
            label: 'UTC-05:00 (America/Indiana/Winamac)',
        },
        {
            value: 'America/Indianapolis',
            label: 'UTC-05:00 (America/Indianapolis)',
        },
        {
            value: 'America/Iqaluit',
            label: 'UTC-05:00 (America/Iqaluit)',
        },
        {
            value: 'America/Jamaica',
            label: 'UTC-05:00 (America/Jamaica)',
        },
        {
            value: 'America/Kentucky/Louisville',
            label: 'UTC-05:00 (America/Kentucky/Louisville)',
        },
        {
            value: 'America/Kentucky/Monticello',
            label: 'UTC-05:00 (America/Kentucky/Monticello)',
        },
        {
            value: 'America/Lima',
            label: 'UTC-05:00 (America/Lima)',
        },
        {
            value: 'America/Louisville',
            label: 'UTC-05:00 (America/Louisville)',
        },
        {
            value: 'America/Montreal',
            label: 'UTC-05:00 (America/Montreal)',
        },
        {
            value: 'America/Nassau',
            label: 'UTC-05:00 (America/Nassau)',
        },
        {
            value: 'America/New_York',
            label: 'UTC-05:00 (America/New_York)',
        },
        {
            value: 'America/Nipigon',
            label: 'UTC-05:00 (America/Nipigon)',
        },
        {
            value: 'America/Panama',
            label: 'UTC-05:00 (America/Panama)',
        },
        {
            value: 'America/Pangnirtung',
            label: 'UTC-05:00 (America/Pangnirtung)',
        },
        {
            value: 'America/Port-au-Prince',
            label: 'UTC-05:00 (America/Port-au-Prince)',
        },
        {
            value: 'America/Porto_Acre',
            label: 'UTC-05:00 (America/Porto_Acre)',
        },
        {
            value: 'America/Rio_Branco',
            label: 'UTC-05:00 (America/Rio_Branco)',
        },
        {
            value: 'America/Thunder_Bay',
            label: 'UTC-05:00 (America/Thunder_Bay)',
        },
        {
            value: 'America/Toronto',
            label: 'UTC-05:00 (America/Toronto)',
        },
        {
            value: 'Brazil/Acre',
            label: 'UTC-05:00 (Brazil/Acre)',
        },
        {
            value: 'Canada/Eastern',
            label: 'UTC-05:00 (Canada/Eastern)',
        },
        {
            value: 'Chile/EasterIsland',
            label: 'UTC-06:00 (Chile/EasterIsland)',
        },
        {
            value: 'Cuba',
            label: 'UTC-05:00 (Cuba)',
        },
        {
            value: 'EST5EDT',
            label: 'UTC-05:00 (EST5EDT)',
        },
        {
            value: 'EST',
            label: 'UTC-05:00 (EST)',
        },
        {
            value: 'Etc/GMT+5',
            label: 'UTC-05:00 (Etc/GMT+5)',
        },
        {
            value: 'Jamaica',
            label: 'UTC-05:00 (Jamaica)',
        },
        {
            value: 'Pacific/Easter',
            label: 'UTC-06:00 (Pacific/Easter)',
        },
        {
            value: 'US/East-Indiana',
            label: 'UTC-05:00 (US/East-Indiana)',
        },
        {
            value: 'US/Eastern',
            label: 'UTC-05:00 (US/Eastern)',
        },
        {
            value: 'US/Michigan',
            label: 'UTC-05:00 (US/Michigan)',
        },
        {
            value: 'America/Caracas',
            label: 'UTC-04:00 (America/Caracas)',
        },
        {
            value: 'America/Anguilla',
            label: 'UTC-04:00 (America/Anguilla)',
        },
        {
            value: 'America/Antigua',
            label: 'UTC-04:00 (America/Antigua)',
        },
        {
            value: 'America/Aruba',
            label: 'UTC-04:00 (America/Aruba)',
        },
        {
            value: 'America/Barbados',
            label: 'UTC-04:00 (America/Barbados)',
        },
        {
            value: 'America/Blanc-Sablon',
            label: 'UTC-04:00 (America/Blanc-Sablon)',
        },
        {
            value: 'America/Boa_Vista',
            label: 'UTC-04:00 (America/Boa_Vista)',
        },
        {
            value: 'America/Curacao',
            label: 'UTC-04:00 (America/Curacao)',
        },
        {
            value: 'America/Dominica',
            label: 'UTC-04:00 (America/Dominica)',
        },
        {
            value: 'America/Glace_Bay',
            label: 'UTC-04:00 (America/Glace_Bay)',
        },
        {
            value: 'America/Goose_Bay',
            label: 'UTC-04:00 (America/Goose_Bay)',
        },
        {
            value: 'America/Grand_Turk',
            label: 'UTC-05:00 (America/Grand_Turk)',
        },
        {
            value: 'America/Grenada',
            label: 'UTC-04:00 (America/Grenada)',
        },
        {
            value: 'America/Guadeloupe',
            label: 'UTC-04:00 (America/Guadeloupe)',
        },
        {
            value: 'America/Guyana',
            label: 'UTC-04:00 (America/Guyana)',
        },
        {
            value: 'America/Halifax',
            label: 'UTC-04:00 (America/Halifax)',
        },
        {
            value: 'America/Kralendijk',
            label: 'UTC-04:00 (America/Kralendijk)',
        },
        {
            value: 'America/La_Paz',
            label: 'UTC-04:00 (America/La_Paz)',
        },
        {
            value: 'America/Lower_Princes',
            label: 'UTC-04:00 (America/Lower_Princes)',
        },
        {
            value: 'America/Manaus',
            label: 'UTC-04:00 (America/Manaus)',
        },
        {
            value: 'America/Marigot',
            label: 'UTC-04:00 (America/Marigot)',
        },
        {
            value: 'America/Martinique',
            label: 'UTC-04:00 (America/Martinique)',
        },
        {
            value: 'America/Moncton',
            label: 'UTC-04:00 (America/Moncton)',
        },
        {
            value: 'America/Montserrat',
            label: 'UTC-04:00 (America/Montserrat)',
        },
        {
            value: 'America/Port_of_Spain',
            label: 'UTC-04:00 (America/Port_of_Spain)',
        },
        {
            value: 'America/Porto_Velho',
            label: 'UTC-04:00 (America/Porto_Velho)',
        },
        {
            value: 'America/Puerto_Rico',
            label: 'UTC-04:00 (America/Puerto_Rico)',
        },
        {
            value: 'America/Santo_Domingo',
            label: 'UTC-04:00 (America/Santo_Domingo)',
        },
        {
            value: 'America/St_Barthelemy',
            label: 'UTC-04:00 (America/St_Barthelemy)',
        },
        {
            value: 'America/St_Kitts',
            label: 'UTC-04:00 (America/St_Kitts)',
        },
        {
            value: 'America/St_Lucia',
            label: 'UTC-04:00 (America/St_Lucia)',
        },
        {
            value: 'America/St_Thomas',
            label: 'UTC-04:00 (America/St_Thomas)',
        },
        {
            value: 'America/St_Vincent',
            label: 'UTC-04:00 (America/St_Vincent)',
        },
        {
            value: 'America/Thule',
            label: 'UTC-04:00 (America/Thule)',
        },
        {
            value: 'America/Tortola',
            label: 'UTC-04:00 (America/Tortola)',
        },
        {
            value: 'America/Virgin',
            label: 'UTC-04:00 (America/Virgin)',
        },
        {
            value: 'America/Asuncion',
            label: 'UTC-04:00 (America/Asuncion)',
        },
        {
            value: 'America/Cuiaba',
            label: 'UTC-04:00 (America/Cuiaba)',
        },
        {
            value: 'America/Campo_Grande',
            label: 'UTC-04:00 (America/Campo_Grande)',
        },
        {
            value: 'Atlantic/Bermuda',
            label: 'UTC-04:00 (Atlantic/Bermuda)',
        },
        {
            value: 'Brazil/West',
            label: 'UTC-04:00 (Brazil/West)',
        },
        {
            value: 'Canada/Atlantic',
            label: 'UTC-04:00 (Canada/Atlantic)',
        },
        {
            value: 'Etc/GMT+4',
            label: 'UTC-04:00 (Etc/GMT+4)',
        },
        {
            value: 'America/St_Johns',
            label: 'UTC-03:30 (America/St_Johns)',
        },
        {
            value: 'Canada/Newfoundland',
            label: 'UTC-03:30 (Canada/Newfoundland)',
        },
        {
            value: 'America/Araguaina',
            label: 'UTC-03:00 (America/Araguaina)',
        },
        {
            value: 'America/Argentina/Buenos_Aires',
            label: 'UTC-03:00 (America/Argentina/Buenos_Aires)',
        },
        {
            value: 'America/Argentina/Catamarca',
            label: 'UTC-03:00 (America/Argentina/Catamarca)',
        },
        {
            value: 'America/Argentina/ComodRivadavia',
            label: 'UTC-03:00 (America/Argentina/ComodRivadavia)',
        },
        {
            value: 'America/Argentina/Cordoba',
            label: 'UTC-03:00 (America/Argentina/Cordoba)',
        },
        {
            value: 'America/Argentina/Jujuy',
            label: 'UTC-03:00 (America/Argentina/Jujuy)',
        },
        {
            value: 'America/Argentina/La_Rioja',
            label: 'UTC-03:00 (America/Argentina/La_Rioja)',
        },
        {
            value: 'America/Argentina/Mendoza',
            label: 'UTC-03:00 (America/Argentina/Mendoza)',
        },
        {
            value: 'America/Argentina/Rio_Gallegos',
            label: 'UTC-03:00 (America/Argentina/Rio_Gallegos)',
        },
        {
            value: 'America/Argentina/Salta',
            label: 'UTC-03:00 (America/Argentina/Salta)',
        },
        {
            value: 'America/Argentina/San_Juan',
            label: 'UTC-03:00 (America/Argentina/San_Juan)',
        },
        {
            value: 'America/Argentina/San_Luis',
            label: 'UTC-03:00 (America/Argentina/San_Luis)',
        },
        {
            value: 'America/Argentina/Tucuman',
            label: 'UTC-03:00 (America/Argentina/Tucuman)',
        },
        {
            value: 'America/Argentina/Ushuaia',
            label: 'UTC-03:00 (America/Argentina/Ushuaia)',
        },
        {
            value: 'America/Bahia',
            label: 'UTC-03:00 (America/Bahia)',
        },
        {
            value: 'America/Belem',
            label: 'UTC-03:00 (America/Belem)',
        },
        {
            value: 'America/Buenos_Aires',
            label: 'UTC-03:00 (America/Buenos_Aires)',
        },
        {
            value: 'America/Catamarca',
            label: 'UTC-03:00 (America/Catamarca)',
        },
        {
            value: 'America/Cayenne',
            label: 'UTC-03:00 (America/Cayenne)',
        },
        {
            value: 'America/Cordoba',
            label: 'UTC-03:00 (America/Cordoba)',
        },
        {
            value: 'America/Fortaleza',
            label: 'UTC-03:00 (America/Fortaleza)',
        },
        {
            value: 'America/Godthab',
            label: 'UTC-02:00 (America/Godthab)',
        },
        {
            value: 'America/Jujuy',
            label: 'UTC-03:00 (America/Jujuy)',
        },
        {
            value: 'America/Maceio',
            label: 'UTC-03:00 (America/Maceio)',
        },
        {
            value: 'America/Mendoza',
            label: 'UTC-03:00 (America/Mendoza)',
        },
        {
            value: 'America/Miquelon',
            label: 'UTC-03:00 (America/Miquelon)',
        },
        {
            value: 'America/Paramaribo',
            label: 'UTC-03:00 (America/Paramaribo)',
        },
        {
            value: 'America/Punta_Arenas',
            label: 'UTC-03:00 (America/Punta_Arenas)',
        },
        {
            value: 'America/Recife',
            label: 'UTC-03:00 (America/Recife)',
        },
        {
            value: 'America/Rosario',
            label: 'UTC-03:00 (America/Rosario)',
        },
        {
            value: 'America/Santarem',
            label: 'UTC-03:00 (America/Santarem)',
        },
        {
            value: 'America/Santiago',
            label: 'UTC-04:00 (America/Santiago)',
        },
        {
            value: 'America/Montevideo',
            label: 'UTC-03:00 (America/Montevideo)',
        },
        {
            value: 'America/Sao_Paulo',
            label: 'UTC-03:00 (America/Sao_Paulo)',
        },
        {
            value: 'Antarctica/Palmer',
            label: 'UTC-03:00 (Antarctica/Palmer)',
        },
        {
            value: 'Antarctica/Rothera',
            label: 'UTC-03:00 (Antarctica/Rothera)',
        },
        {
            value: 'Atlantic/Stanley',
            label: 'UTC-03:00 (Atlantic/Stanley)',
        },
        {
            value: 'Brazil/East',
            label: 'UTC-03:00 (Brazil/East)',
        },
        {
            value: 'Chile/Continental',
            label: 'UTC-04:00 (Chile/Continental)',
        },
        {
            value: 'Etc/GMT+3',
            label: 'UTC-03:00 (Etc/GMT+3)',
        },
        {
            value: 'America/Noronha',
            label: 'UTC-02:00 (America/Noronha)',
        },
        {
            value: 'Atlantic/South_Georgia',
            label: 'UTC-02:00 (Atlantic/South_Georgia)',
        },
        {
            value: 'Brazil/DeNoronha',
            label: 'UTC-02:00 (Brazil/DeNoronha)',
        },
        {
            value: 'Etc/GMT+2',
            label: 'UTC-02:00 (Etc/GMT+2)',
        },
        {
            value: 'America/Scoresbysund',
            label: 'UTC-02:00 (America/Scoresbysund)',
        },
        {
            value: 'Atlantic/Azores',
            label: 'UTC-01:00 (Atlantic/Azores)',
        },
        {
            value: 'Atlantic/Cape_Verde',
            label: 'UTC-01:00 (Atlantic/Cape_Verde)',
        },
        {
            value: 'Etc/GMT+1',
            label: 'UTC-01:00 (Etc/GMT+1)',
        },
        {
            value: 'Africa/Abidjan',
            label: 'UTC+00:00 (Africa/Abidjan)',
        },
        {
            value: 'Africa/Accra',
            label: 'UTC+00:00 (Africa/Accra)',
        },
        {
            value: 'Africa/Bamako',
            label: 'UTC+00:00 (Africa/Bamako)',
        },
        {
            value: 'Africa/Banjul',
            label: 'UTC+00:00 (Africa/Banjul)',
        },
        {
            value: 'Africa/Bissau',
            label: 'UTC+00:00 (Africa/Bissau)',
        },
        {
            value: 'Africa/Casablanca',
            label: 'UTC+00:00 (Africa/Casablanca)',
        },
        {
            value: 'Africa/Conakry',
            label: 'UTC+00:00 (Africa/Conakry)',
        },
        {
            value: 'Africa/Dakar',
            label: 'UTC+00:00 (Africa/Dakar)',
        },
        {
            value: 'Africa/Freetown',
            label: 'UTC+00:00 (Africa/Freetown)',
        },
        {
            value: 'Africa/Lome',
            label: 'UTC+00:00 (Africa/Lome)',
        },
        {
            value: 'Africa/Monrovia',
            label: 'UTC+00:00 (Africa/Monrovia)',
        },
        {
            value: 'Africa/Nouakchott',
            label: 'UTC+00:00 (Africa/Nouakchott)',
        },
        {
            value: 'Africa/Ouagadougou',
            label: 'UTC+00:00 (Africa/Ouagadougou)',
        },
        {
            value: 'Africa/Sao_Tome',
            label: 'UTC+00:00 (Africa/Sao_Tome)',
        },
        {
            value: 'Africa/Timbuktu',
            label: 'UTC+00:00 (Africa/Timbuktu)',
        },
        {
            value: 'America/Danmarkshavn',
            label: 'UTC+00:00 (America/Danmarkshavn)',
        },
        {
            value: 'Antarctica/Troll',
            label: 'UTC+00:00 (Antarctica/Troll)',
        },
        {
            value: 'Atlantic/Canary',
            label: 'UTC+00:00 (Atlantic/Canary)',
        },
        {
            value: 'Atlantic/Faeroe',
            label: 'UTC+00:00 (Atlantic/Faeroe)',
        },
        {
            value: 'Atlantic/Faroe',
            label: 'UTC+00:00 (Atlantic/Faroe)',
        },
        {
            value: 'Atlantic/Madeira',
            label: 'UTC+00:00 (Atlantic/Madeira)',
        },
        {
            value: 'Atlantic/Reykjavik',
            label: 'UTC+00:00 (Atlantic/Reykjavik)',
        },
        {
            value: 'Atlantic/St_Helena',
            label: 'UTC+00:00 (Atlantic/St_Helena)',
        },
        {
            value: 'Eire',
            label: 'UTC+00:00 (Eire)',
        },
        {
            value: 'Etc/GMT',
            label: 'UTC+00:00 (Etc/GMT)',
        },
        {
            value: 'Etc/GMT+0',
            label: 'UTC+00:00 (Etc/GMT+0)',
        },
        {
            value: 'Etc/GMT-0',
            label: 'UTC+00:00 (Etc/GMT-0)',
        },
        {
            value: 'Etc/GMT0',
            label: 'UTC+00:00 (Etc/GMT0)',
        },
        {
            value: 'Etc/Greenwich',
            label: 'UTC+00:00 (Etc/Greenwich)',
        },
        {
            value: 'Etc/UCT',
            label: 'UTC+00:00 (Etc/UCT)',
        },
        {
            value: 'Etc/UTC',
            label: 'UTC+00:00 (Etc/UTC)',
        },
        {
            value: 'Etc/Universal',
            label: 'UTC+00:00 (Etc/Universal)',
        },
        {
            value: 'Etc/Zulu',
            label: 'UTC+00:00 (Etc/Zulu)',
        },
        {
            value: 'Europe/Belfast',
            label: 'UTC+00:00 (Europe/Belfast)',
        },
        {
            value: 'Europe/Dublin',
            label: 'UTC+00:00 (Europe/Dublin)',
        },
        {
            value: 'Europe/Guernsey',
            label: 'UTC+00:00 (Europe/Guernsey)',
        },
        {
            value: 'Europe/Isle_of_Man',
            label: 'UTC+00:00 (Europe/Isle_of_Man)',
        },
        {
            value: 'Europe/Jersey',
            label: 'UTC+00:00 (Europe/Jersey)',
        },
        {
            value: 'Europe/Lisbon',
            label: 'UTC+00:00 (Europe/Lisbon)',
        },
        {
            value: 'Europe/London',
            label: 'UTC+00:00 (Europe/London)',
        },
        {
            value: 'GB-Eire',
            label: 'UTC+00:00 (GB-Eire)',
        },
        {
            value: 'GB',
            label: 'UTC+00:00 (GB)',
        },
        {
            value: 'GMT+0',
            label: 'UTC+00:00 (GMT+0)',
        },
        {
            value: 'GMT-0',
            label: 'UTC+00:00 (GMT-0)',
        },
        {
            value: 'GMT0',
            label: 'UTC+00:00 (GMT0)',
        },
        {
            value: 'GMT',
            label: 'UTC+00:00 (GMT)',
        },
        {
            value: 'Greenwich',
            label: 'UTC+00:00 (Greenwich)',
        },
        {
            value: 'Iceland',
            label: 'UTC+00:00 (Iceland)',
        },
        {
            value: 'Portugal',
            label: 'UTC+00:00 (Portugal)',
        },
        {
            value: 'UCT',
            label: 'UTC+00:00 (UCT)',
        },
        {
            value: 'UTC',
            label: 'UTC+00:00 (UTC)',
        },
        {
            value: 'Universal',
            label: 'UTC+00:00 (Universal)',
        },
        {
            value: 'WET',
            label: 'UTC+00:00 (WET)',
        },
        {
            value: 'Zulu',
            label: 'UTC+00:00 (Zulu)',
        },
        {
            value: 'Africa/Algiers',
            label: 'UTC+01:00 (Africa/Algiers)',
        },
        {
            value: 'Africa/Bangui',
            label: 'UTC+01:00 (Africa/Bangui)',
        },
        {
            value: 'Africa/Brazzaville',
            label: 'UTC+01:00 (Africa/Brazzaville)',
        },
        {
            value: 'Africa/Ceuta',
            label: 'UTC+01:00 (Africa/Ceuta)',
        },
        {
            value: 'Africa/Douala',
            label: 'UTC+01:00 (Africa/Douala)',
        },
        {
            value: 'Africa/Kinshasa',
            label: 'UTC+01:00 (Africa/Kinshasa)',
        },
        {
            value: 'Africa/Lagos',
            label: 'UTC+01:00 (Africa/Lagos)',
        },
        {
            value: 'Africa/Libreville',
            label: 'UTC+01:00 (Africa/Libreville)',
        },
        {
            value: 'Africa/Luanda',
            label: 'UTC+01:00 (Africa/Luanda)',
        },
        {
            value: 'Africa/Malabo',
            label: 'UTC+01:00 (Africa/Malabo)',
        },
        {
            value: 'Africa/Ndjamena',
            label: 'UTC+01:00 (Africa/Ndjamena)',
        },
        {
            value: 'Africa/Niamey',
            label: 'UTC+01:00 (Africa/Niamey)',
        },
        {
            value: 'Africa/Porto-Novo',
            label: 'UTC+01:00 (Africa/Porto-Novo)',
        },
        {
            value: 'Africa/Tunis',
            label: 'UTC+01:00 (Africa/Tunis)',
        },
        {
            value: 'Arctic/Longyearbyen',
            label: 'UTC+01:00 (Arctic/Longyearbyen)',
        },
        {
            value: 'Africa/Windhoek',
            label: 'UTC+02:00 (Africa/Windhoek)',
        },
        {
            value: 'Atlantic/Jan_Mayen',
            label: 'UTC+01:00 (Atlantic/Jan_Mayen)',
        },
        {
            value: 'CET',
            label: 'UTC+01:00 (CET)',
        },
        {
            value: 'Etc/GMT-1',
            label: 'UTC+01:00 (Etc/GMT-1)',
        },
        {
            value: 'Europe/Amsterdam',
            label: 'UTC+01:00 (Europe/Amsterdam)',
        },
        {
            value: 'Europe/Andorra',
            label: 'UTC+01:00 (Europe/Andorra)',
        },
        {
            value: 'Europe/Belgrade',
            label: 'UTC+01:00 (Europe/Belgrade)',
        },
        {
            value: 'Europe/Berlin',
            label: 'UTC+01:00 (Europe/Berlin)',
        },
        {
            value: 'Europe/Bratislava',
            label: 'UTC+01:00 (Europe/Bratislava)',
        },
        {
            value: 'Europe/Brussels',
            label: 'UTC+01:00 (Europe/Brussels)',
        },
        {
            value: 'Europe/Budapest',
            label: 'UTC+01:00 (Europe/Budapest)',
        },
        {
            value: 'Europe/Busingen',
            label: 'UTC+01:00 (Europe/Busingen)',
        },
        {
            value: 'Europe/Copenhagen',
            label: 'UTC+01:00 (Europe/Copenhagen)',
        },
        {
            value: 'Europe/Gibraltar',
            label: 'UTC+01:00 (Europe/Gibraltar)',
        },
        {
            value: 'Europe/Ljubljana',
            label: 'UTC+01:00 (Europe/Ljubljana)',
        },
        {
            value: 'Europe/Luxembourg',
            label: 'UTC+01:00 (Europe/Luxembourg)',
        },
        {
            value: 'Europe/Madrid',
            label: 'UTC+01:00 (Europe/Madrid)',
        },
        {
            value: 'Europe/Malta',
            label: 'UTC+01:00 (Europe/Malta)',
        },
        {
            value: 'Europe/Monaco',
            label: 'UTC+01:00 (Europe/Monaco)',
        },
        {
            value: 'Europe/Oslo',
            label: 'UTC+01:00 (Europe/Oslo)',
        },
        {
            value: 'Europe/Paris',
            label: 'UTC+01:00 (Europe/Paris)',
        },
        {
            value: 'Europe/Podgorica',
            label: 'UTC+01:00 (Europe/Podgorica)',
        },
        {
            value: 'Europe/Prague',
            label: 'UTC+01:00 (Europe/Prague)',
        },
        {
            value: 'Europe/Rome',
            label: 'UTC+01:00 (Europe/Rome)',
        },
        {
            value: 'Europe/San_Marino',
            label: 'UTC+01:00 (Europe/San_Marino)',
        },
        {
            value: 'Europe/Sarajevo',
            label: 'UTC+01:00 (Europe/Sarajevo)',
        },
        {
            value: 'Europe/Skopje',
            label: 'UTC+01:00 (Europe/Skopje)',
        },
        {
            value: 'Europe/Stockholm',
            label: 'UTC+01:00 (Europe/Stockholm)',
        },
        {
            value: 'Europe/Tirane',
            label: 'UTC+01:00 (Europe/Tirane)',
        },
        {
            value: 'Europe/Vaduz',
            label: 'UTC+01:00 (Europe/Vaduz)',
        },
        {
            value: 'Europe/Vatican',
            label: 'UTC+01:00 (Europe/Vatican)',
        },
        {
            value: 'Europe/Vienna',
            label: 'UTC+01:00 (Europe/Vienna)',
        },
        {
            value: 'Europe/Warsaw',
            label: 'UTC+01:00 (Europe/Warsaw)',
        },
        {
            value: 'Europe/Zagreb',
            label: 'UTC+01:00 (Europe/Zagreb)',
        },
        {
            value: 'Europe/Zurich',
            label: 'UTC+01:00 (Europe/Zurich)',
        },
        {
            value: 'MET',
            label: 'UTC+01:00 (MET)',
        },
        {
            value: 'Poland',
            label: 'UTC+01:00 (Poland)',
        },
        {
            value: 'Africa/Blantyre',
            label: 'UTC+02:00 (Africa/Blantyre)',
        },
        {
            value: 'Africa/Bujumbura',
            label: 'UTC+02:00 (Africa/Bujumbura)',
        },
        {
            value: 'Africa/Cairo',
            label: 'UTC+02:00 (Africa/Cairo)',
        },
        {
            value: 'Africa/Gaborone',
            label: 'UTC+02:00 (Africa/Gaborone)',
        },
        {
            value: 'Africa/Harare',
            label: 'UTC+02:00 (Africa/Harare)',
        },
        {
            value: 'Africa/Johannesburg',
            label: 'UTC+02:00 (Africa/Johannesburg)',
        },
        {
            value: 'Africa/Kigali',
            label: 'UTC+02:00 (Africa/Kigali)',
        },
        {
            value: 'Africa/Lubumbashi',
            label: 'UTC+02:00 (Africa/Lubumbashi)',
        },
        {
            value: 'Africa/Lusaka',
            label: 'UTC+02:00 (Africa/Lusaka)',
        },
        {
            value: 'Africa/Maputo',
            label: 'UTC+02:00 (Africa/Maputo)',
        },
        {
            value: 'Africa/Maseru',
            label: 'UTC+02:00 (Africa/Maseru)',
        },
        {
            value: 'Africa/Mbabane',
            label: 'UTC+02:00 (Africa/Mbabane)',
        },
        {
            value: 'Africa/Tripoli',
            label: 'UTC+02:00 (Africa/Tripoli)',
        },
        {
            value: 'Asia/Amman',
            label: 'UTC+03:00 (Asia/Amman)',
        },
        {
            value: 'Asia/Beirut',
            label: 'UTC+02:00 (Asia/Beirut)',
        },
        {
            value: 'Asia/Damascus',
            label: 'UTC+03:00 (Asia/Damascus)',
        },
        {
            value: 'Asia/Gaza',
            label: 'UTC+02:00 (Asia/Gaza)',
        },
        {
            value: 'Asia/Hebron',
            label: 'UTC+02:00 (Asia/Hebron)',
        },
        {
            value: 'Asia/Istanbul',
            label: 'UTC+03:00 (Asia/Istanbul)',
        },
        {
            value: 'Asia/Jerusalem',
            label: 'UTC+02:00 (Asia/Jerusalem)',
        },
        {
            value: 'Asia/Nicosia',
            label: 'UTC+02:00 (Asia/Nicosia)',
        },
        {
            value: 'Asia/Tel_Aviv',
            label: 'UTC+02:00 (Asia/Tel_Aviv)',
        },
        {
            value: 'EET',
            label: 'UTC+02:00 (EET)',
        },
        {
            value: 'Egypt',
            label: 'UTC+02:00 (Egypt)',
        },
        {
            value: 'Etc/GMT-2',
            label: 'UTC+02:00 (Etc/GMT-2)',
        },
        {
            value: 'Europe/Athens',
            label: 'UTC+02:00 (Europe/Athens)',
        },
        {
            value: 'Asia/Famagusta',
            label: 'UTC+02:00 (Asia/Famagusta)',
        },
        {
            value: 'Europe/Bucharest',
            label: 'UTC+02:00 (Europe/Bucharest)',
        },
        {
            value: 'Europe/Chisinau',
            label: 'UTC+02:00 (Europe/Chisinau)',
        },
        {
            value: 'Europe/Helsinki',
            label: 'UTC+02:00 (Europe/Helsinki)',
        },
        {
            value: 'Europe/Istanbul',
            label: 'UTC+03:00 (Europe/Istanbul)',
        },
        {
            value: 'Europe/Kaliningrad',
            label: 'UTC+02:00 (Europe/Kaliningrad)',
        },
        {
            value: 'Europe/Kiev',
            label: 'UTC+02:00 (Europe/Kiev)',
        },
        {
            value: 'Europe/Mariehamn',
            label: 'UTC+02:00 (Europe/Mariehamn)',
        },
        {
            value: 'Europe/Nicosia',
            label: 'UTC+02:00 (Europe/Nicosia)',
        },
        {
            value: 'Europe/Riga',
            label: 'UTC+02:00 (Europe/Riga)',
        },
        {
            value: 'Europe/Sofia',
            label: 'UTC+02:00 (Europe/Sofia)',
        },
        {
            value: 'Europe/Tallinn',
            label: 'UTC+02:00 (Europe/Tallinn)',
        },
        {
            value: 'Europe/Tiraspol',
            label: 'UTC+02:00 (Europe/Tiraspol)',
        },
        {
            value: 'Europe/Uzhgorod',
            label: 'UTC+02:00 (Europe/Uzhgorod)',
        },
        {
            value: 'Europe/Vilnius',
            label: 'UTC+02:00 (Europe/Vilnius)',
        },
        {
            value: 'Europe/Zaporozhye',
            label: 'UTC+02:00 (Europe/Zaporozhye)',
        },
        {
            value: 'Libya',
            label: 'UTC+02:00 (Libya)',
        },
        {
            value: 'Turkey',
            label: 'UTC+03:00 (Turkey)',
        },
        {
            value: 'Africa/Addis_Ababa',
            label: 'UTC+03:00 (Africa/Addis_Ababa)',
        },
        {
            value: 'Africa/Asmara',
            label: 'UTC+03:00 (Africa/Asmara)',
        },
        {
            value: 'Africa/Asmera',
            label: 'UTC+03:00 (Africa/Asmera)',
        },
        {
            value: 'Africa/Dar_es_Salaam',
            label: 'UTC+03:00 (Africa/Dar_es_Salaam)',
        },
        {
            value: 'Africa/Djibouti',
            label: 'UTC+03:00 (Africa/Djibouti)',
        },
        {
            value: 'Africa/Juba',
            label: 'UTC+02:00 (Africa/Juba)',
        },
        {
            value: 'Africa/Kampala',
            label: 'UTC+03:00 (Africa/Kampala)',
        },
        {
            value: 'Africa/Khartoum',
            label: 'UTC+02:00 (Africa/Khartoum)',
        },
        {
            value: 'Africa/Mogadishu',
            label: 'UTC+03:00 (Africa/Mogadishu)',
        },
        {
            value: 'Africa/Nairobi',
            label: 'UTC+03:00 (Africa/Nairobi)',
        },
        {
            value: 'Antarctica/Syowa',
            label: 'UTC+03:00 (Antarctica/Syowa)',
        },
        {
            value: 'Asia/Aden',
            label: 'UTC+03:00 (Asia/Aden)',
        },
        {
            value: 'Asia/Baghdad',
            label: 'UTC+03:00 (Asia/Baghdad)',
        },
        {
            value: 'Asia/Bahrain',
            label: 'UTC+03:00 (Asia/Bahrain)',
        },
        {
            value: 'Asia/Kuwait',
            label: 'UTC+03:00 (Asia/Kuwait)',
        },
        {
            value: 'Asia/Qatar',
            label: 'UTC+03:00 (Asia/Qatar)',
        },
        {
            value: 'Asia/Riyadh',
            label: 'UTC+03:00 (Asia/Riyadh)',
        },
        {
            value: 'Etc/GMT-3',
            label: 'UTC+03:00 (Etc/GMT-3)',
        },
        {
            value: 'Europe/Kirov',
            label: 'UTC+03:00 (Europe/Kirov)',
        },
        {
            value: 'Europe/Minsk',
            label: 'UTC+03:00 (Europe/Minsk)',
        },
        {
            value: 'Europe/Moscow',
            label: 'UTC+03:00 (Europe/Moscow)',
        },
        {
            value: 'Europe/Simferopol',
            label: 'UTC+03:00 (Europe/Simferopol)',
        },
        {
            value: 'Europe/Volgograd',
            label: 'UTC+03:00 (Europe/Volgograd)',
        },
        {
            value: 'Indian/Antananarivo',
            label: 'UTC+03:00 (Indian/Antananarivo)',
        },
        {
            value: 'Indian/Comoro',
            label: 'UTC+03:00 (Indian/Comoro)',
        },
        {
            value: 'Indian/Mayotte',
            label: 'UTC+03:00 (Indian/Mayotte)',
        },
        {
            value: 'W-SU',
            label: 'UTC+03:00 (W-SU)',
        },
        {
            value: 'Asia/Tehran',
            label: 'UTC+03:30 (Asia/Tehran)',
        },
        {
            value: 'Iran',
            label: 'UTC+03:30 (Iran)',
        },
        {
            value: 'Asia/Baku',
            label: 'UTC+04:00 (Asia/Baku)',
        },
        {
            value: 'Asia/Dubai',
            label: 'UTC+04:00 (Asia/Dubai)',
        },
        {
            value: 'Asia/Muscat',
            label: 'UTC+04:00 (Asia/Muscat)',
        },
        {
            value: 'Asia/Tbilisi',
            label: 'UTC+04:00 (Asia/Tbilisi)',
        },
        {
            value: 'Asia/Yerevan',
            label: 'UTC+04:00 (Asia/Yerevan)',
        },
        {
            value: 'Europe/Astrakhan',
            label: 'UTC+04:00 (Europe/Astrakhan)',
        },
        {
            value: 'Etc/GMT-4',
            label: 'UTC+04:00 (Etc/GMT-4)',
        },
        {
            value: 'Europe/Samara',
            label: 'UTC+04:00 (Europe/Samara)',
        },
        {
            value: 'Europe/Saratov',
            label: 'UTC+04:00 (Europe/Saratov)',
        },
        {
            value: 'Europe/Ulyanovsk',
            label: 'UTC+04:00 (Europe/Ulyanovsk)',
        },
        {
            value: 'Indian/Mahe',
            label: 'UTC+04:00 (Indian/Mahe)',
        },
        {
            value: 'Indian/Mauritius',
            label: 'UTC+04:00 (Indian/Mauritius)',
        },
        {
            value: 'Indian/Reunion',
            label: 'UTC+04:00 (Indian/Reunion)',
        },
        {
            value: 'Asia/Kabul',
            label: 'UTC+04:30 (Asia/Kabul)',
        },
        {
            value: 'Antarctica/Mawson',
            label: 'UTC+05:00 (Antarctica/Mawson)',
        },
        {
            value: 'Asia/Aqtau',
            label: 'UTC+05:00 (Asia/Aqtau)',
        },
        {
            value: 'Asia/Aqtobe',
            label: 'UTC+05:00 (Asia/Aqtobe)',
        },
        {
            value: 'Asia/Ashgabat',
            label: 'UTC+05:00 (Asia/Ashgabat)',
        },
        {
            value: 'Asia/Ashkhabad',
            label: 'UTC+05:00 (Asia/Ashkhabad)',
        },
        {
            value: 'Asia/Dushanbe',
            label: 'UTC+05:00 (Asia/Dushanbe)',
        },
        {
            value: 'Asia/Karachi',
            label: 'UTC+05:00 (Asia/Karachi)',
        },
        {
            value: 'Asia/Oral',
            label: 'UTC+05:00 (Asia/Oral)',
        },
        {
            value: 'Asia/Samarkand',
            label: 'UTC+05:00 (Asia/Samarkand)',
        },
        {
            value: 'Asia/Tashkent',
            label: 'UTC+05:00 (Asia/Tashkent)',
        },
        {
            value: 'Asia/Yekaterinburg',
            label: 'UTC+05:00 (Asia/Yekaterinburg)',
        },
        {
            value: 'Asia/Atyrau',
            label: 'UTC+05:00 (Asia/Atyrau)',
        },
        {
            value: 'Etc/GMT-5',
            label: 'UTC+05:00 (Etc/GMT-5)',
        },
        {
            value: 'Indian/Kerguelen',
            label: 'UTC+05:00 (Indian/Kerguelen)',
        },
        {
            value: 'Indian/Maldives',
            label: 'UTC+05:00 (Indian/Maldives)',
        },
        {
            value: 'Antarctica/Vostok',
            label: 'UTC+05:00 (Antarctica/Vostok)',
        },
        {
            value: 'Asia/Almaty',
            label: 'UTC+05:00 (Asia/Almaty)',
        },
        {
            value: 'Asia/Calcutta',
            label: 'UTC+05:30 (Asia/Calcutta)',
        },
        {
            value: 'Asia/Colombo',
            label: 'UTC+05:30 (Asia/Colombo)',
        },
        {
            value: 'Asia/Kolkata',
            label: 'UTC+05:30 (Asia/Kolkata)',
        },
        {
            value: 'Asia/Kathmandu',
            label: 'UTC+05:45 (Asia/Kathmandu)',
        },
        {
            value: 'Asia/Katmandu',
            label: 'UTC+05:45 (Asia/Katmandu)',
        },
        {
            value: 'Asia/Bishkek',
            label: 'UTC+06:00 (Asia/Bishkek)',
        },
        {
            value: 'Asia/Dacca',
            label: 'UTC+06:00 (Asia/Dacca)',
        },
        {
            value: 'Asia/Dhaka',
            label: 'UTC+06:00 (Asia/Dhaka)',
        },
        {
            value: 'Asia/Kashgar',
            label: 'UTC+06:00 (Asia/Kashgar)',
        },
        {
            value: 'Asia/Novosibirsk',
            label: 'UTC+07:00 (Asia/Novosibirsk)',
        },
        {
            value: 'Asia/Omsk',
            label: 'UTC+06:00 (Asia/Omsk)',
        },
        {
            value: 'Asia/Qyzylorda',
            label: 'UTC+05:00 (Asia/Qyzylorda)',
        },
        {
            value: 'Asia/Thimbu',
            label: 'UTC+06:00 (Asia/Thimbu)',
        },
        {
            value: 'Asia/Thimphu',
            label: 'UTC+06:00 (Asia/Thimphu)',
        },
        {
            value: 'Asia/Urumqi',
            label: 'UTC+06:00 (Asia/Urumqi)',
        },
        {
            value: 'Etc/GMT-6',
            label: 'UTC+06:00 (Etc/GMT-6)',
        },
        {
            value: 'Indian/Chagos',
            label: 'UTC+06:00 (Indian/Chagos)',
        },
        {
            value: 'Asia/Rangoon',
            label: 'UTC+06:30 (Asia/Rangoon)',
        },
        {
            value: 'Asia/Yangon',
            label: 'UTC+06:30 (Asia/Yangon)',
        },
        {
            value: 'Indian/Cocos',
            label: 'UTC+06:30 (Indian/Cocos)',
        },
        {
            value: 'Antarctica/Davis',
            label: 'UTC+07:00 (Antarctica/Davis)',
        },
        {
            value: 'Asia/Bangkok',
            label: 'UTC+07:00 (Asia/Bangkok)',
        },
        {
            value: 'Asia/Barnaul',
            label: 'UTC+07:00 (Asia/Barnaul)',
        },
        {
            value: 'Asia/Ho_Chi_Minh',
            label: 'UTC+07:00 (Asia/Ho_Chi_Minh)',
        },
        {
            value: 'Asia/Hovd',
            label: 'UTC+07:00 (Asia/Hovd)',
        },
        {
            value: 'Asia/Jakarta',
            label: 'UTC+07:00 (Asia/Jakarta)',
        },
        {
            value: 'Asia/Krasnoyarsk',
            label: 'UTC+07:00 (Asia/Krasnoyarsk)',
        },
        {
            value: 'Asia/Novokuznetsk',
            label: 'UTC+07:00 (Asia/Novokuznetsk)',
        },
        {
            value: 'Asia/Phnom_Penh',
            label: 'UTC+07:00 (Asia/Phnom_Penh)',
        },
        {
            value: 'Asia/Pontianak',
            label: 'UTC+07:00 (Asia/Pontianak)',
        },
        {
            value: 'Asia/Saigon',
            label: 'UTC+07:00 (Asia/Saigon)',
        },
        {
            value: 'Asia/Tomsk',
            label: 'UTC+07:00 (Asia/Tomsk)',
        },
        {
            value: 'Asia/Vientiane',
            label: 'UTC+07:00 (Asia/Vientiane)',
        },
        {
            value: 'Etc/GMT-7',
            label: 'UTC+07:00 (Etc/GMT-7)',
        },
        {
            value: 'Indian/Christmas',
            label: 'UTC+07:00 (Indian/Christmas)',
        },
        {
            value: 'PRC',
            label: 'UTC+08:00 (PRC)',
        },
        {
            value: 'Antarctica/Casey',
            label: 'UTC+08:00 (Antarctica/Casey)',
        },
        {
            value: 'Asia/Beijing',
            label: 'UTC+08:00 (Asia/Beijing)',
        },
        {
            value: 'Asia/Brunei',
            label: 'UTC+08:00 (Asia/Brunei)',
        },
        {
            value: 'Asia/Chita',
            label: 'UTC+09:00 (Asia/Chita)',
        },
        {
            value: 'Asia/Choibalsan',
            label: 'UTC+08:00 (Asia/Choibalsan)',
        },
        {
            value: 'Asia/Chongqing',
            label: 'UTC+08:00 (Asia/Chongqing)',
        },
        {
            value: 'Asia/Chungking',
            label: 'UTC+08:00 (Asia/Chungking)',
        },
        {
            value: 'Asia/Harbin',
            label: 'UTC+08:00 (Asia/Harbin)',
        },
        {
            value: 'Asia/Irkutsk',
            label: 'UTC+08:00 (Asia/Irkutsk)',
        },
        {
            value: 'Asia/Kuala_Lumpur',
            label: 'UTC+08:00 (Asia/Kuala_Lumpur)',
        },
        {
            value: 'Asia/Kuching',
            label: 'UTC+08:00 (Asia/Kuching)',
        },
        {
            value: 'Asia/Makassar',
            label: 'UTC+08:00 (Asia/Makassar)',
        },
        {
            value: 'Asia/Manila',
            label: 'UTC+08:00 (Asia/Manila)',
        },
        {
            value: 'Asia/Hong_Kong',
            label: 'UTC+08:00 (Asia/Hong Kong)',
        },
        {
            value: 'Asia/Macao',
            label: 'UTC+08:00 (Asia/Macao)',
        },
        {
            value: 'Asia/Taipei',
            label: 'UTC+08:00 (Asia/Taipei)',
        },
        {
            value: 'Asia/Shanghai',
            label: 'UTC+08:00 (Asia/Shanghai)',
        },
        {
            value: 'Asia/Singapore',
            label: 'UTC+08:00 (Asia/Singapore)',
        },
        {
            value: 'Asia/Ujung_Pandang',
            label: 'UTC+08:00 (Asia/Ujung_Pandang)',
        },
        {
            value: 'Asia/Ulaanbaatar',
            label: 'UTC+08:00 (Asia/Ulaanbaatar)',
        },
        {
            value: 'Asia/Ulan_Bator',
            label: 'UTC+08:00 (Asia/Ulan_Bator)',
        },
        {
            value: 'Australia/Perth',
            label: 'UTC+08:00 (Australia/Perth)',
        },
        {
            value: 'Australia/West',
            label: 'UTC+08:00 (Australia/West)',
        },
        {
            value: 'Etc/GMT-8',
            label: 'UTC+08:00 (Etc/GMT-8)',
        },
        {
            value: 'Singapore',
            label: 'UTC+08:00 (Singapore)',
        },
        {
            value: 'Australia/Eucla',
            label: 'UTC+08:45 (Australia/Eucla)',
        },
        {
            value: 'Asia/Dili',
            label: 'UTC+09:00 (Asia/Dili)',
        },
        {
            value: 'Asia/Jayapura',
            label: 'UTC+09:00 (Asia/Jayapura)',
        },
        {
            value: 'Asia/Khandyga',
            label: 'UTC+09:00 (Asia/Khandyga)',
        },
        {
            value: 'Asia/Pyongyang',
            label: 'UTC+09:00 (Asia/Pyongyang)',
        },
        {
            value: 'Asia/Seoul',
            label: 'UTC+09:00 (Asia/Seoul)',
        },
        {
            value: 'Asia/Tokyo',
            label: 'UTC+09:00 (Asia/Tokyo)',
        },
        {
            value: 'Asia/Yakutsk',
            label: 'UTC+09:00 (Asia/Yakutsk)',
        },
        {
            value: 'Etc/GMT-9',
            label: 'UTC+09:00 (Etc/GMT-9)',
        },
        {
            value: 'Japan',
            label: 'UTC+09:00 (Japan)',
        },
        {
            value: 'Pacific/Palau',
            label: 'UTC+09:00 (Pacific/Palau)',
        },
        {
            value: 'ROK',
            label: 'UTC+09:00 (ROK)',
        },
        {
            value: 'Australia/Darwin',
            label: 'UTC+09:30 (Australia/Darwin)',
        },
        {
            value: 'Australia/North',
            label: 'UTC+09:30 (Australia/North)',
        },
        {
            value: 'Australia/Adelaide',
            label: 'UTC+09:30 (Australia/Adelaide)',
        },
        {
            value: 'Australia/Broken_Hill',
            label: 'UTC+09:30 (Australia/Broken_Hill)',
        },
        {
            value: 'Australia/South',
            label: 'UTC+09:30 (Australia/South)',
        },
        {
            value: 'Australia/Yancowinna',
            label: 'UTC+09:30 (Australia/Yancowinna)',
        },
        {
            value: 'Antarctica/DumontDUrville',
            label: 'UTC+10:00 (Antarctica/DumontDUrville)',
        },
        {
            value: 'Asia/Magadan',
            label: 'UTC+11:00 (Asia/Magadan)',
        },
        {
            value: 'Asia/Sakhalin',
            label: 'UTC+11:00 (Asia/Sakhalin)',
        },
        {
            value: 'Asia/Ust-Nera',
            label: 'UTC+10:00 (Asia/Ust-Nera)',
        },
        {
            value: 'Asia/Vladivostok',
            label: 'UTC+10:00 (Asia/Vladivostok)',
        },
        {
            value: 'Australia/Brisbane',
            label: 'UTC+10:00 (Australia/Brisbane)',
        },
        {
            value: 'Australia/Lindeman',
            label: 'UTC+10:00 (Australia/Lindeman)',
        },
        {
            value: 'Australia/Queensland',
            label: 'UTC+10:00 (Australia/Queensland)',
        },
        {
            value: 'Australia/ACT',
            label: 'UTC+10:00 (Australia/ACT)',
        },
        {
            value: 'Australia/Canberra',
            label: 'UTC+10:00 (Australia/Canberra)',
        },
        {
            value: 'Australia/Currie',
            label: 'UTC+10:00 (Australia/Currie)',
        },
        {
            value: 'Australia/Hobart',
            label: 'UTC+10:00 (Australia/Hobart)',
        },
        {
            value: 'Australia/Melbourne',
            label: 'UTC+10:00 (Australia/Melbourne)',
        },
        {
            value: 'Australia/NSW',
            label: 'UTC+10:00 (Australia/NSW)',
        },
        {
            value: 'Australia/Sydney',
            label: 'UTC+10:00 (Australia/Sydney)',
        },
        {
            value: 'Australia/Tasmania',
            label: 'UTC+10:00 (Australia/Tasmania)',
        },
        {
            value: 'Australia/Victoria',
            label: 'UTC+10:00 (Australia/Victoria)',
        },
        {
            value: 'Etc/GMT-10',
            label: 'UTC+10:00 (Etc/GMT-10)',
        },
        {
            value: 'Pacific/Chuuk',
            label: 'UTC+10:00 (Pacific/Chuuk)',
        },
        {
            value: 'Pacific/Guam',
            label: 'UTC+10:00 (Pacific/Guam)',
        },
        {
            value: 'Pacific/Port_Moresby',
            label: 'UTC+10:00 (Pacific/Port_Moresby)',
        },
        {
            value: 'Pacific/Saipan',
            label: 'UTC+10:00 (Pacific/Saipan)',
        },
        {
            value: 'Pacific/Truk',
            label: 'UTC+10:00 (Pacific/Truk)',
        },
        {
            value: 'Pacific/Yap',
            label: 'UTC+10:00 (Pacific/Yap)',
        },
        {
            value: 'Australia/LHI',
            label: 'UTC+10:30 (Australia/LHI)',
        },
        {
            value: 'Australia/Lord_Howe',
            label: 'UTC+10:30 (Australia/Lord_Howe)',
        },
        {
            value: 'Antarctica/Macquarie',
            label: 'UTC+10:00 (Antarctica/Macquarie)',
        },
        {
            value: 'Asia/Srednekolymsk',
            label: 'UTC+11:00 (Asia/Srednekolymsk)',
        },
        {
            value: 'Etc/GMT-11',
            label: 'UTC+11:00 (Etc/GMT-11)',
        },
        {
            value: 'Pacific/Bougainville',
            label: 'UTC+11:00 (Pacific/Bougainville)',
        },
        {
            value: 'Pacific/Efate',
            label: 'UTC+11:00 (Pacific/Efate)',
        },
        {
            value: 'Pacific/Guadalcanal',
            label: 'UTC+11:00 (Pacific/Guadalcanal)',
        },
        {
            value: 'Pacific/Kosrae',
            label: 'UTC+11:00 (Pacific/Kosrae)',
        },
        {
            value: 'Pacific/Noumea',
            label: 'UTC+11:00 (Pacific/Noumea)',
        },
        {
            value: 'Pacific/Pohnpei',
            label: 'UTC+11:00 (Pacific/Pohnpei)',
        },
        {
            value: 'Pacific/Ponape',
            label: 'UTC+11:00 (Pacific/Ponape)',
        },
        {
            value: 'Pacific/Norfolk',
            label: 'UTC+11:00 (Pacific/Norfolk)',
        },
        {
            value: 'Asia/Anadyr',
            label: 'UTC+12:00 (Asia/Anadyr)',
        },
        {
            value: 'Asia/Kamchatka',
            label: 'UTC+12:00 (Asia/Kamchatka)',
        },
        {
            value: 'Etc/GMT-12',
            label: 'UTC+12:00 (Etc/GMT-12)',
        },
        {
            value: 'Kwajalein',
            label: 'UTC+12:00 (Kwajalein)',
        },
        {
            value: 'Pacific/Fiji',
            label: 'UTC+12:00 (Pacific/Fiji)',
        },
        {
            value: 'Pacific/Funafuti',
            label: 'UTC+12:00 (Pacific/Funafuti)',
        },
        {
            value: 'Pacific/Kwajalein',
            label: 'UTC+12:00 (Pacific/Kwajalein)',
        },
        {
            value: 'Pacific/Majuro',
            label: 'UTC+12:00 (Pacific/Majuro)',
        },
        {
            value: 'Pacific/Nauru',
            label: 'UTC+12:00 (Pacific/Nauru)',
        },
        {
            value: 'Pacific/Tarawa',
            label: 'UTC+12:00 (Pacific/Tarawa)',
        },
        {
            value: 'Pacific/Wake',
            label: 'UTC+12:00 (Pacific/Wake)',
        },
        {
            value: 'Pacific/Wallis',
            label: 'UTC+12:00 (Pacific/Wallis)',
        },
        {
            value: 'Pacific/Auckland',
            label: 'UTC+12:00 (Pacific/Auckland)',
        },
        {
            value: 'Antarctica/McMurdo',
            label: 'UTC+12:00 (Antarctica/McMurdo)',
        },
        {
            value: 'Antarctica/South_Pole',
            label: 'UTC+12:00 (Antarctica/South_Pole)',
        },
        {
            value: 'NZ',
            label: 'UTC+12:00 (NZ)',
        },
        {
            value: 'Pacific/Chatham',
            label: 'UTC+12:45 (Pacific/Chatham)',
        },
        {
            value: 'NZ-CHAT',
            label: 'UTC+12:45 (NZ-CHAT)',
        },
        {
            value: 'Etc/GMT-13',
            label: 'UTC+13:00 (Etc/GMT-13)',
        },
        {
            value: 'Pacific/Enderbury',
            label: 'UTC+13:00 (Pacific/Enderbury)',
        },
        {
            value: 'Pacific/Fakaofo',
            label: 'UTC+13:00 (Pacific/Fakaofo)',
        },
        {
            value: 'Pacific/Tongatapu',
            label: 'UTC+13:00 (Pacific/Tongatapu)',
        },
        {
            value: 'Pacific/Apia',
            label: 'UTC+13:00 (Pacific/Apia)',
        },
        {
            value: 'Etc/GMT-14',
            label: 'UTC+14:00 (Etc/GMT-14)',
        },
        {
            value: 'Pacific/Kiritimati',
            label: 'UTC+14:00 (Pacific/Kiritimati)',
        },
    ],
    ja: [
        {
            value: 'Etc/GMT+12',
            label: 'UTC-12:00 (Etc/GMT+12)',
        },
        {
            value: 'Etc/GMT+11',
            label: 'UTC-11:00 (Etc/GMT+11)',
        },
        {
            value: 'Pacific/Midway',
            label: 'UTC-11:00 (太平洋/ミッドウェイ)',
        },
        {
            value: 'Pacific/Niue',
            label: 'UTC-11:00 (太平洋/ニウエ島)',
        },
        {
            value: 'Pacific/Pago_Pago',
            label: 'UTC-11:00 (太平洋/パゴパゴ)',
        },
        {
            value: 'Pacific/Samoa',
            label: 'UTC-11:00 (太平洋/サモア)',
        },
        {
            value: 'US/Samoa',
            label: 'UTC-11:00 (アメリカ/サモア)',
        },
        {
            value: 'America/Adak',
            label: 'UTC-10:00 (アメリカ/アダック)',
        },
        {
            value: 'America/Atka',
            label: 'UTC-10:00 (アメリカ/アトカ)',
        },
        {
            value: 'Etc/GMT+10',
            label: 'UTC-10:00 (Etc/GMT+10)',
        },
        {
            value: 'HST',
            label: 'UTC-10:00 (ハワイアリューシャン標準時)',
        },
        {
            value: 'Pacific/Honolulu',
            label: 'UTC-10:00 (太平洋/ホノルル)',
        },
        {
            value: 'Pacific/Johnston',
            label: 'UTC-10:00 (太平洋/ジョンストン)',
        },
        {
            value: 'Pacific/Rarotonga',
            label: 'UTC-10:00 (太平洋/ラロトンガ)',
        },
        {
            value: 'Pacific/Tahiti',
            label: 'UTC-10:00 (太平洋/タヒチ)',
        },
        {
            value: 'US/Aleutian',
            label: 'UTC-10:00 (アメリカ/アリューシャン列島)',
        },
        {
            value: 'US/Hawaii',
            label: 'UTC-10:00 (アメリカ/ハワイ)',
        },
        {
            value: 'Pacific/Marquesas',
            label: 'UTC-09:30 (太平洋/マルケサス)',
        },
        {
            value: 'America/Anchorage',
            label: 'UTC-09:00 (アメリカ/アンカレッジ)',
        },
        {
            value: 'America/Juneau',
            label: 'UTC-09:00 (アメリカ/ジュノー)',
        },
        {
            value: 'America/Nome',
            label: 'UTC-09:00 (アメリカ/ノーム)',
        },
        {
            value: 'America/Sitka',
            label: 'UTC-09:00 (アメリカ/シトカ)',
        },
        {
            value: 'America/Yakutat',
            label: 'UTC-09:00 (アメリカ/ヤクタット)',
        },
        {
            value: 'Etc/GMT+9',
            label: 'UTC-09:00 (Etc/GMT+9)',
        },
        {
            value: 'Pacific/Gambier',
            label: 'UTC-09:00 (太平洋/ガンビア)',
        },
        {
            value: 'US/Alaska',
            label: 'UTC-09:00 (US/アラスカ)',
        },
        {
            value: 'America/Dawson',
            label: 'UTC-07:00 (アメリカ/ドーソン)',
        },
        {
            value: 'America/Ensenada',
            label: 'UTC-08:00 (アメリカ/エンセナダ)',
        },
        {
            value: 'America/Los_Angeles',
            label: 'UTC-08:00 (アメリカ/ロサンゼルス)',
        },
        {
            value: 'America/Metlakatla',
            label: 'UTC-09:00 (アメリカ/メトラカトラ)',
        },
        {
            value: 'America/Santa_Isabel',
            label: 'UTC-08:00 (アメリカ/サンタイサベル)',
        },
        {
            value: 'America/Tijuana',
            label: 'UTC-08:00 (アメリカ/ティファナ)',
        },
        {
            value: 'America/Vancouver',
            label: 'UTC-08:00 (アメリカ/バンクーバー)',
        },
        {
            value: 'America/Whitehorse',
            label: 'UTC-07:00 (アメリカ/ホワイトホース)',
        },
        {
            value: 'Canada/Pacific',
            label: 'UTC-08:00 (カナダ/太平洋)',
        },
        {
            value: 'Canada/Yukon',
            label: 'UTC-07:00 (カナダ/ユーコン)',
        },
        {
            value: 'Etc/GMT+8',
            label: 'UTC-08:00 (Etc/GMT+8)',
        },
        {
            value: 'Mexico/BajaNorte',
            label: 'UTC-08:00 (メキシコ/バハノルテ)',
        },
        {
            value: 'PST8PDT',
            label: 'UTC-08:00 (太平洋標準時)',
        },
        {
            value: 'Pacific/Pitcairn',
            label: 'UTC-08:00 (太平洋/ピトケアン)',
        },
        {
            value: 'US/Pacific-New',
            label: 'UTC-08:00 (アメリカ/太平洋‐新規)',
        },
        {
            value: 'US/Pacific',
            label: 'UTC-08:00 (アメリカ/太平洋)',
        },
        {
            value: 'America/Boise',
            label: 'UTC-07:00 (アメリカ/ボイシ)',
        },
        {
            value: 'America/Cambridge_Bay',
            label: 'UTC-07:00 (アメリカ/カンブリッジベイ)',
        },
        {
            value: 'America/Chihuahua',
            label: 'UTC-06:00 (アメリカ/チワワ)',
        },
        {
            value: 'America/Creston',
            label: 'UTC-07:00 (アメリカ/クレストン)',
        },
        {
            value: 'America/Dawson_Creek',
            label: 'UTC-07:00 (アメリカ/ドーソンクリーク)',
        },
        {
            value: 'America/Denver',
            label: 'UTC-07:00 (アメリカ/デンバー)',
        },
        {
            value: 'America/Edmonton',
            label: 'UTC-07:00 (アメリカ/エドモントン)',
        },
        {
            value: 'America/Fort_Nelson',
            label: 'UTC-07:00 (アメリカ/フォードネルソン)',
        },
        {
            value: 'America/Hermosillo',
            label: 'UTC-07:00 (アメリカ/エルモシージョ)',
        },
        {
            value: 'America/Inuvik',
            label: 'UTC-07:00 (アメリカ/イヌヴィク)',
        },
        {
            value: 'America/Mazatlan',
            label: 'UTC-07:00 (アメリカ/マサトラン)',
        },
        {
            value: 'America/Ojinaga',
            label: 'UTC-06:00 (アメリカ/オジナガ)',
        },
        {
            value: 'America/Phoenix',
            label: 'UTC-07:00 (アメリカ/フェニックス)',
        },
        {
            value: 'America/Shiprock',
            label: 'UTC-07:00 (アメリカ/シプロック)',
        },
        {
            value: 'America/Yellowknife',
            label: 'UTC-07:00 (アメリカ/イエローナイフ)',
        },
        {
            value: 'Canada/Mountain',
            label: 'UTC-07:00 (カナダ/マウンテン)',
        },
        {
            value: 'Etc/GMT+7',
            label: 'UTC-07:00 (Etc/GMT+7)',
        },
        {
            value: 'MST7MDT',
            label: 'UTC-07:00 (山岳標準時 MST7MDT)',
        },
        {
            value: 'MST',
            label: 'UTC-07:00 (山岳標準時 MST)',
        },
        {
            value: 'Mexico/BajaSur',
            label: 'UTC-07:00 (メキシコ/バハスール)',
        },
        {
            value: 'Navajo',
            label: 'UTC-07:00 (ナバホ)',
        },
        {
            value: 'US/Arizona',
            label: 'UTC-07:00 (アメリカ/アリゾナ)',
        },
        {
            value: 'US/Mountain',
            label: 'UTC-07:00 (アメリカ/マウンテン)',
        },
        {
            value: 'America/Bahia_Banderas',
            label: 'UTC-06:00 (アメリカ/バイーアバンデラス)',
        },
        {
            value: 'America/Belize',
            label: 'UTC-06:00 (アメリカ/ベリーズ)',
        },
        {
            value: 'America/Chicago',
            label: 'UTC-06:00 (アメリカ/シカゴ)',
        },
        {
            value: 'America/Costa_Rica',
            label: 'UTC-06:00 (アメリカ/コスタリカ)',
        },
        {
            value: 'America/El_Salvador',
            label: 'UTC-06:00 (アメリカ/エルサルバドル)',
        },
        {
            value: 'America/Guatemala',
            label: 'UTC-06:00 (アメリカ/グアテマラ)',
        },
        {
            value: 'America/Indiana/Knox',
            label: 'UTC-06:00 (アメリカ/インディアナ/ノックス)',
        },
        {
            value: 'America/Indiana/Tell_City',
            label: 'UTC-06:00 (アメリカ/インディアナナ/テルシティ)',
        },
        {
            value: 'America/Knox_IN',
            label: 'UTC-06:00 (アメリカ/ノックスイン)',
        },
        {
            value: 'America/Managua',
            label: 'UTC-06:00 (アメリカ/マナグア)',
        },
        {
            value: 'America/Matamoros',
            label: 'UTC-06:00 (アメリカ/マタモロス)',
        },
        {
            value: 'America/Menominee',
            label: 'UTC-06:00 (アメリカ/メノミニー)',
        },
        {
            value: 'America/Merida',
            label: 'UTC-06:00 (アメリカ/メリダ)',
        },
        {
            value: 'America/Mexico_City',
            label: 'UTC-06:00 (アメリカ/メキシコシティ)',
        },
        {
            value: 'America/Monterrey',
            label: 'UTC-06:00 (アメリカ/モンテレー)',
        },
        {
            value: 'America/North_Dakota/Beulah',
            label: 'UTC-06:00 (アメリカ/ノースダコタ/ベウラ)',
        },
        {
            value: 'America/North_Dakota/Center',
            label: 'UTC-06:00 (アメリカ/ノースダコタ/センター)',
        },
        {
            value: 'America/North_Dakota/New_Salem',
            label: 'UTC-06:00 (アメリカ/ノースダコタ/ニューセイラム)',
        },
        {
            value: 'America/Rainy_River',
            label: 'UTC-06:00 (アメリカ/レイニーリバー)',
        },
        {
            value: 'America/Rankin_Inlet',
            label: 'UTC-06:00 (アメリカ/ランキンインレット)',
        },
        {
            value: 'America/Regina',
            label: 'UTC-06:00 (アメリカ/レジーナ)',
        },
        {
            value: 'America/Resolute',
            label: 'UTC-06:00 (アメリカ/レゾリュート)',
        },
        {
            value: 'America/Swift_Current',
            label: 'UTC-06:00 (アメリカ/スウィフトカレント)',
        },
        {
            value: 'America/Tegucigalpa',
            label: 'UTC-06:00 (アメリカ/テグシガルパ)',
        },
        {
            value: 'America/Winnipeg',
            label: 'UTC-06:00 (アメリカ/ウィニペグ)',
        },
        {
            value: 'CST6CDT',
            label: 'UTC-06:00 (中央標準時 CST6CDT)',
        },
        {
            value: 'Canada/Central',
            label: 'UTC-06:00 (カナダ/中部)',
        },
        {
            value: 'Canada/Saskatchewan',
            label: 'UTC-06:00 (カナダ/サスカチュワン)',
        },
        {
            value: 'Etc/GMT+6',
            label: 'UTC-06:00 (Etc/GMT+6)',
        },
        {
            value: 'Mexico/General',
            label: 'UTC-06:00 (メキシコ/一般)',
        },
        {
            value: 'Pacific/Galapagos',
            label: 'UTC-06:00 (太平洋/ガラパゴス)',
        },
        {
            value: 'US/Central',
            label: 'UTC-06:00 (アメリカ/ 中央)',
        },
        {
            value: 'US/Indiana-Starke',
            label: 'UTC-06:00 (アメリカ/インディアスターク)',
        },
        {
            value: 'America/Atikokan',
            label: 'UTC-05:00 (アメリカ/アティコカン)',
        },
        {
            value: 'America/Bogota',
            label: 'UTC-05:00 (アメリカ/ボゴタ)',
        },
        {
            value: 'America/Cancun',
            label: 'UTC-05:00 (アメリカ/カンクン)',
        },
        {
            value: 'America/Cayman',
            label: 'UTC-05:00 (アメリカ/ケイマン)',
        },
        {
            value: 'America/Coral_Harbour',
            label: 'UTC-05:00 (アメリカ/コーラルハーバー)',
        },
        {
            value: 'America/Detroit',
            label: 'UTC-05:00 (アメリカ/デトロイト)',
        },
        {
            value: 'America/Eirunepe',
            label: 'UTC-05:00 (アメリカ/エルネペ)',
        },
        {
            value: 'America/Fort_Wayne',
            label: 'UTC-05:00 (アメリカ/フォートウェイン)',
        },
        {
            value: 'America/Guayaquil',
            label: 'UTC-05:00 (アメリカ/グアヤキル)',
        },
        {
            value: 'America/Havana',
            label: 'UTC-05:00 (アメリカ/ハバナ)',
        },
        {
            value: 'America/Indiana/Indianapolis',
            label: 'UTC-05:00 (アメリカ/インディアナ/インディアナポリス)',
        },
        {
            value: 'America/Indiana/Marengo',
            label: 'UTC-05:00 (アメリカ/インディアナ/マレンゴ)',
        },
        {
            value: 'America/Indiana/Petersburg',
            label: 'UTC-05:00 (アメリカ/インディアナ/ピーターズバーグ)',
        },
        {
            value: 'America/Indiana/Vevay',
            label: 'UTC-05:00 (アメリカ/インディアナ/ベベイ)',
        },
        {
            value: 'America/Indiana/Vincennes',
            label: 'UTC-05:00 (アメリカ/インディアナ/ビンセンズ)',
        },
        {
            value: 'America/Indiana/Winamac',
            label: 'UTC-05:00 (アメリカ/インディアナ/ウィナマック)',
        },
        {
            value: 'America/Indianapolis',
            label: 'UTC-05:00 (アメリカ/インディアナポリス)',
        },
        {
            value: 'America/Iqaluit',
            label: 'UTC-05:00 (アメリカ/イカルイト)',
        },
        {
            value: 'America/Jamaica',
            label: 'UTC-05:00 (アメリカ/ジャマイカ)',
        },
        {
            value: 'America/Kentucky/Louisville',
            label: 'UTC-05:00 (アメリカ/ケンタッキー/ルイビル)',
        },
        {
            value: 'America/Kentucky/Monticello',
            label: 'UTC-05:00 (アメリカ/ケンタッキー/モンティチェロ)',
        },
        {
            value: 'America/Lima',
            label: 'UTC-05:00 (アメリカ/リマ)',
        },
        {
            value: 'America/Louisville',
            label: 'UTC-05:00 (アメリカ/ルイビル)',
        },
        {
            value: 'America/Montreal',
            label: 'UTC-05:00 (アメリカ/モントリオール)',
        },
        {
            value: 'America/Nassau',
            label: 'UTC-05:00 (アメリカ/ナッソー)',
        },
        {
            value: 'America/New_York',
            label: 'UTC-05:00 (アメリカ/ニューヨーク)',
        },
        {
            value: 'America/Nipigon',
            label: 'UTC-05:00 (アメリカ/ニピゴン)',
        },
        {
            value: 'America/Panama',
            label: 'UTC-05:00 (アメリカ/パナマ)',
        },
        {
            value: 'America/Pangnirtung',
            label: 'UTC-05:00 (アメリカ/パンニルトゥング)',
        },
        {
            value: 'America/Port-au-Prince',
            label: 'UTC-05:00 (アメリカ/ポルトープランス)',
        },
        {
            value: 'America/Porto_Acre',
            label: 'UTC-05:00 (アメリカ/ポルトエーカー)',
        },
        {
            value: 'America/Rio_Branco',
            label: 'UTC-05:00 (アメリカ/リオブランコ)',
        },
        {
            value: 'America/Thunder_Bay',
            label: 'UTC-05:00 (アメリカ/サンダー湾)',
        },
        {
            value: 'America/Toronto',
            label: 'UTC-05:00 (アメリカ/トロント)',
        },
        {
            value: 'Brazil/Acre',
            label: 'UTC-05:00 (ブラジル/エーカー)',
        },
        {
            value: 'Canada/Eastern',
            label: 'UTC-05:00 (カナダ/東部)',
        },
        {
            value: 'Chile/EasterIsland',
            label: 'UTC-06:00 (チリ/イースター島)',
        },
        {
            value: 'Cuba',
            label: 'UTC-05:00 (キューバ)',
        },
        {
            value: 'EST5EDT',
            label: 'UTC-05:00 (東部標準時 EST5EDT)',
        },
        {
            value: 'EST',
            label: 'UTC-05:00 (東部標準時 EST)',
        },
        {
            value: 'Etc/GMT+5',
            label: 'UTC-05:00 (Etc/GMT+5)',
        },
        {
            value: 'Jamaica',
            label: 'UTC-05:00 (ジャマイカ)',
        },
        {
            value: 'Pacific/Easter',
            label: 'UTC-06:00 (太平洋/イースター)',
        },
        {
            value: 'US/East-Indiana',
            label: 'UTC-05:00 (アメリカ/東部インディアナ)',
        },
        {
            value: 'US/Eastern',
            label: 'UTC-05:00 (アメリカ/東部)',
        },
        {
            value: 'US/Michigan',
            label: 'UTC-05:00 (アメリカ/ミシガン)',
        },
        {
            value: 'America/Caracas',
            label: 'UTC-04:00 (アメリカ/カラカス)',
        },
        {
            value: 'America/Anguilla',
            label: 'UTC-04:00 (アメリカ/アンギラ)',
        },
        {
            value: 'America/Antigua',
            label: 'UTC-04:00 (アメリカ/アンティグア)',
        },
        {
            value: 'America/Aruba',
            label: 'UTC-04:00 (アメリカ/アルバ)',
        },
        {
            value: 'America/Barbados',
            label: 'UTC-04:00 (アメリカ/バルバドス)',
        },
        {
            value: 'America/Blanc-Sablon',
            label: 'UTC-04:00 (アメリカ/ブランサブロン)',
        },
        {
            value: 'America/Boa_Vista',
            label: 'UTC-04:00 (アメリカ/ボアビスタ)',
        },
        {
            value: 'America/Curacao',
            label: 'UTC-04:00 (アメリカ/キュラソー島)',
        },
        {
            value: 'America/Dominica',
            label: 'UTC-04:00 (アメリカ/ドミニカ)',
        },
        {
            value: 'America/Glace_Bay',
            label: 'UTC-04:00 (アメリカ/グレースベイ)',
        },
        {
            value: 'America/Goose_Bay',
            label: 'UTC-04:00 (アメリカ/グースベイ)',
        },
        {
            value: 'America/Grand_Turk',
            label: 'UTC-05:00 (アメリカ/グランドターク)',
        },
        {
            value: 'America/Grenada',
            label: 'UTC-04:00 (アメリカ/グレナダ)',
        },
        {
            value: 'America/Guadeloupe',
            label: 'UTC-04:00 (アメリカ/グアドループ)',
        },
        {
            value: 'America/Guyana',
            label: 'UTC-04:00 (アメリカ/ガイアナ)',
        },
        {
            value: 'America/Halifax',
            label: 'UTC-04:00 (アメリカ/ハリファックス)',
        },
        {
            value: 'America/Kralendijk',
            label: 'UTC-04:00 (アメリカ/クラーレンダイク)',
        },
        {
            value: 'America/La_Paz',
            label: 'UTC-04:00 (アメリカ/ラ_Paz)',
        },
        {
            value: 'America/Lower_Princes',
            label: 'UTC-04:00 (アメリカ/ローワプリンセス)',
        },
        {
            value: 'America/Manaus',
            label: 'UTC-04:00 (アメリカ/マナウス)',
        },
        {
            value: 'America/Marigot',
            label: 'UTC-04:00 (アメリカ/マリゴ)',
        },
        {
            value: 'America/Martinique',
            label: 'UTC-04:00 (アメリカ/マルティニーク)',
        },
        {
            value: 'America/Moncton',
            label: 'UTC-04:00 (アメリカ/モンクトン)',
        },
        {
            value: 'America/Montserrat',
            label: 'UTC-04:00 (アメリカ/モントセラト)',
        },
        {
            value: 'America/Port_of_Spain',
            label: 'UTC-04:00 (アメリカ/ポートオブスペイン)',
        },
        {
            value: 'America/Porto_Velho',
            label: 'UTC-04:00 (アメリカ/ポルトヴェーリョ)',
        },
        {
            value: 'America/Puerto_Rico',
            label: 'UTC-04:00 (アメリカ/プエルトリコ)',
        },
        {
            value: 'America/Santo_Domingo',
            label: 'UTC-04:00 (アメリカ/サントドミンゴ)',
        },
        {
            value: 'America/St_Barthelemy',
            label: 'UTC-04:00 (アメリカ/サンバルテルミー)',
        },
        {
            value: 'America/St_Kitts',
            label: 'UTC-04:00 (アメリカ/セントキッツ)',
        },
        {
            value: 'America/St_Lucia',
            label: 'UTC-04:00 (アメリカ/セントルシア)',
        },
        {
            value: 'America/St_Thomas',
            label: 'UTC-04:00 (アメリカ/セントトーマス)',
        },
        {
            value: 'America/St_Vincent',
            label: 'UTC-04:00 (アメリカ/セントビンセント)',
        },
        {
            value: 'America/Thule',
            label: 'UTC-04:00 (アメリカ/トゥーレ)',
        },
        {
            value: 'America/Cuiaba',
            label: 'UTC-04:00 (アメリカ/クイアバ)',
        },
        {
            value: 'America/Tortola',
            label: 'UTC-04:00 (アメリカ/トルトラ)',
        },
        {
            value: 'America/Campo_Grande',
            label: 'UTC-04:00 (アメリカ/カンポグランデ)',
        },
        {
            value: 'America/Virgin',
            label: 'UTC-04:00 (アメリカ/ヴァージン)',
        },
        {
            value: 'America/Asuncion',
            label: 'UTC-04:00 (アメリカ/アスンシオン)',
        },
        {
            value: 'Atlantic/Bermuda',
            label: 'UTC-04:00 (大西洋/バミューダ)',
        },
        {
            value: 'Brazil/West',
            label: 'UTC-04:00 (ブラジル/西)',
        },
        {
            value: 'Canada/Atlantic',
            label: 'UTC-04:00 (カナダ/大西洋)',
        },
        {
            value: 'Etc/GMT+4',
            label: 'UTC-04:00 (Etc/GMT+4)',
        },
        {
            value: 'America/St_Johns',
            label: 'UTC-03:30 (アメリカ/セントジョンズ)',
        },
        {
            value: 'Canada/Newfoundland',
            label: 'UTC-03:30 (カナダ/ニューファンドランド)',
        },
        {
            value: 'America/Araguaina',
            label: 'UTC-03:00 (アメリカ/アラグアイナ)',
        },
        {
            value: 'America/Argentina/Buenos_Aires',
            label: 'UTC-03:00 (アメリカ/アルゲンティナ/ブエノスアイレス)',
        },
        {
            value: 'America/Argentina/Catamarca',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/カタマルカ)',
        },
        {
            value: 'America/Argentina/ComodRivadavia',
            label: 'UTC-03:00 (アメリカ/アルゲンティナ/コモドリヴァダビア)',
        },
        {
            value: 'America/Argentina/Cordoba',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/コルドバ)',
        },
        {
            value: 'America/Argentina/Jujuy',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/ジュフイ)',
        },
        {
            value: 'America/Argentina/La_Rioja',
            label: 'UTC-03:00 (アメリカ/アルゲンティーナ/ラリオハ)',
        },
        {
            value: 'America/Argentina/Mendoza',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/メンドーサ)',
        },
        {
            value: 'America/Argentina/Rio_Gallegos',
            label: 'UTC-03:00 (アメリカ/アルゲンティナ/リオガジェゴス)',
        },
        {
            value: 'America/Argentina/Salta',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/サルタ)',
        },
        {
            value: 'America/Argentina/San_Juan',
            label: 'UTC-03:00 (アメリカ/アルゲンティナ/サンフアン)',
        },
        {
            value: 'America/Argentina/San_Luis',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/セントルイス)',
        },
        {
            value: 'America/Argentina/Tucuman',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/トゥクマン)',
        },
        {
            value: 'America/Argentina/Ushuaia',
            label: 'UTC-03:00 (アメリカ/アルゼンチン/ウシュアイア)',
        },
        {
            value: 'America/Bahia',
            label: 'UTC-03:00 (アメリカ/バイア)',
        },
        {
            value: 'America/Belem',
            label: 'UTC-03:00 (アメリカ/ベレン)',
        },
        {
            value: 'America/Buenos_Aires',
            label: 'UTC-03:00 (アメリカ/ブエノスアイレス)',
        },
        {
            value: 'America/Catamarca',
            label: 'UTC-03:00 (アメリカ/カタマルカ)',
        },
        {
            value: 'America/Cayenne',
            label: 'UTC-03:00 (アメリカ/カイエン)',
        },
        {
            value: 'America/Cordoba',
            label: 'UTC-03:00 (アメリカ/コルドバ)',
        },
        {
            value: 'America/Fortaleza',
            label: 'UTC-03:00 (アメリカ/フォルタレザ)',
        },
        {
            value: 'America/Godthab',
            label: 'UTC-02:00 (アメリカ/ゴドタブ)',
        },
        {
            value: 'America/Jujuy',
            label: 'UTC-03:00 (アメリカ/ジュフイ)',
        },
        {
            value: 'America/Maceio',
            label: 'UTC-03:00 (アメリカ/マケイオ)',
        },
        {
            value: 'America/Mendoza',
            label: 'UTC-03:00 (アメリカ/メンドーサ)',
        },
        {
            value: 'America/Miquelon',
            label: 'UTC-03:00 (アメリカ/ミクロン)',
        },
        {
            value: 'America/Paramaribo',
            label: 'UTC-03:00 (アメリカ/パラマリボ)',
        },
        {
            value: 'America/Punta_Arenas',
            label: 'UTC-03:00 (アメリカ/プンタアリーナ)',
        },
        {
            value: 'America/Recife',
            label: 'UTC-03:00 (アメリカ/レシフェ)',
        },
        {
            value: 'America/Rosario',
            label: 'UTC-03:00 (アメリカ/ロサリオ)',
        },
        {
            value: 'America/Santarem',
            label: 'UTC-03:00 (アメリカ/サンタレム)',
        },
        {
            value: 'America/Santiago',
            label: 'UTC-04:00 (アメリカ/サンティアゴ)',
        },
        {
            value: 'America/Montevideo',
            label: 'UTC-03:00 (アメリカ/モンテビデオ)',
        },
        {
            value: 'America/Sao_Paulo',
            label: 'UTC-03:00 (アメリカ/サンパウロ)',
        },
        {
            value: 'Antarctica/Palmer',
            label: 'UTC-03:00 (南極大陸/パルマー)',
        },
        {
            value: 'Antarctica/Rothera',
            label: 'UTC-03:00 (南極大陸/ロゼラ)',
        },
        {
            value: 'Brazil/East',
            label: 'UTC-03:00 (ブラジル/東部)',
        },
        {
            value: 'Atlantic/Stanley',
            label: 'UTC-03:00 (大西洋/スタンレー)',
        },
        {
            value: 'Chile/Continental',
            label: 'UTC-04:00 (チリ/大陸)',
        },
        {
            value: 'Etc/GMT+3',
            label: 'UTC-03:00 (Etc/GMT+3)',
        },
        {
            value: 'America/Noronha',
            label: 'UTC-02:00 (アメリカ/ノローニャ)',
        },
        {
            value: 'Atlantic/South_Georgia',
            label: 'UTC-02:00 (大西洋/サウスジョージア州)',
        },
        {
            value: 'Brazil/DeNoronha',
            label: 'UTC-02:00 (ブラジル/デノローニャ)',
        },
        {
            value: 'Etc/GMT+2',
            label: 'UTC-02:00 (Etc/GMT+2)',
        },
        {
            value: 'America/Scoresbysund',
            label: 'UTC-02:00 (アメリカ/スコルズビスン)',
        },
        {
            value: 'Atlantic/Azores',
            label: 'UTC-01:00 (大西洋/アゾレス諸島)',
        },
        {
            value: 'Atlantic/Cape_Verde',
            label: 'UTC-01:00 (大西洋/カーボベルデ)',
        },
        {
            value: 'Etc/GMT+1',
            label: 'UTC-01:00 (Etc/GMT+1)',
        },
        {
            value: 'Africa/Abidjan',
            label: 'UTC+00:00 (アフリカ/アビジャン)',
        },
        {
            value: 'Africa/Accra',
            label: 'UTC+00:00 (アフリカ/アクラ)',
        },
        {
            value: 'Africa/Bamako',
            label: 'UTC+00:00 (アフリカ/バマコ)',
        },
        {
            value: 'Africa/Banjul',
            label: 'UTC+00:00 (アフリカ/バンジュール)',
        },
        {
            value: 'Africa/Bissau',
            label: 'UTC+00:00 (アフリカ/ビサウ)',
        },
        {
            value: 'Africa/Casablanca',
            label: 'UTC+00:00 (アフリカ/カサブランカ)',
        },
        {
            value: 'Africa/Conakry',
            label: 'UTC+00:00 (アフリカ/コナクリ)',
        },
        {
            value: 'Africa/Dakar',
            label: 'UTC+00:00 (アフリカ/ダカール)',
        },
        {
            value: 'Africa/Freetown',
            label: 'UTC+00:00 (アフリカ/フリータウン)',
        },
        {
            value: 'Africa/Lome',
            label: 'UTC+00:00 (アフリカ/ローム)',
        },
        {
            value: 'Africa/Monrovia',
            label: 'UTC+00:00 (アフリカ/モンロビア)',
        },
        {
            value: 'Africa/Nouakchott',
            label: 'UTC+00:00 (アフリカ/ヌアクショット)',
        },
        {
            value: 'Africa/Ouagadougou',
            label: 'UTC+00:00 (アフリカ/ワガドゥグ)',
        },
        {
            value: 'Africa/Sao_Tome',
            label: 'UTC+00:00 (アフリカ/サントメ)',
        },
        {
            value: 'Africa/Timbuktu',
            label: 'UTC+00:00 (アフリカ/ティンブクトゥ)',
        },
        {
            value: 'America/Danmarkshavn',
            label: 'UTC+00:00 (アメリカ/ダンマークシャウン)',
        },
        {
            value: 'Antarctica/Troll',
            label: 'UTC+00:00 (南極大陸/トロール)',
        },
        {
            value: 'Atlantic/Canary',
            label: 'UTC+00:00 (大西洋/カナリア)',
        },
        {
            value: 'Atlantic/Faeroe',
            label: 'UTC+00:00 (大西洋/フェロー)',
        },
        {
            value: 'Atlantic/Faroe',
            label: 'UTC+00:00 (大西洋/フェロー)',
        },
        {
            value: 'Atlantic/Madeira',
            label: 'UTC+00:00 (大西洋/マデイラ)',
        },
        {
            value: 'Atlantic/Reykjavik',
            label: 'UTC+00:00 (大西洋/レイキャヴィク)',
        },
        {
            value: 'Atlantic/St_Helena',
            label: 'UTC+00:00 (大西洋/セントヘレナ島)',
        },
        {
            value: 'Eire',
            label: 'UTC+00:00 (その他 /GMT)',
        },
        {
            value: 'Etc/GMT',
            label: 'UTC+00:00 (その他 /GMT)',
        },
        {
            value: 'Etc/GMT+0',
            label: 'UTC+00:00 (Etc/GMT+0)',
        },
        {
            value: 'Etc/GMT-0',
            label: 'UTC+00:00 (Etc/GMT-0)',
        },
        {
            value: 'Etc/GMT0',
            label: 'UTC+00:00 (Etc/GMT0)',
        },
        {
            value: 'Etc/Greenwich',
            label: 'UTC+00:00 (Etc/ グリニッジ)',
        },
        {
            value: 'Etc/UCT',
            label: 'UTC+00:00 (その他 /UCT)',
        },
        {
            value: 'Etc/UTC',
            label: 'UTC+00:00 (その他 /UTC)',
        },
        {
            value: 'Etc/Universal',
            label: 'UTC+00:00 (Etc/ ユニバーサル)',
        },
        {
            value: 'Etc/Zulu',
            label: 'UTC+00:00 (その他/ズールー)',
        },
        {
            value: 'Europe/Belfast',
            label: 'UTC+00:00 (ヨーロッパ/ベルファスト)',
        },
        {
            value: 'Europe/Dublin',
            label: 'UTC+00:00 (ヨーロッパ/ダブリン)',
        },
        {
            value: 'Europe/Guernsey',
            label: 'UTC+00:00 (ヨーロッパ/ガーンジー)',
        },
        {
            value: 'Europe/Isle_of_Man',
            label: 'UTC+00:00 (ヨーロッパ/マン島)',
        },
        {
            value: 'Europe/Jersey',
            label: 'UTC+00:00 (ヨーロッパ/ジャージー)',
        },
        {
            value: 'Europe/Lisbon',
            label: 'UTC+00:00 (ヨーロッパ/リスボン)',
        },
        {
            value: 'Europe/London',
            label: 'UTC+00:00 (ヨーロッパ/ロンドン)',
        },
        {
            value: 'GB-Eire',
            label: 'UTC+00:00 (GB-エア)',
        },
        {
            value: 'GB',
            label: 'UTC+00:00 (GB)',
        },
        {
            value: 'GMT+0',
            label: 'UTC+00:00 (GMT+0)',
        },
        {
            value: 'GMT-0',
            label: 'UTC+00:00 (GMT-0)',
        },
        {
            value: 'GMT0',
            label: 'UTC+00:00 (GMT0)',
        },
        {
            value: 'GMT',
            label: 'UTC+00:00 (GMT)',
        },
        {
            value: 'Greenwich',
            label: 'UTC+00:00 (グリニッジ)',
        },
        {
            value: 'Iceland',
            label: 'UTC+00:00 (アイスランド)',
        },
        {
            value: 'Portugal',
            label: 'UTC+00:00 (ポルトガル)',
        },
        {
            value: 'UCT',
            label: 'UTC+00:00 (UCT)',
        },
        {
            value: 'UTC',
            label: 'UTC+00:00 (UTC)',
        },
        {
            value: 'Universal',
            label: 'UTC+00:00 (ユニバーサル)',
        },
        {
            value: 'WET',
            label: 'UTC+00:00 (WET)',
        },
        {
            value: 'Zulu',
            label: 'UTC+00:00 (ズールー)',
        },
        {
            value: 'Africa/Algiers',
            label: 'UTC+01:00 (アフリカ/アルジェ)',
        },
        {
            value: 'Africa/Bangui',
            label: 'UTC+01:00 (アフリカ/バンギ)',
        },
        {
            value: 'Africa/Brazzaville',
            label: 'UTC+01:00 (アフリカ/ブラザヴィル)',
        },
        {
            value: 'Africa/Ceuta',
            label: 'UTC+01:00 (アフリカ/セウタ)',
        },
        {
            value: 'Africa/Douala',
            label: 'UTC+01:00 (アフリカ/ドゥアラ)',
        },
        {
            value: 'Africa/Kinshasa',
            label: 'UTC+01:00 (アフリカ/キンシャサ)',
        },
        {
            value: 'Africa/Lagos',
            label: 'UTC+01:00 (アフリカ/ラゴス)',
        },
        {
            value: 'Africa/Libreville',
            label: 'UTC+01:00 (アフリカ/リーブルビル)',
        },
        {
            value: 'Africa/Luanda',
            label: 'UTC+01:00 (アフリカ/ルアンダ)',
        },
        {
            value: 'Africa/Malabo',
            label: 'UTC+01:00 (アフリカ/マラボ)',
        },
        {
            value: 'Africa/Ndjamena',
            label: 'UTC+01:00 (アフリカ/ンジャメナ)',
        },
        {
            value: 'Africa/Niamey',
            label: 'UTC+01:00 (アフリカ/ニアミー)',
        },
        {
            value: 'Africa/Porto-Novo',
            label: 'UTC+01:00 (アフリカ/ポルトノボ)',
        },
        {
            value: 'Africa/Tunis',
            label: 'UTC+01:00 (アフリカ/チュニス)',
        },
        {
            value: 'Africa/Windhoek',
            label: 'UTC+02:00 (アフリカ/ウィンドフック)',
        },
        {
            value: 'Arctic/Longyearbyen',
            label: 'UTC+01:00 (北極/ロングイェルビエン)',
        },
        {
            value: 'Atlantic/Jan_Mayen',
            label: 'UTC+01:00 (大西洋/ヤンマイエン)',
        },
        {
            value: 'CET',
            label: 'UTC+01:00 (CET (E))',
        },
        {
            value: 'Etc/GMT-1',
            label: 'UTC+01:00 (Etc/GMT-1)',
        },
        {
            value: 'Europe/Amsterdam',
            label: 'UTC+01:00 (ヨーロッパ/アムステルダム)',
        },
        {
            value: 'Europe/Andorra',
            label: 'UTC+01:00 (ヨーロッパ/アンドラ)',
        },
        {
            value: 'Europe/Belgrade',
            label: 'UTC+01:00 (ヨーロッパ/ベオグラード)',
        },
        {
            value: 'Europe/Berlin',
            label: 'UTC+01:00 (ヨーロッパ/ベルリン)',
        },
        {
            value: 'Europe/Bratislava',
            label: 'UTC+01:00 (ヨーロッパ/ブラチスラバ)',
        },
        {
            value: 'Europe/Brussels',
            label: 'UTC+01:00 (ヨーロッパ/ブリュッセル)',
        },
        {
            value: 'Europe/Budapest',
            label: 'UTC+01:00 (ヨーロッパ/ブダペスト)',
        },
        {
            value: 'Europe/Busingen',
            label: 'UTC+01:00 (ヨーロッパ/ビュージンゲン)',
        },
        {
            value: 'Europe/Copenhagen',
            label: 'UTC+01:00 (ヨーロッパ/コペンハーゲン)',
        },
        {
            value: 'Europe/Gibraltar',
            label: 'UTC+01:00 (ヨーロッパ/ジブラルタル)',
        },
        {
            value: 'Europe/Ljubljana',
            label: 'UTC+01:00 (ヨーロッパ/リュブリャナ)',
        },
        {
            value: 'Europe/Luxembourg',
            label: 'UTC+01:00 (ヨーロッパ/ルクセンブルク)',
        },
        {
            value: 'Europe/Madrid',
            label: 'UTC+01:00 (ヨーロッパ/マドリード)',
        },
        {
            value: 'Europe/Malta',
            label: 'UTC+01:00 (ヨーロッパ/マルタ)',
        },
        {
            value: 'Europe/Monaco',
            label: 'UTC+01:00 (ヨーロッパ/モナコ)',
        },
        {
            value: 'Europe/Oslo',
            label: 'UTC+01:00 (ヨーロッパ/オスロ)',
        },
        {
            value: 'Europe/Paris',
            label: 'UTC+01:00 (ヨーロッパ/パリ)',
        },
        {
            value: 'Europe/Podgorica',
            label: 'UTC+01:00 (ヨーロッパ/ポドゴリツァ)',
        },
        {
            value: 'Europe/Prague',
            label: 'UTC+01:00 (ヨーロッパ/プラハ)',
        },
        {
            value: 'Europe/Rome',
            label: 'UTC+01:00 (ヨーロッパ/ローマ)',
        },
        {
            value: 'Europe/San_Marino',
            label: 'UTC+01:00 (ヨーロッパ/サンマリノ)',
        },
        {
            value: 'Europe/Sarajevo',
            label: 'UTC+01:00 (ヨーロッパ/サラエボ)',
        },
        {
            value: 'Europe/Skopje',
            label: 'UTC+01:00 (ヨーロッパ/スコピエ)',
        },
        {
            value: 'Europe/Stockholm',
            label: 'UTC+01:00 (ヨーロッパ/ストックホルム)',
        },
        {
            value: 'Europe/Tirane',
            label: 'UTC+01:00 (ヨーロッパ/ティラネ)',
        },
        {
            value: 'Europe/Vaduz',
            label: 'UTC+01:00 (ヨーロッパ/ファドゥーツ)',
        },
        {
            value: 'Europe/Vatican',
            label: 'UTC+01:00 (ヨーロッパ/バチカン)',
        },
        {
            value: 'Europe/Vienna',
            label: 'UTC+01:00 (ヨーロッパ/ウィーン)',
        },
        {
            value: 'Europe/Warsaw',
            label: 'UTC+01:00 (ヨーロッパ/ワルシャワ)',
        },
        {
            value: 'Europe/Zagreb',
            label: 'UTC+01:00 (ヨーロッパ/ザグレブ)',
        },
        {
            value: 'Europe/Zurich',
            label: 'UTC+01:00 (ヨーロッパ/チューリヒ)',
        },
        {
            value: 'MET',
            label: 'UTC+01:00 (MET (M))',
        },
        {
            value: 'Poland',
            label: 'UTC+01:00 (ポーランド)',
        },
        {
            value: 'Africa/Blantyre',
            label: 'UTC+02:00 (アフリカ/ブランタイア)',
        },
        {
            value: 'Africa/Bujumbura',
            label: 'UTC+02:00 (アフリカ/ブジュンブラ)',
        },
        {
            value: 'Africa/Cairo',
            label: 'UTC+02:00 (アフリカ/カイロ)',
        },
        {
            value: 'Africa/Gaborone',
            label: 'UTC+02:00 (アフリカ/ガボローネ)',
        },
        {
            value: 'Africa/Harare',
            label: 'UTC+02:00 (アフリカ/ハラーレ)',
        },
        {
            value: 'Africa/Johannesburg',
            label: 'UTC+02:00 (アフリカ/ヨハネスブルグ)',
        },
        {
            value: 'Africa/Kigali',
            label: 'UTC+02:00 (アフリカ/キガリ)',
        },
        {
            value: 'Africa/Lubumbashi',
            label: 'UTC+02:00 (アフリカ/ルブンバシ)',
        },
        {
            value: 'Africa/Lusaka',
            label: 'UTC+02:00 (アフリカ/ルサカ)',
        },
        {
            value: 'Africa/Maputo',
            label: 'UTC+02:00 (アフリカ/マプト)',
        },
        {
            value: 'Africa/Maseru',
            label: 'UTC+02:00 (アフリカ/マセル)',
        },
        {
            value: 'Africa/Mbabane',
            label: 'UTC+02:00 (アフリカ/ムババネ)',
        },
        {
            value: 'Africa/Tripoli',
            label: 'UTC+02:00 (アフリカ/トリポリ)',
        },
        {
            value: 'Asia/Amman',
            label: 'UTC+03:00 (アジア/アンマン)',
        },
        {
            value: 'Asia/Beirut',
            label: 'UTC+02:00 (アジア/ベイルート)',
        },
        {
            value: 'Asia/Damascus',
            label: 'UTC+03:00 (アジア/ダマスカス)',
        },
        {
            value: 'Asia/Gaza',
            label: 'UTC+02:00 (アジア/ガザ)',
        },
        {
            value: 'Asia/Hebron',
            label: 'UTC+02:00 (アジア/ヘブロン)',
        },
        {
            value: 'Asia/Istanbul',
            label: 'UTC+03:00 (アジア/イスタンブール)',
        },
        {
            value: 'Asia/Jerusalem',
            label: 'UTC+02:00 (アジア/エルサレム)',
        },
        {
            value: 'Asia/Nicosia',
            label: 'UTC+02:00 (アジア/ニコシア)',
        },
        {
            value: 'Asia/Tel_Aviv',
            label: 'UTC+02:00 (アジア/テラアビブ)',
        },
        {
            value: 'EET',
            label: 'UTC+02:00 (EET (E))',
        },
        {
            value: 'Egypt',
            label: 'UTC+02:00 (エジプト)',
        },
        {
            value: 'Etc/GMT-2',
            label: 'UTC+02:00 (Etc/GMT-2)',
        },
        {
            value: 'Europe/Athens',
            label: 'UTC+02:00 (ヨーロッパ/アテネ)',
        },
        {
            value: 'Asia/Famagusta',
            label: 'UTC+02:00 (アジア/ファマグスタ)',
        },
        {
            value: 'Europe/Bucharest',
            label: 'UTC+02:00 (ヨーロッパ/ブカレスト)',
        },
        {
            value: 'Europe/Chisinau',
            label: 'UTC+02:00 (ヨーロッパ/チジナウ)',
        },
        {
            value: 'Europe/Helsinki',
            label: 'UTC+02:00 (ヨーロッパ/ヘルシンキ)',
        },
        {
            value: 'Europe/Istanbul',
            label: 'UTC+03:00 (ヨーロッパ/イスタンブール)',
        },
        {
            value: 'Europe/Kaliningrad',
            label: 'UTC+02:00 (ヨーロッパ/カリーニングラード)',
        },
        {
            value: 'Europe/Kiev',
            label: 'UTC+02:00 (ヨーロッパ/キエフ)',
        },
        {
            value: 'Europe/Mariehamn',
            label: 'UTC+02:00 (ヨーロッパ/マリーハムン)',
        },
        {
            value: 'Europe/Nicosia',
            label: 'UTC+02:00 (ヨーロッパ/ニコシア)',
        },
        {
            value: 'Europe/Riga',
            label: 'UTC+02:00 (ヨーロッパ/リガ)',
        },
        {
            value: 'Europe/Sofia',
            label: 'UTC+02:00 (ヨーロッパ/ソフィア)',
        },
        {
            value: 'Europe/Tallinn',
            label: 'UTC+02:00 (ヨーロッパ/タリン)',
        },
        {
            value: 'Europe/Tiraspol',
            label: 'UTC+02:00 (ヨーロッパ/ティラスポル)',
        },
        {
            value: 'Europe/Uzhgorod',
            label: 'UTC+02:00 (ヨーロッパ/ウジゴロド)',
        },
        {
            value: 'Europe/Vilnius',
            label: 'UTC+02:00 (ヨーロッパ/ヴィリニュス)',
        },
        {
            value: 'Europe/Zaporozhye',
            label: 'UTC+02:00 (ヨーロッパ/ザポロジエ)',
        },
        {
            value: 'Libya',
            label: 'UTC+02:00 (リビア)',
        },
        {
            value: 'Turkey',
            label: 'UTC+03:00 (トルコ)',
        },
        {
            value: 'Africa/Addis_Ababa',
            label: 'UTC+03:00 (アフリカ/アディスアベバ)',
        },
        {
            value: 'Africa/Asmara',
            label: 'UTC+03:00 (アフリカ/アスマラ (Asmara))',
        },
        {
            value: 'Africa/Asmera',
            label: 'UTC+03:00 (アフリカ/アズメラ (Asmera))',
        },
        {
            value: 'Africa/Dar_es_Salaam',
            label: 'UTC+03:00 (アフリカ/ダルース・サラーム)',
        },
        {
            value: 'Africa/Djibouti',
            label: 'UTC+03:00 (アフリカ/ジブチ)',
        },
        {
            value: 'Africa/Juba',
            label: 'UTC+02:00 (アフリカ/ジュバ)',
        },
        {
            value: 'Africa/Kampala',
            label: 'UTC+03:00 (アフリカ/カンパラ)',
        },
        {
            value: 'Africa/Khartoum',
            label: 'UTC+02:00 (アフリカ/ハルツーム)',
        },
        {
            value: 'Africa/Mogadishu',
            label: 'UTC+03:00 (アフリカ/モガディシュ)',
        },
        {
            value: 'Africa/Nairobi',
            label: 'UTC+03:00 (アフリカ/ナイロビ)',
        },
        {
            value: 'Antarctica/Syowa',
            label: 'UTC+03:00 (南極大陸/昭和基地)',
        },
        {
            value: 'Asia/Aden',
            label: 'UTC+03:00 (アジア/アデン)',
        },
        {
            value: 'Asia/Baghdad',
            label: 'UTC+03:00 (アジア/バグダッド)',
        },
        {
            value: 'Asia/Bahrain',
            label: 'UTC+03:00 (アジア/バーレーン)',
        },
        {
            value: 'Asia/Kuwait',
            label: 'UTC+03:00 (アジア/クウェート)',
        },
        {
            value: 'Asia/Qatar',
            label: 'UTC+03:00 (アジア/カタール)',
        },
        {
            value: 'Asia/Riyadh',
            label: 'UTC+03:00 (アジア/リヤド)',
        },
        {
            value: 'Etc/GMT-3',
            label: 'UTC+03:00 (Etc/GMT-3)',
        },
        {
            value: 'Europe/Kirov',
            label: 'UTC+03:00 (ヨーロッパ/キーロフ)',
        },
        {
            value: 'Europe/Minsk',
            label: 'UTC+03:00 (ヨーロッパ/ミンスク)',
        },
        {
            value: 'Europe/Moscow',
            label: 'UTC+03:00 (ヨーロッパ/モスクワ)',
        },
        {
            value: 'Europe/Simferopol',
            label: 'UTC+03:00 (ヨーロッパ/シンフェロポリ)',
        },
        {
            value: 'Europe/Volgograd',
            label: 'UTC+03:00 (ヨーロッパ/ボルゴグラード)',
        },
        {
            value: 'Indian/Antananarivo',
            label: 'UTC+03:00 (インド洋/アンタナナリボ)',
        },
        {
            value: 'Indian/Comoro',
            label: 'UTC+03:00 (インド洋/コモロ)',
        },
        {
            value: 'Indian/Mayotte',
            label: 'UTC+03:00 (インド洋/マヨット島)',
        },
        {
            value: 'W-SU',
            label: 'UTC+03:00 (W-SU)',
        },
        {
            value: 'Asia/Tehran',
            label: 'UTC+03:30 (アジア/テヘラン)',
        },
        {
            value: 'Iran',
            label: 'UTC+03:30 (イラン)',
        },
        {
            value: 'Asia/Baku',
            label: 'UTC+04:00 (アジア/バクー)',
        },
        {
            value: 'Asia/Dubai',
            label: 'UTC+04:00 (アジア/ドバイ)',
        },
        {
            value: 'Asia/Muscat',
            label: 'UTC+04:00 (アジア/マスカット)',
        },
        {
            value: 'Asia/Tbilisi',
            label: 'UTC+04:00 (アジア/トビリシ)',
        },
        {
            value: 'Asia/Yerevan',
            label: 'UTC+04:00 (アジア/イェレバン)',
        },
        {
            value: 'Europe/Astrakhan',
            label: 'UTC+04:00 (ヨーロッパ/アストラハン)',
        },
        {
            value: 'Etc/GMT-4',
            label: 'UTC+04:00 (Etc/GMT-4)',
        },
        {
            value: 'Europe/Samara',
            label: 'UTC+04:00 (ヨーロッパ/サマラ)',
        },
        {
            value: 'Europe/Saratov',
            label: 'UTC+04:00 (ヨーロッパ/サラトフ)',
        },
        {
            value: 'Europe/Ulyanovsk',
            label: 'UTC+04:00 (ヨーロッパ/ウリヤノフスク)',
        },
        {
            value: 'Indian/Mahe',
            label: 'UTC+04:00 (インド洋/マヘ)',
        },
        {
            value: 'Indian/Mauritius',
            label: 'UTC+04:00 (インド洋/モーリシャス)',
        },
        {
            value: 'Indian/Reunion',
            label: 'UTC+04:00 (インド洋/レユニオン島)',
        },
        {
            value: 'Asia/Kabul',
            label: 'UTC+04:30 (アジア/カブール)',
        },
        {
            value: 'Antarctica/Mawson',
            label: 'UTC+05:00 (南極大陸/モーソン基地)',
        },
        {
            value: 'Asia/Aqtau',
            label: 'UTC+05:00 (アジア/アクタウ)',
        },
        {
            value: 'Asia/Aqtobe',
            label: 'UTC+05:00 (アジア/アクトベ)',
        },
        {
            value: 'Asia/Ashgabat',
            label: 'UTC+05:00 (アジア/アシガバート(Ashgabat))',
        },
        {
            value: 'Asia/Ashkhabad',
            label: 'UTC+05:00 (アジア/アシハバード(Ashkhabad))',
        },
        {
            value: 'Asia/Dushanbe',
            label: 'UTC+05:00 (アジア/ドゥシャンベ)',
        },
        {
            value: 'Asia/Karachi',
            label: 'UTC+05:00 (アジア/カラチ)',
        },
        {
            value: 'Asia/Oral',
            label: 'UTC+05:00 (アジア/オラル)',
        },
        {
            value: 'Asia/Samarkand',
            label: 'UTC+05:00 (アジア/サマルカンド)',
        },
        {
            value: 'Asia/Tashkent',
            label: 'UTC+05:00 (アジア/タシュケント)',
        },
        {
            value: 'Asia/Yekaterinburg',
            label: 'UTC+05:00 (アジア/エカテリンブルク)',
        },
        {
            value: 'Asia/Atyrau',
            label: 'UTC+05:00 (アジア/アティラウ)',
        },
        {
            value: 'Etc/GMT-5',
            label: 'UTC+05:00 (Etc/GMT-5)',
        },
        {
            value: 'Indian/Kerguelen',
            label: 'UTC+05:00 (インド洋/ケルゲレン',
        },
        {
            value: 'Indian/Maldives',
            label: 'UTC+05:00 (インド洋/モルディブ)',
        },
        {
            value: 'Antarctica/Vostok',
            label: 'UTC+05:00 (南極大陸/ボストーク)',
        },
        {
            value: 'Asia/Almaty',
            label: 'UTC+05:00 (アジア/アルマティ)',
        },
        {
            value: 'Asia/Calcutta',
            label: 'UTC+05:30 (アジア/カルカッタ (Calcutta))',
        },
        {
            value: 'Asia/Colombo',
            label: 'UTC+05:30 (アジア/コロンボ)',
        },
        {
            value: 'Asia/Kolkata',
            label: 'UTC+05:30 (アジア/コルカタ (Kolkata))',
        },
        {
            value: 'Asia/Kathmandu',
            label: 'UTC+05:45 (アジア/カトマンズ (Kathmandu))',
        },
        {
            value: 'Asia/Katmandu',
            label: 'UTC+05:45 (アジア/カトマンズ (Katmandu))',
        },
        {
            value: 'Asia/Bishkek',
            label: 'UTC+06:00 (アジア/ビシュケク)',
        },
        {
            value: 'Asia/Dacca',
            label: 'UTC+06:00 (アジア/ダッカ(Dacca))',
        },
        {
            value: 'Asia/Dhaka',
            label: 'UTC+06:00 (アジア/ダッカ(Dhaka))',
        },
        {
            value: 'Asia/Kashgar',
            label: 'UTC+06:00 (アジア/カシュガル)',
        },
        {
            value: 'Asia/Novosibirsk',
            label: 'UTC+07:00 (アジア/ノボシビルスク)',
        },
        {
            value: 'Asia/Omsk',
            label: 'UTC+06:00 (アジア/オムスク)',
        },
        {
            value: 'Asia/Qyzylorda',
            label: 'UTC+05:00 (アジア/クズロルダ)',
        },
        {
            value: 'Asia/Thimbu',
            label: 'UTC+06:00 (アジア/ティンブー)',
        },
        {
            value: 'Asia/Thimphu',
            label: 'UTC+06:00 (アジア/ティンプー)',
        },
        {
            value: 'Asia/Urumqi',
            label: 'UTC+06:00 (アジア/ウルムチ)',
        },
        {
            value: 'Etc/GMT-6',
            label: 'UTC+06:00 (Etc/GMT-6)',
        },
        {
            value: 'Indian/Chagos',
            label: 'UTC+06:00 (インド/チャゴス)',
        },
        {
            value: 'Asia/Rangoon',
            label: 'UTC+06:30 (アジア/ラングーン(Rangoon))',
        },
        {
            value: 'Asia/Yangon',
            label: 'UTC+06:30 (アジア/ヤンゴン(Yangon))',
        },
        {
            value: 'Indian/Cocos',
            label: 'UTC+06:30 (インド洋/ココス諸島)',
        },
        {
            value: 'Antarctica/Davis',
            label: 'UTC+07:00 (南極/デービス)',
        },
        {
            value: 'Asia/Bangkok',
            label: 'UTC+07:00 (アジア/バンコク)',
        },
        {
            value: 'Asia/Barnaul',
            label: 'UTC+07:00 (アジア/バルナウル)',
        },
        {
            value: 'Asia/Ho_Chi_Minh',
            label: 'UTC+07:00 (アジア/ホーチミン)',
        },
        {
            value: 'Asia/Hovd',
            label: 'UTC+07:00 (アジア/ホブド)',
        },
        {
            value: 'Asia/Jakarta',
            label: 'UTC+07:00 (アジア/ジャカルタ)',
        },
        {
            value: 'Asia/Krasnoyarsk',
            label: 'UTC+07:00 (アジア/クラスノヤルスク)',
        },
        {
            value: 'Asia/Nova Kuznetsk',
            label: 'UTC+07:00 (アジア/ノヴァクズネツク)',
        },
        {
            value: 'Asia/Phnom Penh',
            label: 'UTC+07:00 (アジア/プノムペン)',
        },
        {
            value: 'Asia/Pontien',
            label: 'UTC+07:00 (アジア/ポンティアナク)',
        },
        {
            value: 'Asia/Saigon',
            label: 'UTC+07:00 (アジア/サイゴン)',
        },
        {
            value: 'Asia/Tomsk',
            label: 'UTC+07:00 (アジア/トムスク)',
        },
        {
            value: 'Asia/Vientiane',
            label: 'UTC+07:00 (アジア/ビエンチャン)',
        },
        {
            value: 'Etc/GMT-7',
            label: 'UTC+07:00 (Etc/GMT-7)',
        },
        {
            value: 'Indian/Christmas',
            label: 'UTC+07:00 (インド洋/クリスマス)',
        },
        {
            value: 'PRC',
            label: 'UTC+08:00 (中国)',
        },
        {
            value: 'Antarctica/Casey',
            label: 'UTC+08:00 (南極大陸/ケーシー)',
        },
        {
            value: 'Asia/Beijing',
            label: 'UTC+08:00 (アジア/北京)',
        },
        {
            value: 'Asia/Brunei',
            label: 'UTC+08:00 (アジア/ブルネイ)',
        },
        {
            value: 'Asia/Chita',
            label: 'UTC+09:00 (アジア/チタ)',
        },
        {
            value: 'Asia/Choibalsan',
            label: 'UTC+08:00 (アジア/チョイバルサン)',
        },
        {
            value: 'Asia/Chongqing',
            label: 'UTC+08:00 (アジア/重慶市 (Chongqing))',
        },
        {
            value: 'Asia/Chungking',
            label: 'UTC+08:00 (アジア/重慶 (Chungking))',
        },
        {
            value: 'Asia/Harbin',
            label: 'UTC+08:00 (アジア/ハルビン)',
        },
        {
            value: 'Asia/Irkutsk',
            label: 'UTC+08:00 (アジア/イルクーツク)',
        },
        {
            value: 'Asia/Kuala_Lumpur',
            label: 'UTC+08:00 (アジア/クアラ_ルンプール)',
        },
        {
            value: 'Asia/Kuching',
            label: 'UTC+08:00 (アジア/クチン)',
        },
        {
            value: 'Asia/Makassar',
            label: 'UTC+08:00 (アジア/マカッサル)',
        },
        {
            value: 'Asia/Manila',
            label: 'UTC+08:00 (アジア/マニラ)',
        },
        {
            value: 'Asia/Hong_Kong',
            label: 'UTC+08:00 (アジア/香港)',
        },
        {
            value: 'Asia/Macao',
            label: 'UTC+08:00 (アジア/マカオ (Macao))',
        },
        {
            value: 'Asia/Taipei',
            label: 'UTC+08:00 (アジア/台北)',
        },
        {
            value: 'Asia/Shanghai',
            label: 'UTC+08:00 (アジア/上海)',
        },
        {
            value: 'Asia/Singapore',
            label: 'UTC+08:00 (アジア/シンガポール)',
        },
        {
            value: 'Asia/Ujung_Pandang',
            label: 'UTC+08:00 (アジア/ウジュング・パンダン)',
        },
        {
            value: 'Asia/Ulaanbaatar',
            label: 'UTC+08:00 (アジア/ウランバートル (Ulaanbaatar))',
        },
        {
            value: 'Asia/Ulan_Bator',
            label: 'UTC+08:00 (アジア/Ulan_Bator)',
        },
        {
            value: 'Australia/Perth',
            label: 'UTC+08:00 (オーストラリア/パース)',
        },
        {
            value: 'Australia/West',
            label: 'UTC+08:00 (オーストラリア/西)',
        },
        {
            value: 'Etc/GMT-8',
            label: 'UTC+08:00 (Etc/GMT-8)',
        },
        {
            value: 'Singapore',
            label: 'UTC+08:00 (シンガポール)',
        },
        {
            value: 'Australia/Eucla',
            label: 'UTC+08:45 (オーストラリア/ユークラ)',
        },
        {
            value: 'Asia/Dili',
            label: 'UTC+09:00 (アジア/ディリ)',
        },
        {
            value: 'Asia/Jayapura',
            label: 'UTC+09:00 (アジア/ジャヤプラ)',
        },
        {
            value: 'Asia/Khandyga',
            label: 'UTC+09:00 (アジア/カンディガ)',
        },
        {
            value: 'Asia/Pyongyang',
            label: 'UTC+09:00 (アジア/平壌)',
        },
        {
            value: 'Asia/Seoul',
            label: 'UTC+09:00 (アジア/ソウル)',
        },
        {
            value: 'Asia/Tokyo',
            label: 'UTC+09:00 (アジア/東京)',
        },
        {
            value: 'Asia/Yakutsk',
            label: 'UTC+09:00 (Asia/Yakutsk)',
        },
        {
            value: 'Etc/GMT-9',
            label: 'UTC+09:00 (Etc/GMT-9)',
        },
        {
            value: 'Japan',
            label: 'UTC+09:00 (日本)',
        },
        {
            value: 'Pacific/Palau',
            label: 'UTC+09:00 (太平洋/パラオ)',
        },
        {
            value: 'ROK',
            label: 'UTC+09:00 (韓国)',
        },
        {
            value: 'Australia/Darwin',
            label: 'UTC+09:30 (オーストラリア/ダーウィン)',
        },
        {
            value: 'Australia/North',
            label: 'UTC+09:30 (オーストラリア/北)',
        },
        {
            value: 'Australia/Adelaide',
            label: 'UTC+09:30 (オーストラリア/アデレード)',
        },
        {
            value: 'Australia/Broken_Hill',
            label: 'UTC+09:30 (オーストラリア/ブロークン・ヒル)',
        },
        {
            value: 'Australia/South',
            label: 'UTC+09:30 (オーストラリア/南部)',
        },
        {
            value: 'Australia/Yancowinna',
            label: 'UTC+09:30 (オーストラリア/ヤンコウィナ)',
        },
        {
            value: 'Antarctica/DumontDUrville',
            label: 'UTC+10:00 (南極大陸/デュモン・デュルヴィル)',
        },
        {
            value: 'Asia/Magadan',
            label: 'UTC+11:00 (アジア/マガダン)',
        },
        {
            value: 'Asia/Sakhalin',
            label: 'UTC+11:00 (アジア/サハリン)',
        },
        {
            value: 'Asia/Ust-Nera',
            label: 'UTC+10:00 (アジア/ウストネラ)',
        },
        {
            value: 'Asia/Vladivostok',
            label: 'UTC+10:00 (アジア/ウラジオストク)',
        },
        {
            value: 'Australia/Brisbane',
            label: 'UTC+10:00 (オーストラリア/ブリスベン)',
        },
        {
            value: 'Australia/Lindeman',
            label: 'UTC+10:00 (オーストラリア/リンドマン)',
        },
        {
            value: 'Australia/Queensland',
            label: 'UTC+10:00 (オーストラリア/クイーンズランド)',
        },
        {
            value: 'Australia/ACT',
            label: 'UTC+10:00 (オーストラリア/ACT)',
        },
        {
            value: 'Australia/Canberra',
            label: 'UTC+10:00 (オーストラリア/キャンベラ)',
        },
        {
            value: 'Australia/Currie',
            label: 'UTC+10:00 (オーストラリア/カリー)',
        },
        {
            value: 'Australia/Melbourne',
            label: 'UTC+10:00 (オーストラリア/メルボルン)',
        },
        {
            value: 'Australia/NSW',
            label: 'UTC+10:00 (アウストラリアー/NSW)',
        },
        {
            value: 'Australia/Sydney',
            label: 'UTC+10:00 (オーストラリア/シドニー)',
        },
        {
            value: 'Australia/Tasmania',
            label: 'UTC+10:00 (オーストラリア/タスマニア)',
        },
        {
            value: 'Australia/Victoria',
            label: 'UTC+10:00 (オーストラリア/ビクトリア)',
        },
        {
            value: 'Australia/Hobart',
            label: 'UTC+10:00 (オーストラリア/ホバート)',
        },
        {
            value: 'Etc/GMT-10',
            label: 'UTC+10:00 (Etc/GMT-10)',
        },
        {
            value: 'Pacific/Chuuk',
            label: 'UTC+10:00 (太平洋/チューク)',
        },
        {
            value: 'Pacific/Guam',
            label: 'UTC+10:00 (太平洋/グアム島)',
        },
        {
            value: 'Pacific/Port_Moresby',
            label: 'UTC+10:00 (太平洋/ポートモレスビー)',
        },
        {
            value: 'Pacific/Saipan',
            label: 'UTC+10:00 (太平洋/サイパン)',
        },
        {
            value: 'Pacific/Truk',
            label: 'UTC+10:00 (太平洋/トルク)',
        },
        {
            value: 'Pacific/Yap',
            label: 'UTC+10:00 (太平洋/ヤップ)',
        },
        {
            value: 'Australia/LHI',
            label: 'UTC+10:30 (オーストラリア/LHI)',
        },
        {
            value: 'Australia/Lord_Howe',
            label: 'UTC+10:30 (オーストラリア/ロードハウ島 (Lord_Howe))',
        },
        {
            value: 'Antarctica/Macquarie',
            label: 'UTC+10:00 (南極大陸/マッコーリー島)',
        },
        {
            value: 'Asia/Srednekolymsk',
            label: 'UTC+11:00 (アジア/スレドネコリムスク)',
        },
        {
            value: 'Etc/GMT-11',
            label: 'UTC+11:00 (Etc/GMT-11)',
        },
        {
            value: 'Pacific/Bougainville',
            label: 'UTC+11:00 (太平洋/ブーゲンビル島)',
        },
        {
            value: 'Pacific/Efate',
            label: 'UTC+11:00 (太平洋/エファテ島)',
        },
        {
            value: 'Pacific/Guadalcanal',
            label: 'UTC+11:00 (太平洋/ガダルカナル島)',
        },
        {
            value: 'Pacific/Kosrae',
            label: 'UTC+11:00 (太平洋/コスラエ)',
        },
        {
            value: 'Pacific/Noumea',
            label: 'UTC+11:00 (太平洋/ヌメア)',
        },
        {
            value: 'Pacific/Pohnpei',
            label: 'UTC+11:00 (太平洋/ポンペイ(Pohnpei))',
        },
        {
            value: 'Pacific/Ponape',
            label: 'UTC+11:00 (太平洋/ポナペ(Ponape))',
        },
        {
            value: 'Pacific/Norfolk',
            label: 'UTC+11:00 (太平洋/ノーフォーク)',
        },
        {
            value: 'Asia/Anadyr',
            label: 'UTC+12:00 (アジア/アナディル)',
        },
        {
            value: 'Asia/Kamchatka',
            label: 'UTC+12:00 (アジア/カムチャッカ)',
        },
        {
            value: 'Etc/GMT-12',
            label: 'UTC+12:00 (Etc/GMT-12)',
        },
        {
            value: 'Kwajalein',
            label: 'UTC+12:00 (クワジャリン)',
        },
        {
            value: 'Pacific/Fiji',
            label: 'UTC+12:00 (太平洋/フィジー)',
        },
        {
            value: 'Pacific/Funafuti',
            label: 'UTC+12:00 (太平洋/フナフティ)',
        },
        {
            value: 'Pacific/Kwajalein',
            label: 'UTC+12:00 (太平洋/クワジャリン)',
        },
        {
            value: 'Pacific/Majuro',
            label: 'UTC+12:00 (太平洋/マジュロ)',
        },
        {
            value: 'Pacific/Nauru',
            label: 'UTC+12:00 (太平洋/ナウル)',
        },
        {
            value: 'Pacific/Tarawa',
            label: 'UTC+12:00 (太平洋/タラワ)',
        },
        {
            value: 'Pacific/Wake',
            label: 'UTC+12:00 (太平洋/ウェイク)',
        },
        {
            value: 'Pacific/Wallis',
            label: 'UTC+12:00 (太平洋/ウォリス)',
        },
        {
            value: 'Pacific/Auckland',
            label: 'UTC+12:00 (太平洋/オークランド)',
        },
        {
            value: 'Antarctica/McMurdo',
            label: 'UTC+12:00 (南極大陸/マクマード)',
        },
        {
            value: 'Antarctica/South_Pole',
            label: 'UTC+12:00 (南極大陸/南極点)',
        },
        {
            value: 'NZ',
            label: 'UTC+12:00 (ニュージーランド)',
        },
        {
            value: 'Pacific/Chatham',
            label: 'UTC+12:45 (太平洋/チャタム)',
        },
        {
            value: 'NZ-CHAT',
            label: 'UTC+12:45 (NZ-CHAT)',
        },
        {
            value: 'Etc/GMT-13',
            label: 'UTC+13:00 (Etc/GMT-13)',
        },
        {
            value: 'Pacific/Enderbury',
            label: 'UTC+13:00 (太平洋/エンダーベリー)',
        },
        {
            value: 'Pacific/Fakaofo',
            label: 'UTC+13:00 (太平洋/ファカオフォ)',
        },
        {
            value: 'Pacific/Tongatapu',
            label: 'UTC+13:00 (太平洋/トンガタプ)',
        },
        {
            value: 'Pacific/Apia',
            label: 'UTC+13:00 (太平洋/アピア)',
        },
        {
            value: 'Etc/GMT-14',
            label: 'UTC+14:00 (Etc/GMT-14)',
        },
        {
            value: 'Pacific/Kiritimati',
            label: 'UTC+14:00 (太平洋/キリティマティ)',
        },
    ],
};
